const messages = {
  it: {
    translations: {
       seller_queue: {
        modal: {
          sale_outcome: {
            completed: 'Vendita Completata',
            not_completed: 'Vendita Non Completata',
          },
          reasons: {
            label: 'Motivo della Non Vendita:',
            loading: 'Caricamento motivi...',
            load_error: 'Impossibile caricare i motivi. Riprova.',
            retry: 'Riprova',
            placeholder: 'Seleziona un motivo...',
          },
          buttons: {
            cancel: 'Annulla',
            next: 'Avanti →',
          },
        },
        "seller_queue":"Fila Venditore",
        "queue_status":"Stato della Fila",
        "queue_position":"Posizione nella Fila",
        "queue_duration":"Durata",
        "queue_seller_status":"Stato del Venditore",
        "queue_in_service":"In Servizio",
        "queue_not_in_service":"NNon in Servizio",
        "queue_no_entry":"Non sei nella fila",
        "queue_loading":"Caricamento...",
        "queue_error":"Errore: {{error}}",
        "queue_view_details":"Visualizza Dettagli",
        "reason":"Motivo",
      },
      gridHotelFeedback: {
        dashboard: 'Dashboard',
        service_grid: 'Griglie di Sondaggio e Soddisfazione',
        service_grid_single: 'Griglia di Sondaggio e Soddisfazione',
        listed_grids: 'Le Griglie di Sondaggio e Soddisfazione sono elencate di seguito',
        create_service_grid: 'Crea Griglia di Sondaggio e Soddisfazione',
        title: 'Titolo',
        status: 'Stato',
        grid_deleted: 'Griglia Eliminata!',
        grid_deleted_message:
          'La Griglia di Sondaggio e Soddisfazione è stata eliminata con successo.',
        error: 'Errore',
        error_delete_message:
          "Si è verificato un errore durante l'eliminazione della Griglia di Sondaggio e Soddisfazione.",
        service_grid_name: 'Titolo',
        service_grid_name_placeholder: 'Es.: Sondaggio di Soddisfazione',
        fill_information_create:
          'Compila le informazioni seguenti e clicca sul pulsante "Crea" per salvare le modifiche',
        missing_fields: 'Campi obbligatori',
        missing_fields_message: 'Il campo "Titolo" e la "Lista degli Elementi" sono obbligatori!',
        grid_created: 'Griglia registrata',
        grid_created_message: 'Registrazione completata con successo!',
        error_create_message: 'Errore durante la registrazione della griglia!',
        service_list: 'Lista degli Elementi',
        service_placeholder: 'Aggiungi un elemento (Es.: Qualità della Camera)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Modifica Griglia di Sondaggio e Soddisfazione',
        save_changes_edit:
          'Compila le informazioni seguenti e clicca sul pulsante "Salva" per confermare le modifiche',
        grid_updated: 'Griglia modificata',
        grid_updated_message: 'Modifica completata con successo!',
        error_update_message: 'Errore durante la modifica della griglia!',

        general: {
          actions: 'Azioni',
          edit: 'Modifica',
          delete: 'Elimina',
          active: 'Attivo',
          inactive: 'Inattivo',
          select: 'Seleziona',
          back: 'Indietro',
        },
        buttons: {
          create: 'Crea',
          back: 'Indietro',
          save: 'Salva',
        },
      },
      // Traduzioni per la pagina di gestione delle lingue dei negozi
      translate_stores: {
        page_title: 'Gestione delle lingue e delle relazioni tra Negozi',
        page_subtitle:
          'Gestisci le lingue di traduzione e le relazioni di ogni negozio del sistema.',
        page_title_relationships: 'Gestione delle Relazioni tra Negozi',
        page_subtitle_relationships: 'Gestisci le relazioni tra i negozi del sistema.',
        tab_translations: 'Gestisci Lingue',
        tab_relations: 'Relazioni tra Negozi',
        breadcrumb: {
          dashboard: 'Dashboard',
          translate_stores: 'Gestisci Lingue',
        },
        filters: {
          status: 'Stato',
          type: 'Tipo',
          active: 'Attivo',
          inactive: 'Inattivo',
          both: 'Entrambi',
          all_types: 'Tutti',
          status_placeholder: 'Stato del Negozio',
          type_placeholder: 'Tipo del Negozio',
          filter_button: 'Filtra',
        },
        status_options: {
          active: 'Attivo',
          inactive: 'Inattivo',
          both: 'Entrambi',
          all_types: 'Tutti',
        },
        languages: {
          portuguese: 'Portoghese',
          spanish: 'Spagnolo',
          english: 'Inglese',
          french: 'Francese',
          german: 'Tedesco',
          italian: 'Italiano',
          japanese: 'Giapponese',
          korean: 'Coreano',
          chinese: 'Mandarino',
        },
        table: {
          headers: {
            type: 'Tipo',
            id: 'ID',
            name: 'Nome',
            subdomain: 'Sottodominio',
            status: 'Stato',
            created: 'Creato il',
            cnpj: 'CNPJ',
            actions: 'Azioni',
          },
          type: 'Tipo',
          id: 'ID',
          name: 'Nome',
          subdomain: 'Sottodominio',
          status: {
            active: 'Attivo',
            inactive: 'Inattivo',
          },
          created: 'Creato il',
          cnpj: 'CNPJ',
          actions: 'Azioni',
        },
        actions: {
          manage_languages: 'Gestisci Lingue',
          edit: 'Modifica',
        },
        messages: {
          success: {
            title: 'Successo',
            save: 'Lingue salvate con successo!',
          },
          error: {
            title: 'Errore',
            load_data: 'Errore nel caricare i dati dei negozi!',
            save_languages: 'Errore nel salvare le lingue!',
          },
        },
        modal: {
          title: 'Gestisci Lingue',
          description:
            'Seleziona le lingue che saranno disponibili per la traduzione in questo negozio:',
          alert: {
            title: 'Attenzione',
            message:
              'Attiva o disattiva le lingue che dovranno essere utilizzate per la traduzione in questo negozio.',
          },
          buttons: {
            cancel: 'Annulla',
            save: 'Salva',
          },
        },
        relations: {
          no_relations: 'Nessuna relazione trovata',
          create_title: 'Crea Relazione',
          edit_title: 'Modifica Relazione',
          parent_label: 'Negozio Padre',
          child_label: 'Negozio Figlio',
          parent_missing: 'Seleziona il negozio padre',
          child_missing: 'Seleziona il negozio figlio',
          same_store_error: 'Il negozio padre non può essere uguale al negozio figlio',
          created_success: 'Relazione creata con successo',
          updated_success: 'Relazione aggiornata con successo',
          deleted_success: 'Relazione eliminata con successo',
          error_create: 'Errore nella creazione della relazione',
          error_update: "Errore nell'aggiornamento della relazione",
          error_delete: "Errore nell'eliminazione della relazione",
          store_not_found: 'Negozio non trovato',
          all_option: 'Tutti',
          cancel: 'Annulla',
          save: 'Salva',
          delete_confirm: 'Sì, elimina',
          create_button: 'Crea Relazione',
          save_changes: 'Salva Modifiche',
          create_description:
            'Definisci quale negozio sarà il negozio padre e quale sarà il negozio figlio. Un negozio padre può avere più negozi figli e gestirne le configurazioni.',
          edit_description:
            'Modifica la relazione tra i negozi selezionati. Le modifiche saranno applicate immediatamente.',
          summary_title: 'Riepilogo della relazione:',
          tips_title: 'Consigli importanti:',
          tip_parent_multiple: 'Un negozio padre può avere più negozi figli',
          tip_child_single: 'Un negozio figlio può avere più padri',
          tip_all_available: 'Tutti i negozi (attivi e inattivi) sono disponibili per la selezione',
          click_new: 'Clicca su "Nuova Relazione" per iniziare',
          message_delete:
            'Sei sicuro di voler eliminare questa relazione? Questa azione non può essere annullata.',
        },
      },
      hospitality_review: {
        page_title: "Recensioni dell'Hotel",
        page_subtitle:
          "Gestisci e monitora le recensioni e le valutazioni degli ospiti dell'hotel.",
        breadcrumb: {
          dashboard: 'Dashboard',
          hospitality: 'Ospitalità',
          reviews: 'Recensioni',
        },
        statistics: {
          total_reviews: 'Totale Recensioni',
          average_rating: 'Media Generale',
        },
        filters: {
          filter_by_type: 'Filtra per Tipo',
          filter_by_rating: 'Filtra per Valutazione',
        },
        type_options: {
          all_types: 'Tutti',
          general: 'Generale',
          room: 'Camera',
          food: 'Cibo',
          service: 'Servizio',
          cleanliness: 'Pulizia',
          activities: 'Attività',
        },
        rating_options: {
          all_ratings: 'Tutte le valutazioni',
          five_stars: '5 stelle',
          four_stars: '4 stelle',
          three_stars: '3 stelle',
          two_stars: '2 stelle',
          one_star: '1 stella',
        },
        table: {
          headers: {
            rating: 'Valutazione',
            type: 'Tipo',
            comment: 'Commento',
            date: 'Data',
            actions: 'Azioni',
          },
          actions: {
            view_full_review: 'Visualizza recensione completa',
          },
          status: {
            approved: 'Approvata',
            pending: 'In sospeso',
          },
        },
        modal: {
          review_title: 'Recensione di',
          fields: {
            rating: 'Valutazione',
            type: 'Tipo',
            status: 'Stato',
            date: 'Data',
            comment: 'Commento',
            email: 'Email',
          },
          guest_anonymous: 'Anonimo',
        },
        messages: {
          success: {
            review_deleted: 'Recensione eliminata',
            delete_success: 'Eliminazione eseguita con successo!',
            status_updated: 'Stato aggiornato',
            approved_success: 'Recensione approvata con successo!',
            suspended_success: 'Recensione sospesa con successo!',
          },
          error: {
            title: 'Errore',
            load_reviews: "Errore nel caricare le recensioni dell'hotel!",
            invalid_id: "ID non valido per l'eliminazione!",
            delete_error: "Errore nell'eliminare la recensione!",
            status_error: 'Errore nel cambiare lo stato della recensione!',
          },
          confirm: {
            delete_title: 'Conferma eliminazione',
            delete_text: 'Sei sicuro di voler eliminare questa recensione?',
            delete_confirm: 'Sì, elimina',
            delete_cancel: 'Annulla',
          },
        },
      },
      hospitality_info: {
        page_title: "Informazioni sull'Hotel",
        page_subtitle: "Gestisci contatto, orari e servizi dell'hotel.",
        tabs: {
          contact: 'Contatto',
          hours: 'Orari e Informazioni',
          services: 'Servizi',
          ramal: 'Interno',
          about: 'Chi siamo',
        },
        contact: {
          phone_label: 'Telefono',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: "Orari e Informazioni dell'Hotel",
          add_button: 'Aggiungi Orario/Informazione',
          remove_button: 'Rimuovi',
          hour_number: 'Elemento',
          title_label: 'Titolo',
          title_placeholder: 'Es.: Reception, Piscina, Ristorante',
          description_label: 'Orari e Informazioni',
          description_placeholder:
            'Descrivi gli orari di apertura e informazioni aggiuntive (Es.: 08:00 - 22:00, chiuso nei fine settimana)',
        },
        services: {
          title: "Servizi dell'Hotel",
          add_button: 'Aggiungi Servizio',
          remove_button: 'Rimuovi',
          service_number: 'Servizio',
          service_title_label: 'Titolo del Servizio',
          service_title_placeholder: 'Es.: Room Service',
          service_description_label: 'Descrizione',
          service_description_placeholder: 'Descrivi il servizio',
        },
        ramal: {
          title: "Interni dell'Hotel",
          add_button: 'Aggiungi Interno',
          remove_button: 'Rimuovi',
          ramal_number: 'Interno',
          ramal_title_label: "Titolo dell'Interno",
          ramal_title_placeholder: 'Es.: 504',
          ramal_description_label: 'Descrizione',
          ramal_description_placeholder: "Descrivi l'interno",
        },
        about: {
          description_label: "Informazioni sull'Hotel",
          description_placeholder:
            "Descrivi informazioni generali sull'hotel, storia, caratteristiche uniche e speciali",
        },
        actions: {
          save_button: 'Salva',
        },
        messages: {
          error_title: 'Errore',
          error_text: "Non è stato possibile salvare le informazioni dell'hotel.",
          success_title: 'Salvato!',
          success_text: "Informazioni dell'hotel salvate con successo.",
          required_phone: 'Il telefono è obbligatorio.',
          required_email: "L'e-mail è obbligatoria.",
          required_hours: 'Tutti gli elementi devono avere titolo e descrizione.',
          required_service: 'Tutti i servizi devono avere titolo e descrizione.',
          required_ramal: 'Tutti gli interni devono avere titolo e descrizione.',
        },
      },
      hospitality_schedules: {
        page_title: "Programmazione dell'Hotel",
        page_subtitle: "Gestisci eventi e programmazioni dell'hotel.",
        new_button: 'Nuova Programmazione',
        edit_button: 'Modifica Programmazione',
        delete_button: 'Elimina Programmazione',
        delete_confirm:
          'Sei sicuro di voler eliminare questa programmazione? Questa azione non può essere annullata.',
        table: {
          title: 'Titolo',
          type: 'Tipo',
          location: 'Località',
          time: 'Orario',
          recurrence: 'Ricorrenza',
          period: 'Periodo',
          status: 'Stato',
          actions: 'Azioni',
          active: 'Attivo',
          inactive: 'Inattivo',
          single_event: 'Evento unico',
          all_types: 'Tutti',
          all_status: 'Tutti gli stati',
          age_group: 'Gruppo di età',
        },
        filters: {
          type: 'Tipo',
          type_placeholder: 'Seleziona il tipo',
          status: 'Stato',
          status_placeholder: 'Seleziona lo stato',
          date_init: 'Data Iniziale',
          date_init_placeholder: 'Data iniziale',
          date_end: 'Data Finale',
          date_end_placeholder: 'Data finale',
          search: 'Cerca',
          clear: 'Pulisci Filtri',
        },
        messages: {
          load_error: 'Errore nel caricare le programmazioni!',
          delete_success: 'Programmazione eliminata con successo!',
          delete_error: "Errore nell'eliminare la programmazione!",
        },
        types: {
          activity: 'Intrattenimento',
          food: 'Gastronomia',
          event: 'Evento',
          tour: 'Gita',
        },
        age_groups: {
          all: 'Tutti',
          children: 'Bambini',
          teens: 'Adolescenti',
          adults: 'Adulti',
          seniors: 'Anziani',
          family: 'Famiglia',
        },
        singleEvent: 'Evento Unico',
      },
      hospitality_schedule_edit: {
        page_title: 'Modifica Programmazione',
        page_subtitle: 'Modifica: {{title}}',
        not_found: {
          title: 'Programmazione non trovata',
          description: 'La programmazione che stai cercando di modificare non è stata trovata.',
          back_button: "Torna all'Elenco",
        },
        form: {
          type_label: 'Tipo',
          type_placeholder: 'Seleziona il tipo',
          type_sports: 'Sport',
          type_wellness: 'Benessere',
          type_other: 'Altro',
          title_label: 'Titolo',
          title_placeholder: 'Inserisci il titolo della programmazione',
          description_label: 'Descrizione',
          description_placeholder: 'Descrivi la programmazione',
          location_label: 'Località',
          location_placeholder: 'Località della programmazione',
          time_label: 'Orario',
          time_placeholder: 'Es: 14:00 - 16:00 o 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" o "HH:MM"',
          recurrence_config: 'Configurazione di Ricorrenza',
          single_event_radio: 'Evento Unico - Evento che si svolge in date specifiche',
          recurring_event_radio:
            'Evento Ricorrente - Evento che si ripete in giorni specifici della settimana',
          day_within_date_range_radio:
            "Evento all'interno di un Intervallo di Date - Evento che si verifica all'interno di un intervallo di date specifico",
          days_of_week_label: 'Giorni della Settimana',
          selected_days: 'Selezionati: {{days}}',
          date_init_label: 'Data Iniziale',
          date_init_placeholder: 'Data di inizio',
          date_end_label: 'Data Finale',
          date_end_placeholder: 'Data di fine (opzionale)',
          status_label: 'Stato',
          back_button: 'Indietro',
          save_button: 'Salva Modifiche',
        },
      },
      hospitality_schedule_create: {
        page_title: 'Nuova Programmazione',
        page_subtitle: "Crea una nuova programmazione per l'hotel",
        success: {
          title: 'Successo!',
          text: 'Programmazione creata con successo!',
        },
        error: {
          title: 'Errore',
          text: 'Errore nella creazione della programmazione!',
        },
        form: {
          title_label: 'Titolo *',
          title_placeholder: 'Inserisci il titolo della programmazione',
          title_required: 'Il titolo è obbligatorio',
          type_label: 'Tipo *',
          type_placeholder: 'Seleziona il tipo',
          type_sports: 'Sport',
          type_wellness: 'Benessere',
          type_other: 'Altri',
          description_label: 'Descrizione *',
          description_placeholder: 'Descrivi la programmazione',
          description_required: 'La descrizione è obbligatoria',
          location_label: 'Località *',
          location_placeholder: 'Località della programmazione',
          location_required: 'La località è obbligatoria',
          time_label: 'Orario *',
          time_placeholder: 'Es: 14:00 - 16:00 o 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" o "HH:MM"',
          time_required: "L'orario è obbligatorio",
          recurrence_config: 'Configurazione di Ricorrenza',
          single_event_radio: 'Evento Unico - Evento che si svolge in date specifiche',
          recurring_event_radio:
            'Evento Ricorrente - Evento che si ripete in giorni specifici della settimana',
          day_within_date_range_radio:
            "Evento all'interno di un Intervallo di Date - Evento che si verifica all'interno di un intervallo di date specifico",
          days_of_week_label: 'Giorni della Settimana',
          selected_days: 'Selezionati: {{days}}',
          date_init_label: 'Data Iniziale',
          date_init_placeholder: 'Data di inizio',
          date_end_label: 'Data Finale',
          date_end_placeholder: 'Data di fine (opzionale)',
          status_label: 'Stato',
          back_button: 'Indietro',
          save_button: 'Salva',
        },
      },
      hospitality_banner: {
        page_title: "Banner dell'Hotel",
        page_subtitle:
          "Gestisci i banner del tuo hotel. Controlla il periodo di visualizzazione, l'ordine e lo stato.",
        breadcrumb: {
          hospitality: 'Ospitalità',
          publicity: 'Pubblicità',
        },
        new_button: 'Nuova Pubblicità',
        table: {
          title: 'Titolo',
          image: 'Immagine',
          order: 'Ordine',
          period: 'Periodo',
          created_date: 'Data di Creazione',
          status: 'Stato',
          actions: 'Azioni',
        },
        actions: {
          edit: 'Modifica pubblicità',
          view: 'Visualizza dettagli',
          delete: 'Elimina pubblicità',
        },
        modal: {
          title: 'Pubblicità #{{id}}',
          order: 'Ordine',
          status: 'Stato',
          active: 'Attiva',
          inactive: 'Inattiva',
          period: 'Periodo',
          created: 'Creato il',
          updated: 'Ultimo aggiornamento',
          image: 'Immagine',
          no_image: 'Nessuna immagine',
        },
        delete: {
          confirm_title: 'Conferma eliminazione',
          confirm_text: 'Sei sicuro di voler eliminare questa pubblicità?',
          confirm_button: 'Sì, elimina',
          cancel_button: 'Annulla',
          success_title: 'Pubblicità eliminata',
          success_text: 'Eliminazione eseguita con successo!',
        },
        status: {
          success_title: 'Stato aggiornato',
          success_text: 'Pubblicità {{action}} con successo!',
          activated: 'attivata',
          deactivated: 'disattivata',
        },
        error: {
          title: 'Errore',
          load_data: 'Errore nel caricare i dati della pubblicità!',
          invalid_id: "ID non valido per l'eliminazione!",
          delete: "Errore nell'eliminare la pubblicità!",
          status_change: 'Errore nel cambiare lo stato della pubblicità!',
        },
      },
      hospitality_banner_create: {
        page_title: "Crea un nuovo Banner dell'Hotel",
        page_subtitle: 'Compila le informazioni sottostanti per creare un nuovo banner.',
        breadcrumb: {
          hospitality: 'Ospitalità',
          publicity: 'Pubblicità',
          create: 'Crea Pubblicità',
        },
        form: {
          title_label: 'Titolo del Banner *',
          title_placeholder: 'Es: Escursioni...',
          order_label: 'Ordine di Visualizzazione *',
          order_placeholder: 'Es: 1, 2, 3...',
          order_smalltext:
            'Ordine di priorità della pubblicità (i numeri più bassi appaiono per primi)',
          status_label: 'Pubblicità Attiva',
          status_smalltext: 'Spunta per attivare la pubblicità',
          start_date_label: 'Data di Inizio *',
          start_time_label: 'Ora di Inizio *',
          end_date_label: 'Data di Fine *',
          end_time_label: 'Ora di Fine *',
          image_label: 'Immagine della Pubblicità',
          image_select: "Seleziona un'immagine",
          image_formats: 'Formati accettati: JPG, PNG, GIF',
          image_optional: "Opzionale - Verrà utilizzata un'immagine predefinita se non fornita",
          image_preview: 'Anteprima Immagine',
          image_remove: 'Rimuovi Immagine',
        },
        preview: {
          period_title: 'Periodo della Pubblicità:',
          start: 'Inizio',
          end: 'Fine',
        },
        validation: {
          title: 'Errore di validazione',
          order_positive: "L'ordine deve essere un numero maggiore di zero!",
          start_date_required: 'La data di inizio è obbligatoria!',
          end_date_required: 'La data di fine è obbligatoria!',
          dates_required: 'Date e orari sono obbligatori!',
          start_before_end: 'La data di inizio deve essere precedente alla data di fine!',
        },
        success: {
          title: 'Pubblicità creata',
          text: 'Pubblicità creata con successo!',
        },
        error: {
          title: 'Errore',
          text: 'Errore nella creazione della pubblicità!',
        },
      },
      hospitality_banner_update: {
        page_title: "Modifica Pubblicità dell'Hotel",
        page_subtitle: 'Modifica pubblicità #{{id}}',
        breadcrumb: {
          edit: 'Modifica Pubblicità',
        },
        current_image: 'Immagine Attuale',
        save_button: 'Salva Modifiche',
        not_found: {
          title: 'Pubblicità non trovata',
          text: 'La pubblicità che stai cercando di modificare non è stata trovata.',
          back_button: "Torna all'Elenco",
        },
        no_changes: {
          title: 'Nessuna modifica',
          text: 'Nessun campo è stato modificato!',
        },
        success: {
          title: 'Pubblicità aggiornata',
          text: 'Pubblicità aggiornata con successo!',
        },
        error: {
          title: 'Errore',
          text: "Errore nell'aggiornare la pubblicità",
          load_data: 'Errore nel caricare i dati della pubblicità!',
          update: "Errore nell'aggiornare la pubblicità!",
        },
      },
      hospitality_publicity: {
        page_title: "Banner in Evidenza dell'Hotel",
        page_subtitle:
          "Gestisci i banner in evidenza del tuo hotel. Controlla il periodo di visualizzazione, l'ordine e lo stato.",
        breadcrumb: {
          hospitality: 'Ospitalità',
          publicity: 'Pubblicità',
        },
        new_button: 'Nuovo Banner',
        table: {
          image: 'Immagine',
          order: 'Ordine',
          period: 'Periodo',
          created_date: 'Data di Creazione',
          status: 'Stato',
          actions: 'Azioni',
        },
        actions: {
          edit: 'Modifica pubblicità',
          view: 'Visualizza dettagli',
          delete: 'Elimina pubblicità',
        },
        modal: {
          title: 'Pubblicità #{{id}}',
          order: 'Ordine',
          status: 'Stato',
          active: 'Attiva',
          inactive: 'Inattiva',
          period: 'Periodo',
          created: 'Creato il',
          updated: 'Ultimo aggiornamento',
          image: 'Immagine',
          no_image: 'Nessuna immagine',
        },
        delete: {
          confirm_title: 'Conferma eliminazione',
          confirm_text: 'Sei sicuro di voler eliminare questa pubblicità?',
          confirm_button: 'Sì, elimina',
          cancel_button: 'Annulla',
          success_title: 'Pubblicità eliminata',
          success_text: 'Eliminazione eseguita con successo!',
        },
        status: {
          success_title: 'Stato aggiornato',
          success_text: 'Pubblicità {{action}} con successo!',
          activated: 'attivata',
          deactivated: 'disattivata',
        },
        error: {
          title: 'Errore',
          load_data: 'Errore nel caricare i dati della pubblicità!',
          invalid_id: "ID non valido per l'eliminazione!",
          delete: "Errore nell'eliminare la pubblicità!",
          status_change: 'Errore nel cambiare lo stato della pubblicità!',
        },
      },
      hospitality_publicity_create: {
        page_title: "Crea Pubblicità dell'Hotel",
        page_title_edit: "Modifica Pubblicità dell'Hotel",
        page_subtitle: 'Compila le informazioni sottostanti per creare una nuova pubblicità.',
        breadcrumb: {
          hospitality: 'Ospitalità',
          publicity: 'Pubblicità',
          create: 'Crea Pubblicità',
        },
        form: {
          order_label: 'Ordine di Visualizzazione *',
          order_placeholder: 'Es: 1, 2, 3...',
          order_smalltext:
            'Ordine di priorità della pubblicità (i numeri più bassi appaiono per primi)',
          status_label: 'Pubblicità Attiva',
          status_smalltext: 'Spunta per attivare la pubblicità',
          start_date_label: 'Data di Inizio *',
          start_time_label: 'Ora di Inizio *',
          end_date_label: 'Data di Fine *',
          end_time_label: 'Ora di Fine *',
          image_label: 'Immagine della Pubblicità',
          image_select: "Seleziona un'immagine",
          image_formats:
            'Formati accettati: JPG, PNG, GIF | Dimensioni: ~200x112px | Dimensione max: 2MB',
          image_optional: "Opzionale - Verrà utilizzata un'immagine predefinita se non fornita",
          image_preview: 'Anteprima Immagine',
          image_remove: 'Rimuovi Immagine',
          external_link_checkbox: 'Includi Link Esterno',
          external_link_label: 'Link Esterno',
          external_link_placeholder: 'https://example.com',
          description_label: 'Descrizione del Banner',
          description_smalltext: '* Massimo {qtd} caratteri',
          title_label: 'Titolo del Banner',
          title_placeholder: 'Esempio: Escursioni...',
          title_smalltext: '* Massimo {qtd} caratteri',
        },
        preview: {
          period_title: 'Periodo della Pubblicità:',
          start: 'Inizio',
          end: 'Fine',
        },
        validation: {
          title: 'Errore di validazione',
          order_positive: "L'ordine deve essere un numero maggiore di zero!",
          start_date_required: 'La data di inizio è obbligatoria!',
          end_date_required: 'La data di fine è obbligatoria!',
          dates_required: 'Date e orari sono obbligatori!',
          start_before_end: 'La data di inizio deve essere precedente alla data di fine!',
          external_link_required: "Il link esterno è obbligatorio quando l'opzione è selezionata!",
          image_size_error: "L'immagine deve avere una dimensione massima di 2MB!",
          image_dimensions_error:
            "Le dimensioni dell'immagine devono essere circa 200x112 pixel! Attuale: {{current}}",
          image_invalid: "File immagine non valido! Seleziona un'immagine valida.",
        },
        success: {
          title: 'Pubblicità creata',
          text: 'Pubblicità creata con successo!',
        },
        error: {
          title: 'Errore',
          text: 'Errore nella creazione della pubblicità!',
          update: "Errore nell'aggiornare la pubblicità!",
        },
        not_found: {
          title: 'Pubblicità non trovata',
          text: 'La pubblicità che stai cercando di modificare non è stata trovata.',
          back_button: "Torna all'elenco",
        },
        no_changes: {
          title: 'Nessuna modifica',
          text: 'Nessun campo è stato modificato!',
        },
        current_image: 'Immagine Attuale',
      },
      // Aggiungi al file
      service_list: {
        filters: {
          categories: 'Categorie',
          category_placeholder: 'Categoria',
          filter_button: 'Filtra',
          all_categories: 'TUTTI',
        },
        table: {
          schedule: 'Orario',
          extension: 'Interno',
        },
        actions: {
          delete_service: 'Elimina Servizio',
        },
      },
      // Aggiungi al file
      service_create: {
        page_title: 'Registra Servizio',
        breadcrumb: {
          services: 'Servizi',
          create: 'Crea',
        },
        form: {
          classification_placeholder: 'Seleziona una classificazione',
          name_label: 'Nome',
          name_placeholder: 'Nome del servizio',
          description_label: 'Descrizione',
          description_placeholder: 'Descrizione del servizio',
          schedule_label: 'Orario di Funzionamento',
          schedule_placeholder: 'Es: 24h, 08:00-18:00, Su richiesta',
          schedule_smalltext: 'Massimo 50 caratteri',
          extension_label: 'Interno',
          extension_placeholder: 'Es: 1001, 2050',
          extension_smalltext: 'Massimo 10 caratteri',
          code_label: 'Codice',
          code_placeholder: 'Codice del servizio',
          order_label: 'Ordine',
          order_placeholder: 'Ordine di visualizzazione',
          status_label: 'Stato',
          status_active: 'Attivo',
          status_inactive: 'Inattivo',
          external_link_label: 'Link Esterno',
          external_link_placeholder: 'https://example.com',
          priority_label: 'Priorità',
          priority_low: 'Bassa',
          priority_normal: 'Normale',
          priority_high: 'Alta',
          priority_critical: 'Critica',
        },
        icons: {
          title: 'Icone',
          category_label: "Categoria dell'Icona",
          all_categories: 'Tutti',
          selected_icon: 'Icona selezionata',
        },
        validation: {
          missing_fields_title: 'Campi mancanti',
          missing_fields_text:
            'Verifica di aver compilato tutti i campi obbligatori: Nome, Classificazione e Icona!',
        },
        success: {
          title: 'Servizio registrato',
          text: 'Registrazione eseguita con successo!',
        },
        error: {
          title: 'Errore',
          text: 'Errore nella registrazione del servizio!',
          icons_load: 'Errore nel trovare i tipi',
        },
      }, // Aggiungi al file
      service_update: {
        page_title: 'Modifica Servizio',
        page_title_full: 'Aggiorna Servizio',
        breadcrumb: {
          edit: 'Modifica',
        },
        error: {
          title: 'Errore',
          load_data: 'Errore nel caricare i dati del servizio!',
          text: "Errore nell'aggiornare il servizio!",
        },
        success: {
          title: 'Servizio aggiornato',
          text: 'Modifica eseguita con successo!',
        },
      },
      // Aggiungi al file
      service_category_create: {
        validation: {
          missing_fields_title: 'Campi mancanti',
          missing_fields_text: 'Verifica di aver compilato tutti i campi!',
        },
        success: {
          title: 'Classificazione registrata',
          text: 'Registrazione eseguita con successo!',
        },
        error: {
          title: 'Errore',
          text: 'Errore nella registrazione della classificazione!',
          create: 'Errore nella registrazione della classificazione!',
        },
      },

      // Aggiungi al file
      service_category_list: {
        page_title: 'Categorie di Contenuto',
        page_subtitle:
          'Qui sono elencate le categorie di contenuto insieme alle rispettive azioni.',
        breadcrumb: {
          categories: 'Categorie',
        },
        add_button: 'Aggiungi',
        table: {
          name: 'Nome',
          status: 'Stato',
          actions: 'Azioni',
        },
        actions: {
          edit_category: 'Modifica categoria',
          delete_category: 'Elimina categoria',
        },
        delete: {
          error_title: 'Errore',
          error_text: "Errore nell'eliminare la categoria!",
          success_title: 'Categoria eliminata',
          success_text: 'Eliminazione eseguita con successo!',
          confirm_title: 'Sei sicuro?',
          confirm_text: 'La categoria verrà eliminata e non sarà possibile ripristinarla!',
          cancel_button: 'Chiudi!',
          confirm_button: 'Elimina!',
        },
      },
      service_category_update: {
        error: {
          title: 'Errore',
          load_data: 'Errore nel caricare i dati della classificazione!',
          text: "Errore nell'aggiornare la classificazione!",
          update: "Errore nell'aggiornare la classificazione!",
        },
        success: {
          title: 'Classificazione aggiornata',
          text: 'Modifica eseguita con successo!',
        },
      },
      hotelRoom: {
        status: {
          available: 'Disponibile',
          reserved: 'Riservato',
          maintenance: 'In manutenzione',
          occupied: 'Occupato',
          being_cleaning: 'In pulizia',
        },
        type: {
          single: 'Camera singola',
          double: 'Camera doppia',
          twin: 'Letti gemelli',
          queen: 'Letto Queen',
          king: 'Letto King',
          suite: 'Suite',
          junior_suite: 'Suite Junior',
          master_suite: 'Suite Master',
          presidential: 'Suite Presidenziale',
          family: 'Camera familiare',
          accessible: 'Camera accessibile',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Cliente',
          wizard_step_reservation: 'Prenotazione',
          wizard_step_confirmation: 'Conferma',
          wizard_step1: 'Passo 1',
          wizard_step2: 'Passo 2',
          wizard_step3: 'Passo 3',
          wizard_customer_title: 'Seleziona o Registra Cliente',
          wizard_customer_search_placeholder: 'Cerca per nome, email o telefono...',
          wizard_customer_search_button: 'Cerca Cliente Esistente',
          wizard_customer_new_button: 'Registra Nuovo Cliente',
          wizard_customer_none_found: 'Nessun cliente trovato',
          wizard_customer_showing_first:
            'Mostrando i primi 20 risultati. Affina la tua ricerca per trovare altri clienti.',
          wizard_reservation_title: 'Dati della Prenotazione',
          wizard_reservation_room_label: 'Camera *',
          wizard_reservation_room_subtitle:
            'Clicca sulle camere per selezionarle. Puoi selezionare più camere.',
          wizard_reservation_room_placeholder: 'Seleziona una camera',
          wizard_reservation_status_label: 'Stato della Prenotazione',
          wizard_reservation_status_placeholder: 'Seleziona lo stato',
          wizard_reservation_checkin_label: 'Data e Ora di Check-in *',
          wizard_reservation_checkout_label: 'Data e Ora di Check-out *',
          wizard_reservation_password_label: 'Password del Cliente',
          wizard_reservation_password_placeholder: 'Inserisci la password del cliente',
          wizard_reservation_generate_password: 'Genera password',
          wizard_confirmation_title: 'Conferma Prenotazione',
          wizard_confirmation_customer_data: 'Dati del Cliente',
          wizard_confirmation_reservation_data: 'Dati della Prenotazione',
          wizard_confirmation_room: 'Camera',
          wizard_confirmation_capacity: 'Capacità',
          wizard_confirmation_price: 'Prezzo',
          wizard_confirmation_checkin: 'Check-in',
          wizard_confirmation_checkout: 'Check-out',
          wizard_confirmation_status: 'Stato',
          wizard_confirmation_password: 'Password',
          wizard_confirmation_address: 'Indirizzo',
          wizard_confirmation_zipcode: 'CAP',
          wizard_confirmation_gender_male: 'Maschile',
          wizard_confirmation_gender_female: 'Femminile',
          wizard_confirmation_gender_other: 'Altro',
          wizard_confirmation_gender_not_informed: 'Preferisco non rispondere',
          wizard_buttons_back: 'Indietro',
          wizard_buttons_cancel: 'Annulla',
          wizard_buttons_next: 'Avanti',
          wizard_buttons_create: 'Crea',
          wizard_page_title: 'Nuova Prenotazione Camera',
          wizard_page_subtitle: "Crea una nuova prenotazione per l'hotel",
          legend: {
            title: 'Legenda Stato Camere',
            available: 'Disponibile',
            selected: 'Selezionato',
            unavailable: 'Non Disponibile',
            occupied: 'Occupata',
            reserved: 'Prenotata',
            being_cleaning: 'In Pulizia',
            maintenance: 'In Manutenzione',
            no_info: 'Senza Informazioni',
          },
        },
        customer_form: {
          title: 'Dati del Cliente',
          personal_info_title: 'Informazioni Personali',
          cpf_label: 'Codice Fiscale *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Nome Completo *',
          name_placeholder: 'Inserisci il nome completo',
          email_label: 'E-mail *',
          email_placeholder: "Inserisci l'e-mail",
          birthdate_label: 'Data di Nascita *',
          gender_label: 'Genere',
          gender_placeholder: 'Seleziona il genere',
          gender_male: 'Maschile',
          gender_female: 'Femminile',
          gender_other: 'Altro',
          contact_info_title: 'Informazioni di Contatto',
          phone_label: 'Telefono *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Tipo di Telefono',
          phone_type_cell: 'Cellulare',
          phone_type_landline: 'Fisso',
          whatsapp_optin: 'Accetta di ricevere messaggi su WhatsApp',
          address_title: 'Indirizzo di Residenza',
          cep_label: 'CAP *',
          cep_placeholder: '00000-000',
          street_label: 'Indirizzo *',
          street_placeholder: 'Via, Viale, ecc.',
          number_label: 'Numero *',
          number_placeholder: '123',
          extra_label: 'Complemento',
          extra_placeholder: 'Appartamento, Blocco, ecc.',
          district_label: 'Quartiere *',
          district_placeholder: 'Nome del quartiere',
          city_label: 'Città *',
          city_placeholder: 'Nome della città',
          state_label: 'Stato *',
          state_placeholder: 'SP',
          reference_label: 'Punto di Riferimento',
          reference_placeholder: 'Vicino al centro commerciale, di fronte alla piazza, ecc.',
          terms_title: 'Termini e Condizioni',
          accept_terms: "Accetto i termini e condizioni d'uso *",
          lgpd_consent: 'Autorizzo il trattamento dei miei dati personali (LGPD) *',
        },
        title: 'Prenotazioni Camere',
        subtitle: "Gestione delle prenotazioni dell'hotel",
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_reservation: 'Prenotazioni',
        btn_new_reservation: 'Nuova Prenotazione',
        btn_confirm: 'Conferma Prenotazione',
        btn_checkin: 'Esegui Check-in',
        btn_checkout: 'Esegui Check-out',
        btn_cancel: 'Annulla Prenotazione',
        btn_no_show: 'Segna come Non Presentato',
        btn_delete: 'Elimina Prenotazione',
        btn_details: 'Dettagli Prenotazione',
        filter_status_label: 'Stato della Prenotazione',
        filter_status_placeholder: 'Seleziona uno stato',
        filter_status_all: 'Tutti gli Stati',
        table_reservation: 'Prenotazione',
        table_room: 'Camera',
        table_customer: 'Cliente',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Stato',
        table_price: 'Valore',
        table_actions: 'Azioni',
        status_confirmed: 'Confermata',
        status_in_progress: 'In corso',
        status_completed: 'Completata',
        status_cancelled: 'Annullata',
        status_no_show: 'Non Presentato',
        status_pending: 'In sospeso',
        msg_success_delete: 'Eliminazione eseguita con successo!',
        msg_success_update: 'Stato della prenotazione aggiornato con successo!',
        msg_error_delete: "Errore nell'eliminare la prenotazione!",
        msg_error_update: "Errore nell'aggiornare lo stato della prenotazione!",
        msg_confirm_status_change: 'Vuoi cambiare lo stato della prenotazione in "{status}"?',
        msg_confirm_checkin: 'Vuoi eseguire il check-in per questa prenotazione?',
        msg_confirm_checkout:
          'Vuoi finalizzare il check-out? Questa azione non può essere annullata.',
        msg_checkout_attention: '⚠️ ATTENZIONE - LEGGI ATTENTAMENTE:',
        msg_checkout_list: [
          'Il cliente ha già effettuato il pagamento',
          'Non ci sono pendenze finanziarie',
          'Tutti i servizi sono stati regolarmente saldati',
        ],
        msg_checkout_confirm_read:
          'Ho letto e confermo che tutte le validazioni sono state verificate',
        msg_checkout_validation:
          'Devi confermare di aver letto e verificato tutte le validazioni prima di procedere.',
        msg_confirm_delete: 'Elimina Prenotazione',
        tab_basic: 'Informazioni Base',
        tab_summary: 'Riepilogo',
        tab_activities: 'Attività',
        tab_tours: 'Gite',
        tab_experiences: 'Esperienze',
        tab_services: 'Prenotazioni Servizi',
        tab_services_list: 'Elenco Servizi',
        tab_orders: 'Ordini Hotel',
        label_loading: 'Caricamento...',
        label_loading_orders: 'Caricamento ordini...',
        label_order_details: 'Dettagli Ordine',
        label_no_data: 'Nessun ordine trovato',
        label_pending: 'Nessun ordine è prenotato al momento.',
        tab_title: 'Ordini Hotel',
        label_order: 'Ordine',
        label_orders: 'Ordini',
        label_total_spent: 'Totale Speso: {value}',
        label_total_orders: 'Totale Ordini',
        label_total_spent_label: 'Totale Speso',
        label_total_paid_label: 'Totale Pagato',
        label_products: 'Prodotti',
        label_quantity: 'Quantità',
        label_sku: 'SKU',
        label_delivery: 'Consegna',
        label_delivery_address: 'Indirizzo di Consegna',
        label_withdraw_address: 'Indirizzo di Ritiro',
        label_financial_summary: 'Riepilogo Finanziario',
        label_products_label: 'Prodotti',
        label_delivery_fee: 'Tassa di Consegna',
        label_discount: 'Sconto',
        label_total: 'Totale',
        label_payment_na: 'Pagamento N/D',
        label_payment_offline: 'Pagamento Offline',
        label_payment_card: 'Pagamento con Carta',
        label_payment_credit: 'Credito',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Informazioni Base',
          label_customer: 'Cliente',
          label_room: 'Camera',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Stato',
          label_price: 'Valore',
          label_notes: 'Osservazioni',
          placeholder_notes: 'Aggiungi osservazioni sulla prenotazione',
          status_edit_warning:
            "Lo stato della prenotazione non può essere modificato dopo la conferma o l'annullamento.",
          selected_room_details: 'Camera {roomNumber} - {type} (Capacità: {capacity}) - R$ {price}',
          selected_customer_details: 'Cliente: {name} | Email: {email} | Telefono: {phone}',
          optional_checkout: 'Il check-out è opzionale e può essere compilato in seguito.',
          status_pending: 'In sospeso',
          status_confirmed: 'Confermata',
          status_in_progress: 'In corso',
          status_completed: 'Completata',
          status_cancelled: 'Annullata',
          summary_capacity: 'Capacità',
          summary_people: 'persone',
          btn_change_password: 'Cambia Password',
        },
        summary: {
          tab_title: 'Riepilogo',
          room_details: 'Dettagli della Camera',
          label_total: 'Totale',
          label_paid: 'Pagato',
          label_pending: 'In sospeso',
          label_services: 'Servizi',
          label_products: 'Prodotti',
          label_activities: 'Attività',
          label_experiences: 'Esperienze',
          label_tours: 'Gite',
          label_room: 'Camera',
          label_customer: 'Cliente',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Stato',
          label_price: 'Valore',
          label_notes: 'Osservazioni',
          label_capacity: 'Capacità',
          label_people: 'Persone',
          label_orders: 'Ordini Hotel',
          label_payment_method: 'Metodo di Pagamento',
          label_discount: 'Sconto',
          label_tax: 'Tassa',
          label_total_with_tax: 'Totale con Tassa',
          label_total_with_discount: 'Totale con Sconto',
          label_total_paid: 'Totale Pagato',
          label_total_pending: 'Totale in Sospeso',
          label_summary: 'Riepilogo della Prenotazione',
          label_details: 'Dettagli',
          label_edit: 'Modifica',
          label_delete: 'Elimina',
          label_confirm: 'Conferma',
          label_cancel: 'Annulla',
          label_no_data: 'Nessun dato disponibile',
          label_success: 'Operazione eseguita con successo!',
          label_error: "Errore nell'operazione!",
          label_warning: 'Attenzione',
          label_info: 'Informazione',
          label_actions: 'Azioni',
          label_service: 'Servizio',
          label_product: 'Prodotto',
          label_activity: 'Attività',
          label_experience: 'Esperienza',
          label_tour: 'Gita',
          label_order: 'Ordine',
          label_date: 'Data',
          label_time: 'Orario',
          label_type: 'Tipo',
          label_edit_reservation: 'Modifica Prenotazione',
          label_delete_reservation: 'Elimina Prenotazione',
          label_confirm_reservation: 'Conferma Prenotazione',
          label_cancel_reservation: 'Annulla Prenotazione',
          label_status_confirmed: 'Confermata',
          label_status_in_progress: 'In corso',
          label_status_completed: 'Completata',
          label_status_cancelled: 'Annullata',
          label_status_no_show: 'Non Presentato',
          label_status_pending: 'In sospeso',
        },
        activities: {
          tab_title: 'Attività',
          label_activity: 'Attività',
          label_activities: 'Attività',
          label_no_data: 'Nessuna attività trovata',
          label_pending: 'Nessuna attività è prenotata al momento.',
          label_people: 'Partecipanti',
          label_category: 'Categoria',
          label_location: 'Località',
          label_session_time: 'Orario della Sessione',
          label_skill_level: 'Livello di Abilità',
          label_special_requests: 'Richieste Speciali',
          label_price: 'Valore',
          label_date: 'Data',
          label_time: 'Orario',
          label_status: 'Stato',
          label_actions: 'Azioni',
          label_description: 'Descrizione',
          status_confirmed: 'Confermato',
          status_pending: 'In attesa',
          status_cancelled: 'Annullato',
          status_completed: 'Completato',
          btn_add_activity: 'Aggiungi Attività',
        },
        experiences: {
          tab_title: 'Esperienze',
          label_experience: 'Esperienza',
          label_experiences: 'Esperienze',
          label_no_data: 'Nessuna esperienza trovata',
          label_pending: 'Nessuna esperienza è prenotata al momento.',
          label_people: 'Partecipanti',
          label_category: 'Categoria',
          label_location: 'Località',
          label_session_time: 'Orario della Sessione',
          label_skill_level: 'Livello di Abilità',
          label_special_requests: 'Richieste Speciali',
          label_price: 'Valore',
          label_date: 'Data',
          label_time: 'Orario',
          label_status: 'Stato',
          label_actions: 'Azioni',
          label_description: 'Descrizione',
          status_confirmed: 'Confermato',
          status_pending: 'In attesa',
          status_cancelled: 'Annullato',
          status_completed: 'Completato',
          btn_add_experience: 'Aggiungi Esperienza',
          label_duration: 'Durata',
          label_rating: 'Valutazione',
          label_special_occasion: 'Occasione Speciale',
          label_includes: 'Include',
        },
        hotel_orders: {
          tab_title: 'Ordini Hotel',
          label_order: 'Ordine',
          label_orders: 'Ordini',
          label_no_data: 'Nessun ordine trovato',
          label_pending: 'Nessun ordine è prenotato al momento.',
          label_delivery: 'Consegna',
          label_quantity: 'Quantità',
          label_sku: 'SKU',
          label_delivery_address: 'Indirizzo di Consegna',
          label_withdraw_address: 'Indirizzo di Ritiro',
          label_financial_summary: 'Riepilogo Finanziario',
          label_products: 'Prodotti',
          label_products_label: 'Prodotti',
          label_total_spent: 'Totale Speso: {value}',
          label_total_orders: 'Totale Ordini',
          label_total_spent_label: 'Totale Speso',
          label_total_paid_label: 'Totale Pagato',
          label_discount: 'Sconto',
          label_total: 'Totale',
          label_payment_na: 'Pagamento N/D',
          label_payment_offline: 'Pagamento Offline',
          label_payment_card: 'Pagamento con Carta',
          label_payment_credit: 'Credito',
          label_delivery_fee: 'Tassa di Consegna',
          no_order_title: 'Nessun Ordine Trovato',
        },
        tours: {
          tab_title: 'Gite',
          label_tour: 'Gita',
          label_tours: 'Gite',
          label_no_data: 'Nessuna gita trovata',
          label_pending: 'Nessuna gita è prenotata al momento.',
          label_people: 'Partecipanti',
          label_duration: 'Durata',
          label_difficulty: 'Difficoltà',
          label_rating: 'Valutazione',
          label_transfer_included: 'Trasferimento Incluso',
          label_transfer_yes: 'Transfer Incluso',
          label_transfer_no: 'Senza Transfer',
          label_schedule: 'Orario',
          label_weather_concerns: 'Preoccupazioni per il Clima',
          label_physical_requirements: 'Requisiti Fisici',
          label_special_requests: 'Richieste Speciali',
          label_price: 'Valore',
          label_date: 'Data',
          label_time: 'Orario',
          label_status: 'Stato',
          label_actions: 'Azioni',
          label_description: 'Descrizione',
          status_confirmed: 'Confermato',
          status_pending: 'In attesa',
          status_cancelled: 'Annullato',
          status_completed: 'Completato',
          btn_add_tour: 'Aggiungi Gita',
        },
        services: {
          title: 'Prenotazioni Servizi',
          subtitle: 'Dettagli dei servizi prenotati',
          no_services: 'Nessun servizio prenotato',
          service_info: 'Informazioni sul Servizio',
          service_name: 'Nome del Servizio',
          service_type: 'Tipo di Servizio',
          description: 'Descrizione',
          room_info: 'Informazioni sulla Camera',
          room_number: 'Camera',
          booking_details: 'Dettagli della Prenotazione',
          status: 'Stato',
          check_in: 'Check-in',
          check_out: 'Check-out',
          guest_name: "Nome dell'Ospite",
          reservation_name: 'Nome della Prenotazione',
          number_of_rooms: 'N° di Camere',
          number_of_guests: 'N° di Ospiti',
          adults: 'Adulti',
          children: 'Bambini',
          total_price: 'Prezzo Totale',
          price_per_night: 'Prezzo per Notte',
          nights: 'Notti',
          additional_info: 'Informazioni Aggiuntive',
          booking_date: 'Data di Prenotazione',
          reservation_code: 'Codice di Prenotazione',
          payment_status: 'Stato del Pagamento',
          special_requests: 'Richieste Speciali',
          service_details: 'Dettagli del Servizio',
          view_details: 'Vedi Dettagli',
          total_services: 'Totale Servizi',
          active_services: 'Servizi Attivi',
          pending_services: 'Servizi in Attesa',
          completed_services: 'Servizi Completati',
          service_image: 'Immagine del Servizio',
          no_image: 'Nessuna immagine disponibile',
        },
        services_list: {
          title: 'Elenco Servizi',
          subtitle: 'Tutti i servizi prenotati',
          search_placeholder: 'Cerca per nome, camera o ospite...',
          filter_all: 'Tutti',
          filter_active: 'Attivi',
          filter_pending: 'In Attesa',
          filter_completed: 'Completati',
          table_service_name: 'Servizio',
          table_service_type: 'Tipo',
          table_room: 'Camera',
          table_guest: 'Ospite',
          table_checkin: 'Check-in',
          table_checkout: 'Check-out',
          table_status: 'Stato',
          table_price: 'Prezzo',
          table_actions: 'Azioni',
          status_active: 'Attivo',
          status_pending: 'In Attesa',
          status_completed: 'Completato',
          status_cancelled: 'Annullato',
          no_services: 'Nessun servizio trovato',
          no_services_desc: 'Nessun servizio corrisponde ai tuoi criteri',
          showing: 'Visualizzazione',
          of: 'di',
          services: 'servizi',
          items_per_page: 'Elementi per pagina',
          page: 'Pagina',
          previous: 'Precedente',
          next: 'Successivo',
          view_details: 'Vedi Dettagli',
          total_found: 'Totale trovato',
          active_filters: 'Filtri attivi',
          clear_filters: 'Cancella filtri',
          filter_by_status: 'Filtra per stato',
          search_active: 'Ricerca attiva',
          rooms: 'camere',
          guests: 'ospiti',
          nights: 'notti',
          loading: 'Caricamento servizi...',
          error: 'Errore nel caricamento dei servizi',
          retry: 'Riprova',
          export: 'Esporta',
          refresh: 'Aggiorna',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Numero della Camera *',
        image: 'Immagine della Camera',
        placeholder_room_number: 'Es: 101, A201, Suite Presidenziale',
        max_20_chars: 'Massimo 20 caratteri',
        label_status: 'Stato',
        label_capacity: 'Capacità (persone)',
        placeholder_capacity: 'Es: 2',
        label_price: 'Prezzo (R$)',
        placeholder_price: 'Es: 150.00',
        label_type: 'Tipo di Camera',
        title: "Camere d'Hotel",
        subtitle: "Gestione delle camere dell'hotel",
        create_multiples: 'Crea Camere Multiple',
        add_room: 'Aggiungi Camera',
        header_number: 'Numero',
        header_status: 'Stato',
        header_type: 'Tipo',
        header_capacity: 'Capacità',
        header_price: 'Prezzo',
        header_actions: 'Azioni',
        action_edit: 'Modifica Camera',
        action_delete: 'Elimina Camera',
        modal_bulk_title: 'Crea Camere Multiple',
        modal_bulk_prefix: 'Prefisso (opzionale)',
        modal_bulk_prefix_placeholder: 'Es: A, B, 1°',
        modal_bulk_start: 'Numero Iniziale *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Numero Finale *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Capacità',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Prezzo',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Tipo',
        type_single: 'Singola',
        type_double: 'Doppia',
        type_twin: 'Twin',
        type_queen: 'Queen',
        type_king: 'King',
        type_suite: 'Suite',
        type_junior_suite: 'Suite Junior',
        type_master_suite: 'Suite Master',
        type_presidential: 'Presidenziale',
        type_family: 'Familiare',
        type_accessible: 'Accessibile',
        modal_bulk_cancel: 'Annulla',
        modal_bulk_create: 'Crea Camere',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hotel_room: "Camere d'Hotel",
        create_title: "Crea Camera d'Hotel",
        create_subtitle: "Aggiungi una nuova camera all'hotel",
        edit_title: "Modifica Camera d'Hotel",
        edit_subtitle: 'Modifica le informazioni della camera #{room}',
        breadcrumb_create: 'Crea Camera',
        breadcrumb_edit: 'Modifica Camera',
      },
      hospitality_experiences: {
        tab_basic: 'Informazioni Base',
        edit: 'Modifica Esperienza',
        edit_subtitle: "Aggiorna l'informazione dell'esperienza",
        create: 'Crea Esperienza',
        create_subtitle: 'Compila i dettagli per creare una nuova esperienza',
        tab_details: 'Elementi dettagliati',
        tab_image: 'Immagine',
        tab_schedules: 'Orari',
        list_title: "Esperienze dell'Hotel",
        list_subtitle: "Gestisci tutte le esperienze dell'hotel",
        field_title: 'Titolo',
        field_title_placeholder: 'Es: Cena Romantica Esclusiva',
        field_description: 'Descrizione',
        field_description_placeholder: "Descrivi dettagliatamente l'esperienza offerta...",
        field_image: 'Nuova Immagine',
        field_price: 'Prezzo (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Durata',
        field_duration_placeholder: 'Es: 2 ore',
        field_type: 'Tipo di Esperienza',
        field_rating: 'Valutazione (0-5)',
        field_rating_placeholder: '0',
        field_status: 'Stato Attivo',
        field_includes: 'Elementi Inclusi',
        field_includes_placeholder: 'Es: Champagne, decorazione speciale...',
        field_show_additional_services: 'Mostra opzioni di servizio predefinite',
        field_actions: 'Azioni',
        status_active: 'Attivo',
        status_inactive: 'Inattivo',
        no_rating: 'Senza valutazione',
        no_includes: 'Nessun elemento incluso',
        currency: 'R$',
        btn_add: 'Aggiungi Esperienza',
        btn_edit: 'Modifica',
        btn_delete: 'Rimuovi',
        btn_update: 'Aggiorna Esperienza',
        btn_create: 'Crea Esperienza',
        btn_remove: 'Rimuovi',
        btn_add_item: 'Aggiungi Elemento',
        edit_title: 'Modifica Esperienza',
        create_title: 'Crea Esperienza',
        msg_success_create: 'Esperienza creata con successo!',
        msg_success_update: 'Esperienza aggiornata con successo!',
        msg_success_delete: 'Esperienza rimossa',
        msg_success_delete_text: 'Esperienza rimossa con successo!',
        msg_error_create: "Errore nella creazione dell'esperienza",
        msg_error_update: "Errore nell'aggiornamento dell'esperienza",
        msg_error_delete: "Errore nella rimozione dell'esperienza",
        msg_error_delete_text: "Non è stato possibile rimuovere l'esperienza!",
        msg_error_load: "Errore nel caricare l'esperienza",
        msg_error_load_text: "Non è stato possibile caricare i dati dell'esperienza!",
        msg_error_required_title: 'Il titolo è obbligatorio!',
        msg_error_title_length: 'Il titolo deve avere un massimo di 255 caratteri!',
        msg_error_required_description: 'La descrizione è obbligatoria!',
        msg_error_required_price: 'Il prezzo è obbligatorio!',
        msg_error_price_negative: 'Il prezzo deve essere maggiore o uguale a zero!',
        msg_error_required_duration: 'La durata è obbligatoria!',
        msg_error_duration_length: 'La durata deve avere un massimo di 100 caratteri!',
        msg_error_required_includes: 'Almeno un elemento deve essere incluso!',
        msg_error_rating_range: 'La valutazione deve essere compresa tra 0 e 5!',
        field_order: 'Ordine',
        field_order_placeholder: 'Es: 1, 2, 3...',
        header_order: 'Ordine',
        msg_error_order_negative: "L'ordine deve essere maggiore o uguale a zero!",
      },
      entertainment_services: {
        list_title: 'Servizi di Intrattenimento',
        list_subtitle: 'Gestisci i servizi di intrattenimento disponibili',
        create: 'Crea Servizio di Intrattenimento',
        create_subtitle: 'Compila i dettagli per creare un nuovo servizio',
        create_title: 'Crea Servizio di Intrattenimento',
        edit: 'Modifica Servizio di Intrattenimento',
        edit_subtitle: 'Aggiorna le informazioni del servizio',
        edit_title: 'Modifica Servizio di Intrattenimento',
        field_title: 'Titolo',
        field_title_placeholder: 'Es: Spa e Massaggio',
        field_type: 'Tipo di Servizio',
        field_status: 'Stato Attivo',
        field_actions: 'Azioni',
        type_experience: 'Esperienza di Intrattenimento',
        type_activity: 'Attività di Intrattenimento',
        type_tour: 'Tour di Intrattenimento',
        status_active: 'Attivo',
        status_inactive: 'Inattivo',
        btn_add: 'Aggiungi Servizio',
        btn_edit: 'Modifica',
        btn_delete: 'Rimuovi',
        btn_update: 'Aggiorna Servizio',
        btn_create: 'Crea Servizio',
        btn_search: 'Cerca',
        btn_clear: 'Cancella',
        search_placeholder: 'Cerca per titolo...',
        msg_success_create: 'Servizio creato con successo!',
        msg_success_update: 'Servizio aggiornato con successo!',
        msg_success_delete: 'Servizio rimosso',
        msg_success_delete_text: 'Servizio rimosso con successo!',
        msg_error_create: 'Errore nella creazione del servizio',
        msg_error_update: "Errore nell'aggiornamento del servizio",
        msg_error_delete: 'Errore nella rimozione del servizio',
        msg_error_delete_text: 'Impossibile rimuovere il servizio!',
        msg_error_load: 'Errore nel caricamento del servizio',
        msg_error_load_text: 'Impossibile caricare i dati del servizio!',
        msg_error_required_title: 'Il titolo è obbligatorio!',
        msg_error_title_length: 'Il titolo deve essere lungo al massimo 255 caratteri!',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'Prenotazioni Servizi',
          details_title: 'Dettagli della Prenotazione',
          cancel_title: 'Annulla Prenotazione',
          cancel_reason_label: "Motivo dell'Annullamento *",
          cancel_reason_placeholder: "Seleziona il motivo dell'annullamento",
          cancel_reason_select: 'Seleziona un motivo',
          type_tour: 'Gita',
          type_experience: 'Esperienza',
          type_activity: 'Attività',
          type_room_service: 'Servizio in Camera',
          status_pending: 'In sospeso',
          status_confirmed: 'Confermato',
          status_cancelled: 'Annullato',
          status_completed: 'Completato',
          error_title: 'Errore',
          error_load: 'Errore nel caricare le prenotazioni!',
          error_details: 'Errore nel caricare i dettagli della prenotazione!',
          error_cancel: "Errore nell'annullare la prenotazione!",
          success_title: 'Successo',
          success_cancel: 'Prenotazione annullata con successo!',
          warning_title: 'Attenzione',
          warning_cancel_reason: "Per favore, seleziona un motivo per l'annullamento.",
          no_details: 'Dettagli specifici non disponibili per questo tipo di prenotazione.',
          reasons_tour: [
            'Cambio di piani',
            'Problemi climatici',
            'Conflitto di orario',
            'Motivi di salute',
            "Annullamento dell'hotel",
          ],
          reasons_experience: [
            'Cambio di data del soggiorno',
            'Occasione speciale annullata',
            'Conflitto di agenda',
            'Motivi personali',
            'Preferenza per un altro servizio',
          ],
          reasons_activity: [
            'Non mi sento preparato/a',
            'Conflitto di orario',
            'Problemi di salute',
            'Cambio di piani',
            "L'attività non soddisfa le aspettative",
          ],
          reasons_room_service: [
            'Cambio di piani',
            'Servizio non necessario',
            'Conflitto di orario',
            'Motivi personali',
            'Preferenza per un altro servizio',
          ],
        },
        create_title: "Crea Attività dell'Hotel",
        create_subtitle: "Aggiungi una nuova attività all'hotel",
        edit_title: "Modifica Attività dell'Hotel",
        edit_subtitle: "Aggiorna le informazioni dell'attività",
        list_title: "Attività dell'Hotel",
        list_subtitle: "Gestione delle attività e dell'intrattenimento",
        field_title: "Titolo dell'Attività *",
        field_title_placeholder:
          'Es: Lezione di Yoga, Spettacolo Musicale, Ricreazione per Bambini',
        field_title_hint: 'Massimo 255 caratteri',
        field_time: 'Orario *',
        field_time_placeholder: 'Es: 08:00 - 09:00, Giornalmente alle 15h',
        field_time_hint: 'Massimo 100 caratteri',
        field_description: 'Descrizione *',
        field_description_placeholder:
          "Descrivi dettagliatamente l'attività, i suoi benefici e cosa possono aspettarsi gli ospiti...",
        field_image: "Immagine dell'Attività",
        field_location: 'Località *',
        field_location_placeholder: 'Es: Piscina principale, Salone eventi, Spiaggia',
        field_location_hint: 'Massimo 255 caratteri',
        field_capacity: 'Capacità *',
        field_capacity_placeholder: 'Es: 20, se 0 è illimitato',
        field_capacity_hint: 'Massimo 50 caratteri',
        field_period: 'Periodo *',
        field_period_placeholder: 'Es: 00:15 o 01:00 o 00:30',
        field_category: 'Categoria *',
        field_age_group: "Fascia d'Età",
        field_price: 'Prezzo (R$)',
        field_price_placeholder: '0.00 (lascia vuoto se gratuito)',
        field_price_hint: 'Lascia vuoto per attività gratuita',
        field_requires_reservation: 'Richiede Prenotazione',
        field_requires_reservation_hint: "Spunta se l'attività richiede prenotazione anticipata",
        field_is_active: 'Attività Attiva',
        field_is_active_hint: "Deseleziona per disattivare temporaneamente l'attività",
        btn_edit: 'Modifica Attività',
        btn_delete: 'Elimina Attività',
        btn_create: 'Crea Attività',
        btn_cancel: 'Annulla',
        msg_success_create: 'Attività creata con successo!',
        msg_success_update: 'Attività aggiornata con successo!',
        msg_success_delete: 'Attività eliminata con successo!',
        msg_error_create: "Errore nella creazione dell'attività!",
        msg_error_update: "Errore nell'aggiornamento dell'attività!",
        msg_error_delete: "Errore nell'eliminazione dell'attività!",
        msg_error_load: "Errore nel caricare l'attività!",
        msg_error_required_title: 'Il titolo è obbligatorio!',
        msg_error_title_length: 'Il titolo deve avere un massimo di 255 caratteri!',
        msg_error_required_description: 'La descrizione è obbligatoria!',
        msg_error_required_time: "L'orario è obbligatorio!",
        msg_error_time_length: "L'orario deve avere un massimo di 100 caratteri!",
        msg_error_required_location: 'La località è obbligatoria!',
        msg_error_location_length: 'La località deve avere un massimo di 255 caratteri!',
        msg_error_required_capacity: 'La capacità è obbligatoria!',
        msg_error_capacity_length: 'La capacità deve avere un massimo di 50 caratteri!',
        msg_error_price_negative: 'Il prezzo deve essere maggiore o uguale a zero!',
        remove_schedule: 'Elimina Orario',
        confirm_remove_schedule: 'Sei sicuro di voler eliminare questo orario?',
        schedule_seasonal_start: 'Inizio Stagione',
        schedule_seasonal_end: 'Fine Stagione',
        schedule_start_time: 'Ora di Inizio',
        schedule_end_time: 'Ora di Fine',
        add_schedule: 'Aggiungi Orario',
        schedule_time: 'Ora *',
        schedule_time_placeholder: 'Es.: 08:00 - 09:00, Giornaliero alle 15h',
        schedule_description: 'Descrizione *',
        schedule_days_of_week: 'Giorni della Settimana',
        schedule_status: 'Orario Attivo',
        schedule_seasonal_hint: 'Definisci un periodo stagionale se applicabile',
        field_duration_hint: 'Durata in ore e minuti (es: 2h30min)',
        field_duration_placeholder: 'Durata in ore e minuti (es: 2h30min)',
        field_order: 'Ordine',
        field_order_placeholder: 'Es: 1, 2, 3...',
        msg_error_order_negative: "L'ordine deve essere maggiore o uguale a zero!",
      },
      hotel_tour: {
        create_title: "Crea Gita dell'Hotel",
        create_subtitle: "Aggiungi una nuova gita all'hotel",
        edit_title: "Modifica Gita dell'Hotel",
        edit_subtitle: 'Aggiorna le informazioni della gita',
        list_title: "Gite dell'Hotel",
        list_subtitle: 'Gestisci gite ed escursioni',
        field_title: 'Titolo della Gita *',
        field_difficulty: 'Difficoltà',
        field_duration: 'Durata',
        field_rating: 'Valutazione',
        field_participants: 'Partecipanti',
        field_schedules: 'Orari',
        field_includes: 'Include',
        field_transfer: 'Transfer',
        field_currency: 'Valuta',
        field_currency_hint: 'Codice della valuta (es: BRL, USD)',
        currency_brl: 'Reale (BRL)',
        currency_usd: 'Dollaro (USD)',
        currency_eur: 'Euro (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: 'Valutazione da 0 a 5 stelle',
        field_participants_min: 'Partecipanti Minimi *',
        field_participants_min_hint: 'Numero minimo di partecipanti',
        field_participants_max: 'Partecipanti Massimi',
        field_participants_max_placeholder: 'Lascia vuoto se illimitato',
        field_participants_max_hint: 'Numero massimo di partecipanti (opzionale)',
        field_age_restriction: "Restrizione d'Età",
        field_age_restriction_placeholder: 'Es: Sopra i 12 anni, Non raccomandato per minori di 18',
        field_age_restriction_hint: "Restrizioni d'età (opzionale)",
        field_physical_requirements: 'Requisiti Fisici',
        field_physical_requirements_placeholder:
          'Es: Buona condizione fisica, Capacità di camminare lunghe distanze',
        field_physical_requirements_hint: 'Requisiti fisici necessari (opzionale)',
        field_cancellation_hours: 'Annullamento (ore) *',
        field_cancellation_hours_hint: "Ore prima per l'annullamento",
        field_discount_children: 'Sconto Bambini (%)',
        field_discount_children_hint: 'Sconto in percentuale',
        field_weather_dependent: 'Dipende dal Clima',
        field_weather_dependent_hint: 'Spunta se dipende dalle condizioni climatiche',
        field_is_active: 'Gita Attiva',
        field_is_active_hint: 'Deseleziona per disattivare temporaneamente',
        tab_basic: 'Informazioni Base',
        tab_details: 'Dettagli e Configurazioni',
        tab_schedules: 'Orari',
        tab_includes: 'Elementi Inclusi',
        tab_image: 'Immagine',
        no_schedule_added: 'Nessun orario aggiunto',
        click_add_schedule: 'Clicca su "Aggiungi Orario" per iniziare.',
        includes_title: 'Elementi Inclusi nella Gita',
        selected: 'Selezionati',
        field_image_hint: "Seleziona un'immagine rappresentativa della gita",
        update_info: 'Aggiorna informazioni della gita',
        field_title_placeholder: 'Es: City Tour, Escursione in Spiaggia, Camminata Storica',
        field_title_hint: 'Massimo 255 caratteri',
        field_time: 'Orario *',
        field_time_placeholder: 'Es: 08:00 - 09:00, Giornalmente alle 15h',
        field_time_hint: 'Massimo 100 caratteri',
        field_description: 'Descrizione *',
        field_description_placeholder:
          'Descrivi la gita, i punti salienti e cosa possono aspettarsi gli ospiti...',
        field_image: 'Immagine della Gita',
        field_location: 'Località *',
        field_location_placeholder: 'Es: Centro, Spiaggia, Museo',
        field_location_hint: 'Massimo 255 caratteri',
        field_capacity: 'Capacità *',
        field_capacity_placeholder: 'Es: 20 persone, Illimitato, 10-15 partecipanti',
        field_capacity_hint: 'Massimo 50 caratteri',
        field_category: 'Categoria *',
        field_price: 'Prezzo (R$)',
        field_price_placeholder: '0.00 (lascia vuoto se gratuito)',
        field_price_hint: 'Lascia vuoto per gita gratuita',
        field_requires_reservation: 'Richiede Prenotazione',
        field_requires_reservation_hint: 'Spunta se la gita richiede prenotazione anticipata',
        btn_edit: 'Modifica Gita',
        btn_delete: 'Elimina Gita',
        btn_create: 'Crea Gita',
        btn_cancel: 'Annulla',
        table_title: 'Titolo',
        table_time: 'Orario',
        table_location: 'Località',
        table_category: 'Categoria',
        table_price: 'Prezzo',
        table_capacity: 'Capacità',
        table_actions: 'Azioni',
        msg_success_create: 'Gita creata con successo!',
        msg_success_update: 'Gita aggiornata con successo!',
        msg_success_delete: 'Gita eliminata con successo!',
        msg_error_create: 'Errore nella creazione della gita!',
        msg_error_update: "Errore nell'aggiornamento della gita!",
        msg_error_delete: "Errore nell'eliminazione della gita!",
        msg_error_load: 'Errore nel caricare la gita!',
        msg_error_required_title: 'Il titolo è obbligatorio!',
        msg_error_title_length: 'Il titolo deve avere un massimo di 255 caratteri!',
        msg_error_required_description: 'La descrizione è obbligatoria!',
        msg_error_required_time: "L'orario è obbligatorio!",
        msg_error_time_length: "L'orario deve avere un massimo di 100 caratteri!",
        msg_error_required_location: 'La località è obbligatoria!',
        msg_error_location_length: 'La località deve avere un massimo di 255 caratteri!',
        msg_error_required_capacity: 'La capacità è obbligatoria!',
        msg_error_capacity_length: 'La capacità deve avere un massimo di 50 caratteri!',
        msg_error_price_negative: 'Il prezzo deve essere maggiore o uguale a zero!',
        schedule_start_time: 'Ora di Inizio',
        schedule_end_time: 'Ora di Fine',
        add_schedule: 'Aggiungi Orario',
        schedule_time: 'Ora *',
        schedule_time_placeholder: 'Es.: 08:00 - 09:00, Giornaliero alle 15h',
        schedule_description: 'Descrizione *',
        schedule_days_of_week: 'Giorni della Settimana',
        schedule_status: 'Orario Attivo',
        schedule_seasonal_hint: 'Definisci un periodo stagionale se applicabile',
        field_duration_hint: 'Durata in ore e minuti (es: 2h30min)',
        field_duration_placeholder: 'Durata in ore e minuti (es: 2h30min)',
        schedule_seasonal_start: 'Inizio Stagione',
        schedule_seasonal_end: 'Fine Stagione',
        difficult: {
          easy: 'Facile',
          medium: 'Moderata',
          hard: 'Difficile',
          extreme: 'Estrema',
        },
        field_order: 'Ordine',
        field_order_placeholder: 'Es: 1, 2, 3...',
        header_order: 'Ordine',
        msg_error_order_negative: "L'ordine deve essere maggiore o uguale a zero!",
      },
      months: {
        jan: 'Gen',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Mag',
        jun: 'Giu',
        jul: 'Lug',
        aug: 'Ago',
        sep: 'Set',
        oct: 'Ott',
        nov: 'Nov',
        dec: 'Dic',
      },
      permissions: {
        color_variations: 'Variazioni di Colore',
        food: 'Smart Order',
        content: 'Interfaccia Webapp',
        buttons: 'Pulsanti',
        sessions: 'Sessioni',
        smartorder: 'Gestione Prodotti',
        category: 'Categorie',
        subcategory: 'Sottocategorie',
        product: 'Prodotti',
        mark: 'Marche',
        grid: 'Griglie',
        variation: 'Variazioni',
        catalog: 'Cataloghi',
        integration: 'Integrazioni',
        int_pos: 'POS',
        int_gateway: 'Metodo di Pagamento',
        messaging: 'Messaggistica',
        sms: 'Stato e SMS',
        multichannel: 'Multicanale',
        report: 'Rapporti',
        saleorder: 'Ordini',
        indicators: 'Indicatori',
        orderReport: 'Ordini',
        imports: 'Importazione Immagini',
        importProductImage: 'Prodotti',
        importProductImageSKU: 'Variazioni',
        importCategoryImage: 'Categorie',
        customers: 'Clienti',
        customer_report: 'Elenco Clienti',
        measurement_unit: 'Unità di Misura',
        logs: 'Log',
        settings: 'Impostazioni',
        charge_integration: 'Carichi',
        summaryAccess: 'Accessi',
        sellerAccess: 'Dash Venditore',
        managerAccess: 'Dash Manager',
        managerGroupAccess: 'Dash Gestore del Gruppo',
        orders: 'Ordini',
        support: 'Supporto',
        translate: 'Lingue e Relazioni',
        application: 'Webapp',
        messenger: 'Messaggistica',
        others: 'Altri',
        settings_store: 'Impostazioni del Negozio',
        settings_hotel: 'Impostazioni ',
        modalities: 'Modalità',
        delivery_tax: 'Tassa di consegna',
        shifts: 'Turni',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'Gestore File',
        payment_plans: 'Piani di Pagamento',
        settings_account: 'Impostazioni Account',
        account: 'Account',
        groups: 'Gruppi',
        users: 'Utenti',
        terms: 'Termini',
        highlights: 'In Evidenza',
        menu: 'Menu',
        productReport: 'Prodotti',
        optional: 'Elenco Aggiuntivi',
        locations: 'Settori',
        stores_location: 'Stabilimenti',
        message_hotel: 'Stato e Notifica',
        service: 'Servizi',
        service_items: 'Servizi',
        service_category: 'Categorie',
        feed: 'Feed',
        structured_content: 'Servizi Essenziali',
        orders_room_service: 'Ordini Camera',
        orders_activities: 'Ordini Attività',
        seller: 'Venditore',
        queue: "Coda d'attesa",
        queue_config: 'Configurazioni',
        queue_manager: 'Gestione',
        reason: 'Motivo',
        seller_queue_config: 'Configurazione Coda del Venditore',
        checkout: 'Dati del Cliente',
        booking: 'Prenotazione',
        booking_management: 'Gestione',
        booking_config: 'Configurazioni',
        booking_environment: 'Ambienti',
        booking_day: 'Prenotazioni del giorno',
        booking_report: 'Rapporti',
        booking_managerday: 'Gestione Prenotazioni del Giorno',
        booking_management_dashboard: 'Dashboard di Gestione delle Prenotazioni',
        table_management: 'Gestione Tavoli',
        table_allocation_report: 'Rapporto di Assegnazione dei Tavoli',
        table_management_dashboard: 'Dashboard di Gestione dei Tavoli',
        liveShop: 'Live Commerce',
        icon_library: 'Libreria Icone',
        stores: 'Negozi/Clienti',
        segments: 'Segmenti',
        payment: 'Pagamenti',
        serviceCategory: 'Categoria del Servizio',
        SDS: 'KDS',
        sds_manage: 'Miei KDS',
        sds_layout: 'Personalizzazione',
        sds_link: 'Configurazioni',
        sds_display: 'Display',
        /* Aggregatore */
        config: 'Configurazioni',
        config_account: "Dati dell'account",
        config_sector: 'Settore di attività',
        config_user: 'Utenti',
        config_term: 'Termini',
        subCategory: 'Sottocategoria',
        footer: 'Risorse del piè di pagina',
        footerFeature: 'Abilita risorse',
        footerContent: 'Feed di risorse',
        footerContentAddEdit: 'Risorse',
        webapp: 'Personalizza',
        webapp_qrcode: 'Genera QR Code',
        ia_menu: 'Intelligenza Artificiale',
        ia_config: 'Configurazioni',
        ia_fit: 'Addestramento',
        ia_file_manager: 'Gestore File',
        ia_folders: 'Cartelle',
        ia_files: 'File',
        ia_settings: 'Impostazioni',
        ia_folders_blank: 'Nessuna cartella trovata',
        ia_filter: 'Filtra',
        ia_recharge: 'Ricarica',
        ia_final_date: 'Data Fine',
        ia_initial_date: 'Data Iniziale',
        summarize: 'Dashboard',
        consumption: 'Consumo IA',
        ct_account: 'Consumo e Valore',
        ct_s3_account: 'Account S3',
        ct_data_cost_account: 'Dati e Costi',
        publication_highlight_banner: 'Banner In Evidenza',
        publication: 'Pubblicità',
        cost: 'Costi',
        security_settings: 'Impostazioni di sicurezza',
        coupon: 'Coupon',
        clean_safe: 'Clean & Safe',
        service_requests: 'Moduli di Servizio',
        grid_hotel: 'Griglia dei Servizi',
        /*Ospitalità */
        hotel_maintenance: 'Manutenzione',
        hotel_room: 'Camera',
        hotel_reservation: 'Prenotazioni Camera',
        hotel_activities_experiences: 'Attività ed Esperienze',
        hotel_activities: 'Attività',
        hotel_tour: 'Gita Hotel',
        hotel_tour_schedules: 'Orari Gita Hotel',
        hotel_tour_reservation: 'Prenotazioni Generali',
        hotel_experiences: 'Esperienze',
        hotel_info: 'Informazioni',
        hotel_reservations: 'Prenotazioni',
        hotel_schedules: 'Programmazione Hotel',
        publication_banner: 'Banner',
        feed_back: 'Feedback',
        feedback_satisfaction: 'Sondaggio e Soddisfazione',
        grid_hotel_feedback: 'Griglia',
        feedback_list: 'Modulo',
        feedback: 'Feedback',
        post: 'Postagem',
        post_category: 'Categoria de Postagem',
        post_content: 'Conteúdo da Postagem',
        booking_hotel: 'Gestione Prenotazioni',
        grid_hotel_booking: 'Griglie di Servizi',
        booking_config_hotel: 'Prenotazioni di Servizi',
        page_publications: 'Página de Publicações',
        communication: 'Comunicazione',
        communicationCenter: 'Centro di Comunicazione',
        hotel_management: "Gestione dell'Hotel",
        hotel_management_entertainment: 'Intrattenimento',
        product_color_variations: 'Variazioni di Colore',
        feedback_analytics: 'Analisi dei Feedback',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: 'Variazioni di Colore',
        page_subtitle: 'Gestisci le variazioni di colore del prodotto',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_workbench: 'Laboratorio dei Colori',

        // Mode Selection
        selectMode: 'Seleziona Modalità',
        chooseProdutOrVariation: 'Scegli di lavorare con un Prodotto o una Variazione',
        product: 'Prodotto',
        productDescription: 'Scegli tra i prodotti registrati nel tuo negozio',
        variation: 'Variazione',
        variationDescription: 'Scegli tra le variazioni registrate',

        // Product/Variation Selection
        selectProduct: 'Seleziona un Prodotto',
        selectVariation: 'Seleziona una Variazione',
        searchProduct: 'Cerca prodotto per nome o codice...',
        searchVariation: 'Cerca variazione per SKU o nome del prodotto...',
        noProductsFound: 'Nessun prodotto trovato',
        noProductsMatchSearch: 'Nessun prodotto trovato che corrisponda ai criteri di ricerca',
        noVariationsFound: 'Nessuna variazione trovata',
        noVariationsMatchSearch: 'Nessuna variazione trovata che corrisponda ai criteri di ricerca',
        noImagesFound: 'Nessuna immagine trovata per questo prodotto/variazione',
        description:
          'Seleziona un prodotto o una variazione per iniziare a creare variazioni di colore personalizzate.',
        showingResults: 'Visualizzazione',
        of: 'di',
        backButton: 'Indietro',

        // Image and Color Selection
        selectImage: 'Seleziona Immagine',
        selectColor: 'Seleziona Colore',
        colorDescription: 'Descrizione (Facoltativa)',
        descriptionPlaceholder: 'Descrivi il cambiamento che desideri apportare...',
        selectImageFirst: "Seleziona prima un'immagine",
        processingError: "Errore durante l'elaborazione della variazione",

        // Buttons
        generateVariation: 'Genera Variazione',
        processing: 'Elaborazione in corso...',
        processingTimeSeconds: '{time}s',

        // Preview
        selectedImagePreview: 'Anteprima Immagine Selezionata',
        resultPreview: 'Anteprima Risultato',
        originalImage: 'Immagine Originale',
        processedImage: 'Immagine Elaborata',
        targetColor: 'Colore Obiettivo',
        processingTime: 'Tempo di Elaborazione',

        // Actions
        approveAndApply: 'Approva e Applica',
        reject: 'Rifiuta',
        applyVariation: 'Applica Variazione',
        applyTarget: 'Dove desideri applicare questa variazione?',

        // Apply Dialog
        createNewVariation: 'Crea Nuova Variazione',
        newVariationInfo: 'Con questa immagine verrà creata una nuova variazione',
        replaceExistingVariation: 'Sostituisci Variazione Esistente',
        selectVariationToReplace: 'Seleziona la variazione che desideri sostituire',
        replaceProductImage: 'Sostituisci Immagine Prodotto',
        selectProductToReplaceImage: 'Seleziona quale immagine del prodotto sarà sostituita',

        // Messages
        variationSavedSuccess: 'Variazione salvata con successo!',
        errorSavingVariation: 'Errore durante il salvataggio della variazione',
        successTitle: 'Successo',
        errorTitle: 'Errore',
        warningTitle: 'Avviso',

        // Dialog Buttons
        cancel: 'Annulla',
        save: 'Salva',
        confirm: 'Conferma',
        close: 'Chiudi',
      },
      customer: {
        select_group: 'Seleziona un gruppo',
        select: 'Seleziona',
        create: 'Crea cliente',
        create_group: 'Crea gruppo',
        edit: 'Visualizza cliente',
        search_custom: 'Cerca...',
        customer: 'Clienti',
      },

      buttons: {
        create: 'Crea',
        back: 'Indietro',
        previous: 'Precedente',
        register_pluginspace: 'Registra Pluginspace',
        access: 'Accedi',
        add_modality: 'Aggiungi modalità',
        add_km: 'Aggiungi Km',
        zip_code_list: 'Elenco CAP',
        add_zip_code: 'Aggiungi CAP',
        area: 'Aree di Spedizione',
        list_of_negative_renge_zip_code: 'Elenco CAP negativi',
        add_negative_zip_code: 'Aggiungi CAP negativo',
        add_user: 'Aggiungi utente',
        generate_password: 'Genera password',
        generate_sku: 'Genera SKU',
        add_group: 'Aggiungi gruppo',
        save: 'Salva',
        add_term: 'Aggiungi termine',
        add_integration: 'Aggiungi integrazione',
        filter: 'Filtra',
        search: 'Cerca',
        register_product: 'Registra Prodotto',
        choose_files: 'Scegli file',
        add_categories: 'Aggiungi categorie',
        add_subcategories: 'Aggiungi sottocategorie',
        add_brand: 'Aggiungi marca',
        close: 'Chiudi',
        add_grade: 'Aggiungi griglia',
        add: 'Aggiungi',
        add_variation: 'Aggiungi variazione',
        confirm_grades: 'Conferma griglie',
        add_catalog: 'Aggiungi catalogo',
        generete_qr_code: 'Genera QR Code',
        personalize: 'Personalizza',
        settings: 'Impostazioni',
        add_interval: 'Aggiungi intervallo',
        add_gateway: 'Aggiungi gateway',
        overview: 'Panoramica',
        view: 'Visualizza',
        load_csv: 'Carica file',
        download_csv: 'Scarica XLSX Standard',
        att_page: 'Aggiorna pagina',
        export: 'Esporta',
        add_service: 'Registra Servizio',
        add_environment: 'Aggiungi ambiente',
        generate_ia: 'Proponi',
        clear_table_card: 'Cancella tavolo o comanda',
        propose_image: 'Proponi immagine',
        cancel: 'Annulla',
        next: 'Avanti',
      },

      global: {
        success: 'Successo',
        error: 'Errore',
        warning: 'Attenzione',
        active: 'Attivo',
        inactive: 'Inattivo',
      },

      modals: {
        warning_confirm: 'Sei sicuro?',
        warning_save: 'Salva',
        warning_close: 'Chiudi',
        text_close: 'Chiudi',
      },

      general: {
        delete_item: 'Vuoi eliminare questo elemento?',
        delete_product_observation:
          'Anche le variazioni di questo prodotto saranno eliminate, vuoi continuare comunque?',
        delete_classification_observation:
          'Eliminando questa categoria, tutti i prodotti ad essa correlati andranno in Generale, vuoi continuare?',
        delete: 'Elimina',
        edit: 'Modifica',
        duplicate: 'Duplica',
        attention: 'Attenzione',
        actions: 'Azioni',
        select: 'Seleziona',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Qui sono elencati gli elementi insieme alle rispettive azioni',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
        save_changes_edit:
          'Compila le informazioni sottostanti e clicca sul pulsante "Salva" per confermare le modifiche',
        save_changes_duplicate:
          'Convalida o modifica le informazioni sottostanti e clicca sul pulsante "Salva" per confermare le modifiche',
        active: 'Attivo',
        inactive: 'Inattivo',
        showing: 'Mostrando',
        of: 'di',
        to: 'a',
        records: 'record',
        type: 'Tipo',
        today: 'Oggi',
        copy: 'Copia',
        linkS3: 'Link',
        linkedS3: 'Collegato',
        downloadS3: 'Scarica',
        downloadedS3: 'Download Avviato',
        copied: 'Copiato',
        copy_link: 'Copia link del venditore',
        test: 'Testa',
        success: 'Successo',
        error: 'Errore',
        email: 'E-mail',
        paymentFree: 'Gratis',
      },

      pluginspaces: {
        hospitality: 'Hotel',
        food: 'Food',
        healthcare: 'Sanità',
        varejo: 'Vendita al dettaglio',
        fashion: 'Moda',
      },

      dashboard: {
        totals_by_products: 'Totali per prodotto',
        totals_by_category: 'Totali per categoria',
        last_orders: 'Ultimi ordini',
        products: 'Prodotti',
        quantity: 'Quantità',
        total: 'Totale',
        category: 'Categoria',
        welcome: 'Benvenuto in Ninegrid',
        describe_dashboard:
          'Qui hai tutti gli strumenti per gestire il tuo negozio in modo semplice ed efficiente. Esplora i menu laterali per navigare nelle nostre funzionalità. Buon lavoro!',
      },

      modalities: {
        modalities: 'Modalità',
        modalitie: 'Modalità',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Qui sono elencate le modalità insieme alle rispettive azioni',
        delivery: 'Consegna',
        withdraw: 'Ritiro',
        active: 'Attivo',
        inactive: 'Inattivo',
        name: 'Nome',
        code: 'Codice',
        actions: 'Azioni',
        search: 'Cerca',
        type: 'Tipo',
        sector_name: 'Nome del settore',
        table: 'Tavolo',
        room: 'Camera',
        counter: 'Bancone',
        internal: 'Consegna Interna',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: 'Tassa di consegna',
        create_delivery_fee: 'Crea tassa di consegna',
        edit_delivery_fee: 'Modifica tassa di consegna',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
        save_changes_edit:
          'Compila le informazioni sottostanti e clicca sul pulsante "Salva" per confermare le modifiche',
        km_min: 'Km Minimo',
        km_max: 'Km Massimo',
        value: 'Valore',
        actions: 'Azioni',
        patterns: 'Modelli di Importazione',
        import_file:
          'Per importare i file, la prima cella del file deve seguire uno dei seguenti modelli:',
        import_delivery: 'Per importare per intervallo: kmmin, kmmax, Valore',
        import_cep: 'Per importare CAP: cap_inizio, cap_fine, valore',
        import_cep_negative: 'Per importare CAP negativo: cap_inizio, cap_fine',
        model: 'Modello',
        continue_import: 'Tutti i tuoi record verranno sostituiti, sei sicuro di voler continuare?',
        cep_delivery: 'CAP di Consegna',
        cep_info: 'Qui sono elencati i CAP di consegna insieme alle rispettive azioni.',
        cep_start: 'CAP Inizio',
        cep_end: 'CAP Fine',
        create_cep: 'Crea CAP di Consegna',
        edit_cep: 'Modifica CAP di Consegna',
        cep_delivery_negative: 'CAP Negativi di Consegna',
        cep_info_negative:
          'Qui sono elencati i CAP negativi di consegna insieme alle rispettive azioni.',
        create_cep_negative: 'Crea CAP Negativo',
        edit_cep_negative: 'Modifica CAP Negativo',
        delete_cep_negative: 'Elimina CAP Negativo',
      },

      user: {
        user: 'Utenti',
        here_are_listed_the_users_along_with_their_respective_actions:
          'Qui sono elencati gli utenti insieme alle rispettive azioni',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
        save_changes_edit:
          'Compila le informazioni sottostanti e clicca sul pulsante "Salva" per confermare le modifiche',
        picture: 'Foto',
        name: 'Nome',
        type: 'Tipo',
        registration: 'Registrazione',
        create_user: 'Crea utente',
        edit_user: 'Modifica utente',
        profile_picture: 'Immagine del profilo',
        password: 'Password',
        generate_pass: 'Genera Password',
        access_level: 'Gruppo di accesso',
        select_a_access_level: 'Seleziona un gruppo di accesso',
        select_type: 'Seleziona un tipo',
        active: 'Attivo',
        actions: 'Azioni',
        discount_permission: 'Permesso di sconto sulla vendita',
        discount_value: 'Valore massimo di sconto (%)',
        phone: 'Numero di telefono',
      },

      groups: {
        groups: 'Gruppi',
        group: 'Gruppo',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'Qui sono elencati i gruppi insieme alle rispettive azioni',
        name: 'Nome',
        Integrations: 'Integrazioni',
        means_of_payment: 'Metodo di pagamento',
        products: 'Prodotti',
        category: 'Categorie',
        subcategory: 'Sottocategoria',
        indicators: 'Indicatori',
        requests: 'Ordini',
        reports: 'Rapporti',
        messenger: 'Messaggistica',
      },

      shifts: {
        shifts: 'Turni',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          'Qui sono elencati i turni per ogni giorno della settimana',
        monday: 'Lunedì',
        tuesday: 'Martedì',
        wednesday: 'Mercoledì',
        thursday: 'Giovedì',
        friday: 'Venerdì',
        saturday: 'Sabato',
        sunday: 'Domenica',
        start: 'Inizio',
        end: 'Fine',
      },

      account: {
        account: 'Account',
        edit_account: 'Modifica account',
        registration_number: 'Codice Fiscale',
        corporate_name: 'Ragione sociale',
        customer_name: 'Nome',
        name_of_the_establishment: 'Nome dello stabilimento',
        subdomain: 'Sottodominio',
        code: 'Codice',
        default_language: 'Lingua predefinita',
        default_currency: 'Valuta predefinita',
        login_of_person_in_charge: "Login del responsabile dell'account",
        name_of_person_in_charge: 'Nome del responsabile',
        address: 'Indirizzo',
        zip_code: 'CAP',
        number: 'Numero',
        neighbourhood: 'Quartiere',
        city: 'Città',
        state: 'Stato',
        public_place: 'Via',
        address_complement: 'Complemento',
        info: 'Per cambiare il sottodominio contatta il supporto',
      },

      terms: {
        terms: 'Termini',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          'Qui sono elencati i termini di accettazione della piattaforma di vendita',
        create_your_term: 'Crea il tuo termine',
        term_name: 'Nome del termine',
        valid_until: 'Valido fino al',
        name: 'Nome',
        expirated: 'Scade',
      },

      payment_plans: {
        payment_plans: 'Piani di pagamento',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          'Qui sono elencati i piani di pagamento insieme alle rispettive azioni',
        create_payment_plans: 'Crea Piani di pagamento',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
        erp_integration: 'Integrazione ERP',
        integration_type: 'Tipo di Integrazione',
        select_an_integration: "Seleziona un'integrazione",
        card_flag: 'Bandeira della Carta',
        flag: 'Bandeira',
        type: 'Tipo',
        erp_code: 'Codice ERP',
        card_installment: 'Rateizzazione',
        payment_plan: 'Piano di pagamento',
        installment: 'Rata',
        time: 'Termine',
        credit: 'Credito',
        debit: 'Debito',
      },

      indicators: {
        indicators: 'Indicatori',
        orders: 'Ordini',
        filters: 'Filtri',
        first: 'Inizio',
        end: 'Fine',
        total_order: 'Totale ordini',
        revenue: 'Fatturato',
        orders_by_location: 'Ordini per modalità',
        orders_by_month: 'Ordini per mese',
        orders_by_day: 'Ordini per giorno',
        orders_by_hour: 'Ordini per ora',
        orders_by_month_sector: 'Ordini per mese e modalità',
        orders_by_day_sector: 'Ordini per giorno e modalità',
        orders_by_hour_sector: 'Ordini per ora e modalità',
        product: 'Prodotti',
        categories: 'Categorie',
        sales_by_category: 'Vendite per categoria',
        revenue_by_category: 'Fatturato per categoria',
        average_ticket: 'Scontrino medio',
        quantity: 'Quantità',
        summary: 'Riepilogo',
        summaryAccess: 'Accessi',
        summaryAccessGroup: 'Aree accessibili per periodo',
        summaryTimeAccessGroup: 'Totale per orario',
        summaryIPAccessGroup: 'Totale per utente',
        summarySellerCart: 'Totale carrelli creati per venditore',
        period: 'Scegli un periodo',
        summaryTypeCust: 'Somma per tipo di costo',
        summaryComposition: 'Composizione dei costi',
        cost: 'Costi',
        customer: 'Clienti',
        seller_sales_by_category: 'Vendite del venditore per categoria',
        summary_seller: 'Riepilogo del Venditore',
        sellers_invoice: 'Fatturato del venditore',
        comparative_sales_by_channel: 'Comparativa vendite per canale',
        select_view: 'Seleziona visualizzazione',
        sales: 'Vendite',
        attended_customers: 'Clienti serviti',
        carts: 'Carrelli salvati',
        sales_conversion: 'Conversione delle vendite',
        mean_ticket: 'Scontrino medio',
        sales_client: 'Comparativa/ Classifica di vendita per clienti',
        sellers: 'Venditori',
        summary_store: 'Riepilogo del Negozio',
        accesses: 'Visite',
        active_sellers: 'Venditori attivi',
        revenue_store: 'Fatturato del Negozio',
        revenue_group: 'Fatturato del Gruppo',
        comparative_sales_by_seller: 'Comparativa vendite per venditore',
        comparative_sales_by_store: 'Comparativa unità di business',
        comparative_by_seller: 'Forza commerciale - Comparativa venditori',
        stores: 'Negozi',
        invoicing: 'Fatturato',
        active_stores: 'Negozi attivi',
        summary_group: 'Riepilogo del Gruppo',
        invoice_by_store: 'Fatturato per negozio',
        rank_sellers: 'Classifica venditori',
        rank_stores: 'Classifica negozi',
      },

      customer_list: {
        customer_list: 'Elenco clienti',
        listed_customers: 'Qui sono elencati i clienti insieme alle rispettive azioni.',
        select_time: 'Periodo degli ordini effettuati',
        name: 'Nome',
        first: 'Inizio',
        end: 'Fine',
        phone: 'Telefono',
        date: 'Data',
        detail: 'Dettagli del Cliente',
        total_profit: 'Profitto Totale',
        total_itens: 'Totale Articoli',
        total_orders: 'Totale Ordini',
        order_between: 'Ordini tra',
        order_detail: "Dettaglio dell'ordine",
        create: 'Crea Cliente',
        go_detail: 'Visualizza dettagli',
        product: 'Prodotto',
        value: 'Valore',
        quantity: 'Qtà.',
        total: 'Totale',
        edit: 'Modifica Cliente',
      },

      smart_order: {
        smart_order: 'Smart Order',
        service_classification: 'Classificazione del Servizio',
        message_warning_find_variation:
          'Cerca una variazione di prodotto per aggiungerla al tuo ordine.',
        product: 'Prodotti',
        create_product: 'Crea Prodotto',
        here_are_listed_the_products_along_with_their_respective_actions:
          'Qui sono elencati i prodotti insieme alle rispettive azioni',
        name: 'Nome',
        code: 'Codice',
        color_code: 'Codice Colore',
        crop_image: 'Ritaglia Immagine',
        use_original_image: 'Usa Immagine Originale',
        select_image_format: 'Seleziona Formato Immagine',
        use_selected_size: 'Usa Dimensione Selezionata',
        format_640x640: '640x640 (Quadrato)',
        format_600x900: '600x900 (Verticale)',
        product_data: 'Dati del Prodotto',
        mark: 'Marca',
        measurement_unit: 'Unità di Misura',
        description: 'Descrizione',
        technical_specification: 'Specifiche Tecniche',
        from: 'di',
        characters: 'caratteri',
        order: 'Ordine',
        product_image: 'Immagini del Prodotto',
        additional_images: 'Immagini Aggiuntive',
        product_groups: 'Gruppi di clienti per il Prodotto',
        categories: 'Categorie',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'Qui sono elencate le categorie insieme alle rispettive azioni',
        image: 'Immagine prodotto',
        image_variation: 'Immagine variazione',
        category: 'Categoria',
        category_parent: 'Categoria Padre',
        category_name: 'Nome della categoria',
        category_code: 'Codice della categoria',
        perfil_image: 'Immagine del profilo',

        subcategories: 'Sottocategorie',
        subcategory: 'Sottocategoria',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'Qui sono elencate le sottocategorie insieme alle rispettive azioni',
        select_category: 'Seleziona una categoria',

        marks: 'Marche',
        listened_marks: 'Qui sono elencate le marche insieme alle rispettive azioni',

        measurements_units: 'Unità di Misura',
        listened_measurement: 'Qui sono elencate le unità di misura insieme alle rispettive azioni',

        grid_products: 'Griglie',
        listened_grid: 'Qui sono elencate le griglie di prodotti insieme alle rispettive azioni',
        grid_name: 'Nome della griglia',
        grid_code: 'Codice',
        variation: 'Variazione',
        grid: 'Griglia',
        grids: 'Griglie',

        variations: 'Variazioni',
        listened_variations:
          'Qui sono elencate le variazioni di prodotti insieme alle rispettive azioni',
        modality: 'Modalità',
        select_modality: 'Seleziona una modalità',
        prod: 'Prodotto',
        select_product: 'Seleziona un prodotto',
        no_variation: 'Prodotto senza variazione',
        variation_product: 'Variazione del prodotto',
        cost_price: 'Prezzo di Costo',
        sell_price: 'Prezzo di Vendita',
        promotional_price: 'Prezzo Promozionale',
        weight: 'Peso',
        height: 'Altezza',
        width: 'Larghezza',
        depth: 'Profondità',
        availability: 'Qual è la disponibilità del prodotto?',
        when_product_stock: 'Quando il prodotto è esaurito in magazzino?',
        stock: 'Quantità di prodotti in magazzino',
        min_stock: 'Scorta minima',
        price: 'Prezzo',

        catalogs: 'Cataloghi',
        catalog: 'Catalogo',
        create_catalog: 'Crea Catalogo',
        edit_catalog: 'Modifica Catalogo',
        catalog_link: 'Copia Link del Catalogo',
        listened_catalogs:
          'Qui sono elencati i cataloghi di prodotti insieme alle rispettive azioni.',
        validity: 'Validità',
        first: 'Inizio',
        end: 'Fine',
        search_products: 'Ricerca Prodotti',

        product_status: 'Stato del prodotto',
        sku: 'SKU/EAN',
        status_variation: 'Stato della variazione',
        specification: 'Specifiche',
        price_promotional: 'Prezzo con sconto',
        inventory: 'Inventario',
        preparation_time: 'Tempo di preparazione',
        service_title: 'Qui sono elencati i servizi insieme alle rispettive azioni.',

        initial_hour: 'Orario iniziale',
        final_hour: 'Orario finale',

        date_start: 'Data Iniziale',
        date_end: 'Data Finale',

        add_group: 'Elenco Aggiuntivi',
        no_add: 'Questo prodotto non è ancora associato a nessun elenco di aggiuntivi.',
        already_add: 'Questo prodotto è associato ai seguenti elenchi di aggiuntivi.',
        associate_add: 'Associa a un elenco di aggiuntivi',
        associate: 'Associa',
        choose_add: 'Scegli gli elenchi di aggiuntivi che saranno associati a questo prodotto.',
        no_group_add: 'Nessun elenco di aggiuntivi disponibile da associare.',
        remove_add: 'Rimuovi associazione',
        remove_add_text:
          'Vuoi rimuovere l\'associazione di questo prodotto con l\'elenco di aggiuntivi "@"?',
        limit_range: 'Limite massimo di intervalli raggiunto',

        remove_add_soon:
          'Attenzione! Questa scheda verrà rimossa a breve. Potrai continuare a gestire i tuoi aggiuntivi normalmente. Accedi alla scheda "Informazioni Base" e vai alla sezione "Gruppo Aggiuntivi" per vedere gli aggiuntivi di questo prodotto.',
        create_image_ia: 'Proposta di Immagine IA',
        create_image_ia_text: 'Fornisci una descrizione del prodotto per generare le immagini.',
        generate_images: 'Genera immagini',
        generate_description: 'Personalizza descrizione',
        generate_new_options: 'Genera nuove opzioni',
        save_image_selected: 'Salva la foto selezionata',
        reference_image_ia: 'Immagine di riferimento',
        image_qtd_ia: 'Quantità di immagini',
        save_img_ia: 'Salva immagini',
        cancel: 'Annulla',

        more_category: 'Vedi più configurazioni di questa categoria',
        selectAll: 'Seleziona Tutti',
        alterLot: 'Modifica Lotto',
        edit_category:
          'Non è permesso cambiare il vincolo di categoria, ti consigliamo di creare una nuova categoria',

        catalog_image: 'Immagine del Catalogo',
      },

      service_grid: {
        service_grid: 'Griglie di Servizi',
        service_grid_single: 'Griglia di Servizio',
        create_service_grid: 'Crea Griglia di Servizi',
        edit_service_grid: 'Modifica Griglia di Servizi',
        service_grid_name: 'Nome della Griglia di Servizi',
        service_grid_name_placeholder: 'Nome della griglia di servizi',
        start_hour: 'Ora Iniziale',
        start_hour_placeholder: '00:00',
        end_hour: 'Ora Finale',
        end_hour_placeholder: '23:59',
        interval: 'Intervallo',
        interval_placeholder: '00:15',
        interval_tooltip: 'Intervallo di tempo tra gli ordini',
        service_list: 'Elenco Servizi',
        service_placeholder: 'Servizi',
        missing_fields: 'Campi mancanti',
        missing_fields_message: 'Verifica di aver compilato tutti i campi!',
        grid_created: 'Griglia registrata',
        grid_created_message: 'Registrazione eseguita con successo!',
        grid_updated: 'Griglia modificata',
        grid_updated_message: 'Modifica eseguita con successo!',
        error: 'Errore',
        error_create_message: 'Errore nella registrazione della griglia!',
        error_update_message: 'Errore nella modifica della griglia!',
        fill_information_create:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
        save_changes_edit:
          'Compila le informazioni sottostanti e clicca sul pulsante "Salva" per confermare le modifiche',
        dashboard: 'Dashboard',
        title: 'Titolo',
        listed_grids: 'Qui sono elencate le griglie di servizi insieme alle rispettive azioni',
        grid_deleted: 'Griglia eliminata',
        grid_deleted_message: 'Eliminazione eseguita con successo!',
        error_delete_message: "Errore nell'eliminazione della griglia!",
        status: 'Stato',
        grid_linked_warning: 'Griglia collegata',
        grid_linked_message:
          'Questa griglia è collegata a {count} modulo/i di servizio e non può essere eliminata.',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: 'Genera QR Code',
        personalize: 'Personalizza',
        settings: 'Impostazioni',
        link: 'Link alla Webapp',

        webapp_data: 'Dati della Webapp',
        name: 'Nome',
        place: 'Luogo',
        product_pagination: 'Quantità di prodotti nella paginazione',
        logo_ninegrid: 'Logo Ninegrid',
        light: 'Chiara',
        dark: 'Scura',
        logo_totvs: 'Logo TOTVS',
        use_icon_menu: 'Usa icona nel menu della Webapp',
        description: 'Descrizione',
        icon: 'Icona',
        color_setting: 'Configurazione dei colori',
        background_webapp: 'Sfondo della Webapp',
        background_default_webapp: 'Colore Predefinito della WebApp',
        background_header: "Sfondo dell'intestazione",
        text_header: "Testo dell'intestazione",
        icon_header: "Icone dell'intestazione",
        background_footer: 'Sfondo del piè di pagina',
        icon_footer: 'Icone del piè di pagina',
        highlight_footer: 'Evidenziazione del piè di pagina',
        notification_cart: 'Notifica del carrello',
        notification_text: 'Testo della notifica',
        home_button: 'Pulsante Home',
        text_home_button: 'Testo del pulsante Home',
        title_bar: 'Barra del titolo',
        text_title_bar: 'Testo della barra del titolo',
        icon_title_bar: 'Icone della barra del titolo',
        text_category: 'Testo delle categorie',
        webapp_button: 'Tema della Webapp',
        text_button: 'Testo dei pulsanti',
        background_menu: 'Sfondo del menu laterale',
        text_menu: 'Testo del menu laterale',
        price_card_background: 'Sfondo della scheda prezzo',
        price_card_font_color: 'Colore del font della scheda prezzo',
        order_status: "Stato dell'ordine",
        order_active_status: "Stato dell'ordine attivo",
        text_order_active_status: "Testo dello stato dell'ordine",
        info_cart: 'Informativa del carrello',

        settings_webapp: 'Impostazioni della Webapp',
        type_delivery: 'Tipo di restrizione di consegna',
        integration: 'Integrazione',
        select_integration: "Seleziona un'integrazione",
        payment_method_card: 'Metodo di pagamento Carta',
        payment_method_pix: 'Metodo di pagamento Pix',
        payment_method_delivery: 'Metodo di pagamento alla consegna',
        consent_letter: 'Attiva lettera di consenso',
        product_no_stock: 'Vendita di prodotti senza magazzino',
        show_subcategory: 'Mostra sottocategoria',
        show_observation: 'Mostra osservazione',
        use_category_list: 'Mostra sottocategorie e prodotti in elenchi',
        use_category_list_v2: 'Mostra categorie e sottocategorie in elenchi',
        use_product_list: 'Mostra prodotti in elenchi',
        remove_shadow: 'Non aggiungere ombra a categorie e cataloghi',
        remove_show_mode: 'Rimuovi modalità di visualizzazione',
        no_shadow: 'Non aggiungere ombra alle categorie',
        is_order_number: 'Ordina categoria',
        order_number: 'Per ordine',
        order_category: 'Alfabetica',
        show_layout: 'Mostra Layout',
        image_type: "Stile dell'immagine del prodotto",

        withdraw_fee: 'Tassa di Ritiro',
        minimum_value: "Valore Minimo dell'Ordine",
        seller_checkout: 'Modalità del Checkout',

        no_sales: 'Non consentire vendite',
        safe_mode: 'Modalità sicurezza',
        time_safe_mode: 'Tempo di Sessione della Modalità sicurezza (in minuti)',
        limit_characteres_explanation:
          'Per negozi con integrazione Wintor o Protheus, il massimo raccomandato è di 50 caratteri.',
        limit_characteres: 'Limite di caratteri',

        skip_entry: 'Salta schermata iniziale',
        payment_table: 'Pagamento al tavolo',

        payment_card: 'Pagamento alla comanda',

        slides_homePage: 'Immagini in Evidenza HomePage',
        slides_initial: 'Immagini in Evidenza Iniziali',

        slides_not_found: 'Nessuna immagine dello slider trovata',

        externalLink: 'Link esterno',
        buttonType: 'Tipo di Pulsante',
        ableUserLocation: 'Permetti ricerca indirizzo per localizzazione',
        ableWaiter: 'Disattiva opzione per chiamare cameriere',
        closeAccountButton: 'Rimuovi pulsante di chiusura conto',
        emitNfChef: "Emetti Fattura dopo il pagamento dell'ordine? (Bancone/Tavolo/Comanda)",

        seller_cart_limit_time: 'Tempo di scadenza del carrello del venditore per ora',
        seller_cart_limit_time_explanation:
          'Tempo massimo in cui il cliente può utilizzare il carrello del venditore',
        settings_webapp_aggregator: 'Personalizza',
        generate_qrcode_webapp_aggregator: 'Genera QR code',
        qrcode_webapp_aggregator: 'Applicazione Web',
        security_settings: 'Impostazioni di sicurezza',
        biometric_authentication: 'Autenticazione Biometrica',
        code_scanner: 'Consenti la lettura di codici a barre e codici QR',
        maximus_radius: 'Localizzazione: Raggio di prossimità permesso (in metri)',
        access_maximus: 'Numero massimo di accessi per tavolo',
        limit_time: 'Tempo di accesso per la comanda scadere (in minuti)',
        password: "Password per sbloccare l'accesso",
        flag_discount: 'Formato del flag di sconto',
        color_flag_discount: 'Colore del tag',

        config_tags: 'Configura Tag',
        promotional_tags: 'Tag promozionale',

        pre_created: 'Pre-registrazione',

        show_classification_button: 'Mostra pulsante per visualizzare tutte le categorie',
        show_catalog_button: 'Mostra pulsante per visualizzare tutti i cataloghi',
        show_catalog_name: 'Mostra nome dei cataloghi',
        show_classification_name: 'Mostra nome delle categorie',
        show_mark_name: 'Mostra marca dei prodotti',
        show_stock_quantity: 'Mostra magazzino dei prodotti',
        show_promotional_tags: 'Mostra Etichetta Promozionale',
        show_product_sku: 'Mostra sku del prodotto',
        tag_display_groups: 'Mostra gruppi di tag nella lista dei prodotti',
        text_free_delivery: 'Testo personalizzato per consegna o ritiro gratuito',
        tooltip_free_delivery:
          'Se compilato, questo testo verrà visualizzato quando la consegna o il ritiro è gratuito. Se vuoto, verrà visualizzato il valore R$ 0,00',
        place_holder_free_delivery: 'Es: Gratuito',
        no_show_grid: 'Ometti griglie di variazioni uniche del prodotto',
        explain_show_grid:
          'Nasconde le griglie con variazioni uniche. Le griglie con opzioni multiple (es: taglie L; XL) rimarranno visibili nella selezione del prodotto, ma nascoste in altri luoghi.',

        type_image: 'Tipo di Immagine',
        type_image_square: 'Quadrata',
        type_image_rectangle: 'Rettangolare',

        directlink: 'Link Diretto',
        infoDirectLink:
          "Non obbligatorio, solo quando è necessario inviare direttamente a un'altra pagina o sito, massimo 350 caratteri",

        block_add_in_limit: 'Blocca aggiunta al limite',

        family_fonte: 'Famiglia del Carattere',
        rounding_images: 'Arrotondamento delle Immagini',
        rounding_bars: 'Arrotondamento delle Barre',
        color_icons: 'Colore delle icone',
        color_icons_header_footer: "Colore delle icone nell'intestazione e nel piè di pagina",
        background_icon_button: 'Colore di sfondo delle icone',
        background_icon_custom: 'Colore personalizzato',
        restaurant_list: 'Mostra ristoranti in elenchi',
        restaurant_display_mode: 'Modifica modalità di visualizzazione dei ristoranti',
        icon_button_size: 'Dimensione delle icone dei pulsanti',
        shadow_image: "Ombra dell'Immagine",
        black_logo_nine: 'Logo Ninegrid Scuro',
        skip_loud_screen: 'Salta schermata di caricamento',
        can_acesse_restaurant:
          'Consentire la visualizzazione del catalogo (Negozio/Ristorante) senza login',
        info_acesse_restaurant:
          "L'attivazione di questo flag consente all'utente di accedere al menu/catalogo del ristorante o del negozio senza necessità di effettuare il login. Nel caso in cui esista un'integrazione di pagamento attiva, il login verrà richiesto direttamente nella WebApp del negozio o ristorante, prima della fase di pagamento, affinché l'ordine sia correttamente associato al contesto dell'utente (profilo/prenotazione) nel sistema dell'hotel.",
      },

      integration: {
        integration: 'Integrazione',
        means_of_payment: 'Metodo di Pagamento',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          'Qui sono elencati i metodi di pagamento insieme alle rispettive azioni',
        PDV: 'Integrazione POS',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          'Qui sono elencate le integrazioni insieme alle rispettive azioni',
        integration_name: "Nome dell'Integrazione",
        type_of_integration: 'Tipo di Integrazione',
        actions: 'Azioni',
        search: 'Cerca',
        example: 'Esempio di Payload',

        loads: 'Carichi',
        name: 'Nome',
        price: 'Prezzo',
        stock: 'Magazzino',
        measurements_units: 'Unità di Misura',
        grid: 'Griglie',
        classifications: 'Categorie',
        products: 'Prodotti',
        status_sync: 'Sincronizzazione dello Stato',
        marks: 'Marche',
        orders: 'Ordini',
        trigger_load: 'Attiva Carico',
        first: 'Inizio',
        end: 'Fine',
        load: 'Carica',
        messenger: 'Messaggistica',
        others: 'Altri',
        test: "Vuoi testare l'integrazione",
        params_test: 'Vedi parametri di questa integrazione',
        copy_params: 'Copia parametri',
        result_test: "Risultati del test dell'integrazione",
        success_1: "Successo! L'integrazione",
        success_2: 'è andata a buon fine.',
        result_log: 'Log del risultato',
        copy_result: 'Copia risultato',
        search_result: 'Cerca nei risultati',
        error_1: "L'integrazione",
        error_2: 'ha restituito un errore. Controlla il log sottostante per maggiori informazioni.',

        success_food_1: "Successo! L'integrazione",
        success_food_2: 'è andata a buon fine.',
        error_food_1: "L'integrazione",
        error_food_2: 'ha restituito offline.',

        integrationPrint: 'Testa Connessione',
      },

      reports: {
        orders: 'Ordini',
        order_report: 'Rapporto Ordini',
        order_list: 'Elenco Ordini',
        first: 'Inizio',
        end: 'Fine',
        firstTime: 'Ora iniziale',
        endTime: 'Ora finale',
        orders_between: 'Ordini tra',
        order_number: "Numero dell'Ordine",
        date: 'Data',
        consumer: 'Consumatore',
        modality: 'Modalità',
        total_value: 'Valore',
        cancel_order: 'Annulla ordine',

        products: 'Prodotti',
        quantity: 'Quantità',
        qtt: 'Qtà',
        product: 'Prodotto',
        value: 'Valore',
        total: 'Totale',
        order_status: "Stato dell'Ordine",
        payment_method: 'Metodo di pagamento',
        billing_address: 'Indirizzo di fatturazione',
        product_value: 'Valore dei prodotti',
        discount: 'Sconto',
        order: 'Ordine',

        listened_logs: 'Qui sono elencati i log insieme alle rispettive azioni.',
        methods: 'Metodi',
        log_details: 'Dettagli del Log',

        withdraw: 'Ritiro',
        delivery: 'Consegna',
        table: 'Tavolo',
        counter: 'Bancone',
        responsible_withdraw: 'Responsabile del ritiro',
        responsible_delivery: 'Responsabile della ricezione',
        address_withdraw: 'Indirizzo di ritiro',
        address_delivery: 'Indirizzo di consegna',
        seller: 'Venditore',
        seller_link: 'Link del Venditore',
        external_code: 'Numero esterno',
        payment: 'Pagamento',
        internal_delivery: 'Consegna Interna',
        origin: 'Origine',
        historial: "Storico dell'ordine",
        approval_moment: "Data e ora dell'approvazione",
        id: 'Codice della Prenotazione',
        pluginspace: 'Hotel',
        hotel: "Ordine associato all'hotel",
        document: 'Documento della Prenotazione',
        room: 'Codice Camera',
        status_payment: 'Stato del pagamento',
        authorization_code: 'Codice di autorizzazione',
        transaction: 'ID della transazione',
        made_in: 'Eseguito il',
        send_method: 'Metodo di invio',
        send_date: 'Data di invio',
        estimated_delivery: 'Previsione di consegna',
        freight: 'Spedizione',
        tracking_code: 'Codice di tracciamento',
        website: 'Apri sito di tracciamento',
        label: 'Stampa etichetta di spedizione',
        payment_delivery: 'Pagamento alla consegna',
        payment_money: 'Pagamento in contanti',
        change_money: 'Resto',
        label_code: 'Etichetta',
        label_website: "Apri sito dell'etichetta",
        declaration_code: 'Dichiarazione',
        declaration_website: 'Apri sito della dichiarazione',
        height: 'Altezza (cm)',
        width: 'Larghezza (cm)',
        length: 'Lunghezza (cm)',
        weight: 'Peso (kg)',
        send_text: 'Modalità di invio scelta dal cliente: ',
        success_label: 'La tua etichetta di spedizione è stata generata con successo.',
        continue: 'Continua',
        confirm: 'Conferma',
        change_multiple_status: 'Cambia stato di più ordini',
        change_status_text: 'Vuoi cambiare lo stato degli ordini sottostanti?',
        new_status: 'Nuovo stato',
        change_status: 'Cambia stato',

        synkar: 'Automazione',
        invalid_data: 'Per favore, seleziona le date di inizio e fine.',

        details: 'Dettagli',
      },

      imports: {
        imports: 'Importazioni',
        import_image_product: 'Importazioni di Immagini per Prodotti',
        import_image_category: 'Importazioni di Immagini per Categorie',
        listened_import_product:
          'Qui sono elencate le importazioni di immagini per prodotti insieme alle rispettive azioni.',
        no_upload_images: 'Non effettuare upload di immagini',
        first: 'Inizio',
        end: 'Fine',
        total_products: 'Totale Prodotti',
        sync_products: 'Prodotti Sincronizzati',
        import_image_sku: 'Importazioni di Immagini per Variazioni',
        listened_import_sku:
          'Qui sono elencate le importazioni di immagini per variazioni insieme alle rispettive azioni.',
        verify_verification: 'Verifica della variazione',
        product_code: 'Codice del prodotto',
        code: 'Codice',
        total_variations: 'Totale Variazioni',
        sync_variations: 'Variazioni Sincronizzate',
        total_categories: 'Totale Categorie',
        sync_categories: 'Categorie Sincronizzate',
        problem_title: 'Immagini con problema',
        images_success: 'immagini sono state inviate con successo.',
        images_error: 'immagini hanno presentato un problema e non sono state inviate.',
        file: 'File',
        status: "Stato dell'importazione",
        new_import: 'Esegui nuova importazione',
        import_xls: 'Importa immagini con file XLS',
        import_repo: 'Importa immagini da Google Drive o Dropbox',
        steps: "Passo passo per l'importazione",
        step_1: '1. Inserisci tutte le immagini in un server web pubblico.',
        step_2: '2. Verifica che il server sia pubblico e accessibile via web.',
        step_3: '3. Scarica il nostro file XLSX vuoto.',
        step_4: '4. Compila con i dati della tua banca immagini.',
        step_5: '5. Carica il file compilato.',
        step_1_repo:
          '1. Verifica che la cartella del negozio sia creata come "fotos_loja_<identificatore del negozio>".',
        step_2_repo: '2. Crea la cartella "produtos" all\'interno della cartella del tuo negozio.',
        step_2_repo_sku:
          '2. Crea la cartella "variacoes" all\'interno della cartella del tuo negozio.',
        step_2_repo_category:
          '2. Crea la cartella "categorias" all\'interno della cartella del tuo negozio.',
        step_3_repo:
          '3. Conferma che i file siano nel formato "<codice del prodotto>.<estensione>".',
        step_3_repo_sku: '3. Conferma che i file siano nel formato "<sku>.<estensione>".',
        step_3_repo_category:
          '3. Conferma che i file siano nel formato "<codice della categoria>.<estensione>".',
        step_4_repo: '4. Se si tratta di un prodotto aggiuntivo, verifica che abbia "_<numero>".',
        step_4_repo_sku:
          "4. Conferma che la variazione sia un'immagine e sia in formato JPG o PNG.",
        step_4_repo_category:
          "4. Conferma che la categoria sia un'immagine e sia in formato JPG o PNG.",
        step_5_repo: "5. Conferma che il prodotto sia un'immagine e sia in formato JPG o PNG.",
        download: 'Scarica il file XLSX vuoto',
        download_problems: 'Esporta rapporto',
        upload: 'Invia file',
        upload_anex: 'Allega file',
        import_dropbox: 'Importa con Dropbox',
        import_drive: 'Importa con Google Drive',
        spreadsheet: 'Foglio di calcolo',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'Tipo',
        type_resize: 'Tipo di Ridimensionamento',
        agroup_color: 'Raggruppa foto per colore',
        banner_size: 'Tratta categoria N1 come banner',
        select_dimensions: 'Seleziona le dimensioni',
        square: 'Tratta come 640x640',
        vertical: 'Tratta come 600x900',
      },

      sms: {
        sms: 'SMS',
        listened_sms: 'Qui sono elencati i messaggi (SMS) insieme alle rispettive azioni.',
        order: 'Ordine',
        name: 'Nome',
        message: 'Messaggio',
        markers: 'I marcatori [pedido] e [status] devono essere nel messaggio',
        waiting: 'In attesa',
        opened: 'Aperto',
        ready: 'Pronto',
        refused: 'Rifiutato',
        message_hotel: 'SMS Hotel',
        listened_sms_hotel:
          "Qui sono elencati i messaggi dell'hotel insieme alle rispettive azioni.",
        status_hotel: 'Stato Hotel',
        listened_status_hotel:
          "Qui sono elencati gli stati e i messaggi dell'hotel insieme alle rispettive azioni.",
        edit_status: 'Modifica stato',
        edit_status_hotel: 'Modifica stato hotel',
        notification: 'Notifica',
        email_group_status: 'Stato',
        email_group_service_forms: 'Moduli di Servizio',
        email_group_services: 'Servizi',
        email_group_services_booking: 'Servizi - Booking',
        send_email_simple: 'Invia e-mail',
        status_label: 'Stato',
        write_message_status: 'Scrivi qui un messaggio per questo stato',
        markers_hotel:
          'I marcatori [pedido], [status], [cliente], [quarto], [hotel] devono essere nel messaggio',
        status_updated: 'Stato aggiornato',
        status_update_success: 'Aggiornamento completato con successo!',
        status_update_error_title: 'Errore',
        status_update_error: "Errore durante l'aggiornamento dello stato!",
      },

      multichannel: {
        multichannel: 'Multicanale',
        listened_multichannel:
          'Qui sono elencate le configurazioni multicanale insieme alle rispettive azioni.',
      },

      feed: {
        content: 'Contenuto',
        title: 'Titolo',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Compila le informazioni sottostanti e clicca sul pulsante "Crea" per salvare le modifiche',
      },
      feedCategory: {
        feedCategory: 'Categoria del Contenuto',
      },

      structured_content: {},

      queue: {
        index: "Coda d'attesa",
        menage: 'Gestione',
        config: "Configurazioni della coda d'attesa",
        able: "Permetti coda d'attesa",
        link: "Link della coda d'attesa:",
        limit_people: 'Numero massimo di persone',
        limit_people_text: "Limite della coda d'attesa",
        limit_time: "Limite di tempo per visualizzare l'avviso",
        limit_time_text: 'Tempo massimo in minuti per considerare in ritardo',
        image_title: 'Definizione di immagini',
        image_text:
          'Il sistema di coda visualizza 2 immagini. Carica foto del tuo ristorante o seleziona foto predefinite qui sotto. Le foto inviate saranno adattate alla dimensione di 350x250 pixel.',
        image: 'Immagine',
        position: 'Posizione',
        time: 'Tempo di attesa',
        people: 'persone',
        cancel: 'Annullamento',
        cancel_text: "Vuoi rimuovere questa persona dalla coda d'attesa?",
        cancel_button: 'Rimuovi',
        confirm: 'Conferma',
        confirm_text: "Vuoi confermare l'arrivo del prenotante?",
        confirm_button: 'Conferma arrivo',
        empty: "Nessuna lista d'attesa al momento",
        confirm_all: 'Conferma tutti',
        cancel_all: 'Annulla tutti',
        observation: 'Osservazione',
        use_terms: 'Attiva termini di consenso',
        total_people: 'Totale persone per gruppo',
        total_people_text: "Limite della coda d'attesa per gruppo",
        all: 'Tutti',
        in_queue: 'In coda',
        preferential: 'Preferenziale',
        confirmed: 'Confermato',
        removed: 'Rifiutato',
        show: 'Visualizza',
        show_text: 'Ultime @ ore',
        yes: 'Sì',
        no: 'No',
        add: 'Aggiungi Cliente alla Coda',
        use_location: 'Permetti localizzazione?',
        use_menu: 'Vuoi utilizzare il menu?',
        use_ninegrid_menu: 'Utilizzare il menu Ninegrid?',
        external_menu_link: 'Fornisci il link del menu',
        edit: 'Modifica Cliente in Coda',
      },
      booking: {
        index: 'Prenotazione',
        config: 'Configurazioni della prenotazione',
        able: 'Permetti prenotazione',
        link: 'Link della prenotazione:',
        image_title: 'Definizione di immagini',
        image_text:
          'Il sistema di prenotazione visualizza 2 immagini. Carica foto del tuo ristorante o seleziona foto predefinite qui sotto. Le foto inviate saranno adattate alla dimensione di 350x250 pixel.',
        image: 'Immagine',
        days_week: 'Giorni della settimana',
        booking_day: 'Permetti prenotazioni in questo giorno?',
        booking_day_text: 'Definisci di seguito gli orari consentiti per le prenotazioni.',
        booking_day_subtext:
          'Selezionando un orario verrà definita una finestra di 1 ora. Esempio: selezionando 19:00 le persone potranno effettuare prenotazioni tra le 19:00 e le 20:00.',
        max_people: 'Numero massimo di persone per prenotazione',
        max_people_text:
          'È la dimensione massima di un gruppo di persone che può effettuare una prenotazione',
        expiry_time: 'Tempo massimo fino alla scadenza della prenotazione',
        expiry_time_text: "Tempo in minuti per attendere l'arrivo del prenotante",
        day_confirm: 'Richiedi conferma il giorno stesso',
        day_confirm_text: "L'utente deve confermare la prenotazione nella data scelta",
        payment_confirm: 'Richiedi pagamento anticipato nella prenotazione',
        value_payment_confirm: 'Valore del pagamento anticipato',
        week: 'Settimana',
        month: 'Mese',
        year: 'Anno',
        use_terms: 'Attiva termini di consenso',
        empty: 'Nessuna prenotazione al momento',
        use_time: 'Permetti prenotazione per periodo',
        time: 'Durata della prenotazione (HH:mm)',
        time_cancel: 'Termine per la cancellazione della prenotazione (HH:mm)',
        time_change: 'Termine per la modifica della prenotazione (HH:mm)',
        use_change: 'Consenti modifica della prenotazione',
      },
      booking_day: {
        booking: 'Prenotazioni del giorno',
        date: 'Data',
        people: 'persone',
        expiry: 'Scade tra',
        cancel_title: 'Annullamento',
        cancel_subtitle: 'Vuoi annullare questa prenotazione?',
        cancel_button: 'Annulla prenotazione',
        confirm_title: 'Conferma',
        confirm_subtitle: "Vuoi confermare l'arrivo del prenotante?",
        confirm_button: 'Conferma arrivo',
        accessibility_needs: 'Esigenza di Accessibilità',
        accessibility_elderly: 'Supporto per Anziani',
        accessibility_wheelchair: 'Utente su Sedia a Rotelle',
        accessibility_physical: 'Disabilità Fisica',
        filter_accessibility: 'Filtra per Accessibilità',
        all_accessibility: 'Tutte le esigenze',
      },
      booking_report: {
        report: 'Rapporti',
        search: 'Ricerca prenotazioni',
        time: 'Seleziona il periodo',
        date_start: 'Data inizio',
        date_end: 'Data fine',
        confirm: 'Conferma',
        noShow: 'Non presentato',
        confirmed: 'Prenotazioni confermate',
        canceled: 'Prenotazioni annullate',
        open: 'Aperto',
        map: 'Mappa delle prenotazioni',
        booking: 'prenotazioni',
        accessibility_stats: 'Statistiche di Accessibilità',
        accessibility_total: 'Totale con esigenze',
        accessibility_percentage: 'Percentuale',
      },
      booking_report_management: {
        management: 'Gestione prenotazioni',
        search: 'Ricerca prenotazioni',
        phone: 'Telefono',
        date_start: 'Data inizio',
        date_end: 'Data fine',
        today: 'Oggi',
        tomorrow: 'Domani',
        calendar: 'Calendario',
        see_all: 'Vedi tutte',
        people: 'persone',
        noShow: 'Non presentato',
        confirmed: 'Confermata',
        canceled: 'Annullata',
        open: 'Aperto',
        search_text: 'Risultati della ricerca per telefono o selezione data',
      },
      environment: {
        map: 'Mappa degli ambienti',
        environment: 'Ambiente',
        index: 'Ambienti',
        name: "Nome dell'ambiente",
        tables: 'Numero di tavoli',
        seats_available: 'Totale posti disponibili',
        actions: 'Azioni',
      },
      week_day: {
        sun: 'Dom',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thur: 'Gio',
        fri: 'Ven',
        sat: 'Sab',
      },
      week_day_full: {
        sun: 'Domenica',
        mon: 'Lunedì',
        tue: 'Martedì',
        wed: 'Mercoledì',
        thur: 'Giovedì',
        fri: 'Venerdì',
        sat: 'Sabato',
      },
      checkout: {
        title: 'Dati del Cliente',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Qui sono elencati i campi necessari per la creazione del cliente.',
        active_mandatory: 'Campo Obbligatorio',
        active_visibility: 'Campo Visibile',
      },

      liveShop: {
        liveShop: 'Live Commerce',
        liveShop_list:
          'Qui sono elencati gli eventi di Live Commerce insieme alle rispettive azioni.',
        create: 'Crea Live Commerce',
        edit: 'Modifica Live Commerce',
        dateInit: 'Inizio',
        hourInit: 'Ora di Inizio',
        dateEnd: 'Fine',
        hourEnd: 'Ora di Fine',
        status: 'Stato',
        initDate: 'Data e Ora di Inizio',
        fimDate: 'Data e Ora di Fine',
        name: 'Nome',
        variations: 'Variazioni del Prodotto',
        search_products_Attentions:
          'I Prodotti e le Variazioni restituiti devono avere stato attivo, prezzo, magazzino e immagine',
        alert_delete: 'Non è possibile rimuovere un Live quando è iniziato o è terminato!',
        alert_Edit: 'Non è possibile modificare un Live quando è iniziato o è terminato!',
        delete: 'Elimina Live Commerce',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Errore codice telefono Pagseguro',
        pagseguroPaymentErrorCountry: 'Errore codice Paese Pagseguro',
        pagseguroPaymentErrorEmail: 'Errore email Pagseguro',
        authenticatePagseguro: 'Autenticazione Pagseguro',
        pagseguroPayment: 'Pagamento Pagseguro',
        pagseguroPaymentCatch: 'Pagamento Pagseguro',
        pagseguroPaymentResponse: 'Risposta del pagamento Pagseguro',
        pagseguroPaymentTransactions: 'Transazione del pagamento Pagseguro',
        pagseguroReturnPayment: 'Restituzione del pagamento Pagseguro',
        paymentPixPagseguro: 'Pagamento Pix Pagseguro',

        pagseguroPaymentGateway: 'Gateway di pagamento Pagseguro',
        getAuthPagseguroEmailSpace: 'Autenticazione Pagseguro per email',
        getOneApplicationClientId: 'Prendi applicazione del cliente Pagseguro',
        createAuthPagseguro: 'Crea autenticazione Pagseguro',
        generatePublicKeyPagseguro: 'Genera chiave pubblica Pagseguro',
        updateCodeRedirectApplication:
          'Aggiornamento del Codice di reindirizzamento applicazione Pagseguro',
        deleteAuthPagseguroByEmail: 'Rimuovi autenticazione Pagseguro',
        createPluginconfig: 'Configurazione del plugin',

        //Totvs pagamento HUB
        refundTotvs: 'Storno tramite Totvs',
        refundPayCard: 'Storno tramite Totvs per carta',
        paymentTotvs: 'Pagamento tramite Totvs',
        paymentPixTotvs: 'Pagamento Pix tramite Totvs',

        //Struttura della Carta
        sendUnregisteredCardBrands: 'Bandeira non trovata',
        cardStructure: 'Struttura della carta',
        cardStructureInvalidPlugin: 'Plugin non valido per il gateway',
        cardStructureGatewayError: 'Errore della carta per il gateway',
        cardStructureData: 'Dati della Carta',
        cardStructureError: 'Errore nei Dati della carta',
        cardStructureDecrypt: 'Decrittografia della carta',
        cardStructureFields: 'Campi della Carta',
        refundCard: 'Storno della Carta',

        //Stato
        analysisSatusOrder: "Stato dell'ordine per analisi",
        statusPayPix: 'Stato Pix',

        //Antifrode
        analyseAntifraud: 'Analisi Antifrode',
        dataClearSale: 'Dati ClearSale',
        statusAnalysis: "Stato dell'Analisi",

        //magazzino
        addSkuInventory: 'Aggiungi al magazzino',
        subtractSku: 'Rimuovi dal magazzino',
        viewCargoHistory: 'Visualizza storico del carico',
        viewCargoHistoryBySku: 'Visualizza storico del carico per SKU',

        // Ordine-Pedido
        sendOrderIn: "Invio dell'ordine",
        cancelOrder: 'Annulla Ordine',
        sendOrder: 'Invia Ordine',
        sendOrderRefund: "Storno dell'Ordine",
        sendOrderError: "Errore nell'invio dell'ordine",
        sendOrderResultRefund: "Risultato dello storno dell'ordine",
        sendOrderResultData: "Risultato dell'invio dell'ordine",
        sendOrderAntifrud: "Antifrode nell'invio dell'ordine",
        sendOrderPaymentStruct: "Struttura del pagamento dell'ordine",

        sendOrderDescryptor: "Decrittografia dell'Ordine",
        sendOrderStatus: "Stato dell'ordine",
        sendOrderConfigNotFound: "Configurazione dell'invio dell'ordine",
        sendOrderMandatoryCustomer: "Cliente dell'ordine",
        sendOrderMandatory: "Struttura obbligatoria dell'ordine",
        sendOrderResultGateway: "Risultato dell'invio al gateway",
        OrderFashionService: 'Servizio di ordine Fashion',
        OrderFashionServiceError: 'Errore nel servizio di ordine Fashion',
        cartOrderLive: "Carrello dell'ordine Live",
        cartOrderLiveError: "Errore nel carrello dell'ordine Live",
        sendOrderErrorGeral: "Errore nell'ordine",
        sendPushNotification: 'Invia notifica push',

        //Pre-Ordine
        preOrderStatusPix: 'Stato del Pre-ordine tramite Pix',
        processQueuePreOrder: 'Elaborazione della coda del pre-ordine',
        getAllPreOrderBySpace: 'Prendi tutti i pre-ordini per pluginspace',
        sendPreOrder: 'Invio del Pre-ordine',
        makeOrderTransparent: 'Verifica ordine',
        statusPreOrder: 'Aggiornamento dello Stato Pix del Pre-ordine',
        preOrderStatusCanceledPix: 'Annulla Pre-ordine tramite Pix',

        //Totvs Wintor
        buildOrderTotvsWinthor: 'Crea Ordine',
        sendOrderWinthor: "Invio dell'ordine a Totvs",
        sendCustomerOrderWinthor: 'Invio del cliente a Totvs',

        //Totvs Vendita al Dettaglio
        buildOrderTotvsVarejo: 'Crea Ordine',
        setConfimTicket: 'Conferma del Ticket',
        SyncOrderLive: 'Sincronizzazione degli Ordini',
        ObterProdutos: 'Ottieni Prodotti',
        taskPrice: 'Carico Prezzo',
        calculationPromotion: 'Calcolo Promozione',
        PayloadCalcPromotion: 'Payload Calcolo Promozione',

        //Totvs Moda
        changeStatus: 'Cambio di Stato',
        sendOrderFashion: "Invio dell'ordine a Totvs",
        sendCustomerFashion: 'Invio del cliente a Totvs',
        searchPersonTotvsByCPF: 'Ricerca Cliente Totvs',
        sendErrorCustomerFashion: "Errore nell'invio del Cliente a Fashion",
        buildCustomerTotvsFashion: 'Creazione cliente in Totvs',
        ResumeSnyOrderFashion: 'Riepilogo sincronia con Fashion',
        changeStatusFashion: 'Cambia Stato',
        buildOrderTotvsFashion: 'Crea Ordine Fashion',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'Cambio di Stato',
        buildOrderTotvsFood: 'Crea Ordine',
        changeStatusOrderFood: 'Cambio di Stato',
        sendOrderTotvsFood: "Invio dell'ordine a Totvs",
        confirmMenu: 'Menu Confermato',
        getMenu: 'Prendi Menu Totvs',

        //Totvs Live
        sendCustomerLive: 'Invio del Cliente Live',
        sendOrderLive: 'Invio Ordine Live',

        //Synkar
        updateStatusOrderSynkar: 'Aggiornamento Ordine Synkar',
        sendingOrderMessageSynkar: 'Invio Messaggistica Synkar',
        responseOrderMessageSynkar: 'Risposta Messaggistica Synkar',
        sendingOrderSynkar: 'Invio Synkar',
        responseOrderSynkar: 'Risposta Synkar',

        //SDS
        sdsGetOrders: 'Prendi gli ordini SDS',
        sdsOrderIn: 'Invio degli ordini SDS',
        sdsOrderInResult: "Invio dell'ordine a SDS",
        sdsSyncCardapio: 'Sincronia del menu con SDS',
        'sendOrderfood-sdsOrderIn': "Errore nell'inviare l'ordine SDS",

        //S3
        createRoute: 'Crea Rotta S3',
        getStatusfiftythree: 'Stato Rotta 53',
        updateDistribution: 'Aggiorna Distribuzione',
        deleteRoute: 'Elimina Rotta S3',
        deleteDistribution: 'Elimina Distribuzione',

        //Erede
        refundErede: 'Storno Erede',
        paymentErede: 'Pagamento Erede',

        //Cielo
        refundCielo: 'Storno Cielo',
        paymentCielo: 'Pagamento Cielo',

        //Pagseguro
        refundPagseguro: 'Storno Pagseguro',
        getApplicationPagseguro: 'Gateway Applicazione Pagseguro',

        //pagamento offline
        paymentOffline: 'Pagamento alla consegna',

        //Generale
        chargeSyncOrderErro: 'Errore nella Sincronia dello Stato',
        chargeSyncOrder: 'Sincronia dello Stato',
        chargeProductLive: 'Sincronia dei Prodotti Live',
        chargeBalanceLive: 'Sincronia del Magazzino Live',
        chargePriceLive: 'Sincronia dei Prezzi Live',
        chargeProductLiveErro: 'Errore nella Sincronia dei Prodotti Live',
        chargeBalanceLiveErro: 'Errore nella Sincronia del Magazzino Live',
        chargePriceLiveErro: 'Errore nella Sincronia dei Prezzi Live',

        chargeProduct: 'Sincronia dei Prodotti',
        chargeBalance: 'Sincronia del Magazzino',
        chargePrice: 'Sincronia dei Prezzi',
        chargeProductErro: 'Errore nella Sincronia dei Prodotti',
        chargeBalanceErro: 'Errore nella Sincronia del Magazzino',
        chargePriceErro: 'Errore nella Sincronia dei Prezzi',

        taskBalanceIntegration: 'Integrazione del Carico di magazzino',
        taskBalanceCharge: 'Carico di magazzino avviato',
        SnyOrder: "Sincronizzazione dello stato dell'ordine",
        syncronyzePriceInteration: 'Carico Prezzo',
        syncronyzePrice: 'Sincronizzazione Prezzo',
        chargeClassification: 'Carico di categoria e sottocategoria',
        chargeGrid: 'Carico di griglia',
        chargeGridItens: 'Elementi del Carico di griglia',
        chargeMeasure: 'Carico di unità di misura',
        deleteAllProducts: 'Elimina tutti i Prodotti',

        chargeGridToken: 'Token per il carico di Griglia',
        classificationChargeToken: 'Token per il carico di Classificazione',
        syncronyzeBalanceToken: 'Token per la sincronizzazione di Magazzino',
        syncronyzePriceToken: 'Token per la sincronizzazione di Prezzo',
        chargeMeasureToken: 'Token per il carico di Unità di Misura',
        taskClassificationBySpace: 'Carico di Classificazione',
        syncStatusOrderPayload: "Payload di Sincronizzazione dello Stato dell'Ordine",
        syncStatusOrder: "Sincronizzazione dello Stato dell'Ordine",
        syncStatusOrderToken: "Token di Sincronizzazione dello Stato dell'Ordine",
        syncronyzeBalancePayload: 'Payload di Sincronizzazione di Magazzino',
        syncronyzeBalance: 'Sincronizzazione di Magazzino',
        taskBalanceChargeBySpace: 'Carico di Magazzino',
        syncronyzePricePayload: 'Payload di Sincronizzazione di Prezzo',
        priceSkuVariationItens: 'Prezzo degli Elementi della Variazione',
        configSyncOrderBySpace: 'Configurazione di Sincronizzazione Ordine',
        configSyncOrder: 'Configurazione di Sincronizzazione Ordine',
        taskGridChargeBySpace: 'Carico di Griglia',
        productChargeInternal: 'Carico di Prodotto',
        taskChargeProductBySpace: 'Carico di Prodotto',
        skuLocationVariation: 'Sincronizzazioni di Variazione per Località',
        stockSkuVariation: 'Sincronizzazioni di Variazione',
        taskPriceChargeBySpace: 'Carico di Prezzo per Pluginspace',

        automaticChargeBalance: 'Sinc Auto Magazzino',
        automaticChargePrice: 'Sinc Auto Prezzo',
        automaticChargeClassification: 'Sinc Auto Classificazione',
        automaticTaskGridCharge: 'Sinc Auto Griglia',
        automaticTaskMeassure: 'Sinc Auto Unità Misura',
        automaticSnyOrder: 'Sinc Auto Stato Ordini',
        chargeMeasureItens: 'Elementi del carico di Unità Misura',
        searchMeasurementAll: 'Carico di unità di misura',
        taskGridCharge: 'Carico di Griglia',
        taskMeassure: 'Carico di unità di misura',

        getCredential: 'Ottieni Token',
        LoadPricePerList: 'Carico Prezzi',
        processPriceList: 'Elaborazione della Lista Prezzi',
        updateProductKit: 'Aggiornamento dei Prodotti',
        UpdateProductSingle: 'Aggiornamento dei Prodotti',
        updateProductStatus: 'Aggiornamento dello Stato del Prodotto',
        taskBalanceIntegrationLink: 'Link di integrazione magazzino',
        taskPriceIntegrationLink: 'Link di integrazione prezzo',
        taskProductIntegrationLink: 'Link di integrazione prodotto',
        token: 'Ottenimento del Token',
        automaticChargeProduct: 'Carico automatico di prodotti',

        //Sconto Ninegrid
        calculateDiscount: 'Calcolo dello sconto in Ninegrid',
        sendDiscountNinegrid: 'Sconto Ninegrid',

        //Carrello Cliente
        updateCustomerCartStatus: 'Aggiornamento del carrello del Cliente',

        //Cliente
        createCustomer: 'Creazione del Cliente',
        validCodeCustomer: 'Codice di validazione del Cliente',

        //clearSale
        statusAnalisis: 'Analisi dello Stato',
        antifraudValidation: "Validazione dell'antifrode",
        clearSale: 'ClearSale Garantito',
        searchOrderStatusClearSale: 'Ricerca Stato ClearSale',

        printLabelFrenet: 'Etichetta Frenet',
        changeStatusFrenet: 'Cambio di stato Frenet',
        callWaiter: 'Chiama Cameriere',
        paymentTable: 'Pagamento al tavolo',

        // Generazione della Fattura del Cuoco
        generateNfOrderFood: "Genera fattura dell'ordine",
        getNotaFiscalChef: 'Recupera fattura del Cuoco',
        finishOrderFood: 'Controllo preliminare alla fattura',

        // Log di errore dell\'ordine del Cuoco
        buildCardData: 'Errore nella creazione dei dati per Comanda',
        buildTableData: 'Errore nella creazione dei dati per Tavolo',
        buildTablePaymentData: 'Errore nella creazione dei dati per Pagamento Tavolo',
        buildCounterData: 'Errore nella creazione dei dati per Bancone',
        buildDeliveryData: 'Errore nella creazione dei dati per Consegna/Ritiro',

        generateCustomerWholeSalerByCSV: "Genera cliente all'ingrosso tramite CSV",

        validateStockWholeSaleCart: 'Avviso di ordine',
        validateWholeSaleCart: 'Avviso di ordine',

        chargeImageService: 'Servizio di carico di immagini',

        webhookNisRedis: 'Pulizia del Redis del Negozio',

        /*Invio email  */
        sendEmailWelcome: 'Invia email di benvenuto',
        sendEmailOrderNotification: 'Invia notifica via email di ordine',
        sendEmailAccountNotification: 'Invia notifica via email di account',
        createCustomerLogin: 'Invia email di creazione login cliente',
        /*Seller Queue */
        sellerOrderFilterPDVTotvsPersistResponse: 'Persistenza del filtro degli ordini del PDV Totvs',
        sellerOrderFilterPDVTotvsPersistRequest: 'Richiesta del filtro degli ordini del PDV Totvs',
      },

      copy: {
        definition: 'Definizione di Pluginspace',
        origin: 'Seleziona il Pluginspace di origine',
        destination: 'Seleziona il Pluginspace di destinazione',
        configurations: 'Configurazioni della copia',
        store: 'Impostazioni del Negozio',
        deliveryFee: 'Tassa di consegna',
        shifts: 'Turni',
        paymentPlans: 'Piani di pagamento',
        clientData: 'Dati del Cliente',
        account: "Configurazioni dell'Account",
        groups: 'Gruppi',
        terms: 'Termini',
        webapp: 'Webapp',
        webappConfig: 'Configurazioni',
        webappPersonalize: 'Personalizzazione',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: 'Configurazioni',
        whatsappwebPersonalize: 'Personalizzazione',
        integrations: 'Integrazioni',
        integrationPayment: 'Metodi di pagamento',
        integrationPdv: 'POS',
        integrationMessaging: 'Messaggistica',
        integrationOthers: 'Altri',
        button: 'Copia Pluginspace',
      },

      payment: {
        methods: 'Metodi di pagamento',
        method: 'Metodo di pagamento',
        gateway: 'Gateway di pagamento',
        card: 'Carta di credito',
        debit: 'Carta di debito',
        food: 'Buono pasto',
        pix: 'Pix',
        others: 'Altri',
        pay_money: 'Contanti',
        config: 'Configurazioni',
        add: 'Configura metodo di pagamento',
        back: 'Torna ai gateway di pagamento',
        basic_settings: 'Configurazioni base',
        modalities: 'Modalità in cui verrà utilizzato questo metodo di pagamento',
        add_payment: 'Aggiungi metodo di pagamento',
        code_erp: 'Codice ERP',
        installments: 'Numero di rate',
        edit_payment: 'Modifica metodo di pagamento',
        delete: 'Elimina metodo di pagamento',
        money: 'Pagamento in contanti',
        max_installments: 'Qual è il numero massimo di rate?',
        min_value_installments: 'Qual è il valore minimo per le rate?',
        confirm: 'Conferma eliminazione',
        delete_payment: 'Vuoi eliminare il metodo di pagamento',
        change: 'Vuoi effettuare questo scambio?',
        inative: 'Vuoi disattivare questo metodo di pagamento?',
        inative_change: 'Vuoi attivare questo metodo di pagamento e disattivare il precedente?',
        motive: 'Per favore fornisci il motivo',
        /* usato per sconto */
        config_descount_payment: 'Configurazione di sconto per metodo di pagamento',

        able_discount_pix: 'Abilita sconto per pagamento Pix',
        able_discount_card: 'Abilita sconto per pagamento con Carta',
        able_discount: 'Abilita sconto per pagamento',

        discount_percentage: 'Sconto Percentuale',
        discount_monetary: 'Sconto Monetario',
        discount_value: 'Valore dello sconto',
      },

      icon: {
        title: 'Icone',
        subtitle: 'Qui sono elencate tutte le icone della libreria',
      },
      freight: {
        title: 'Modalità di invio',
        map: 'Mappa',
        map_text: "Opzione per pagamento alla consegna dell'ordine",
        range: 'Raggio',
        range_text: "Opzione per pagamento alla consegna dell'ordine",
        cep: 'Elenco CAP',
        cep_text: "Opzione per pagamento alla consegna dell'ordine",
        config: 'Configurazioni',
        delivery: 'Consegna propria',
        delivery_text: 'Ci sono 3 opzioni di consegna personalizzabili:',
        frenet: 'Frenet',
        frenet_text: 'Gestione completa delle spedizioni con diversi corrieri e mezzi di invio.',
        frenet_text_2: 'Per abilitare questa integrazione è necessario avere un piano Frenet.',
        site: 'Vedi il sito ufficiale',
        coming_soon: 'Prossimamente...',
      },
      frenet: {
        title: 'Integrazione con Frenet',
        back: 'Torna ai metodi di consegna',
        integration: 'Integrazione',
        config: 'Configurazioni',
        dimensions: 'Dimensioni base di consegna in centimetri',
        height: 'Altezza',
        width: 'Larghezza',
        length: 'Lunghezza',
        value: 'Valore dichiarato dei prodotti',
        use: 'Utilizza',
        dont_use: 'Non utilizzare',
        price: 'Usare quotazione semplificata?',
        yes: 'Sì',
        no: 'No',
        branchCode: 'Punto di spedizione Jadlog',
        no_balance: 'Nessun saldo in Frenet',
        value_balance: 'Hai @ di saldo in Frenet',
        print_balance:
          "Per stampare l'etichetta di spedizione di questo ordine è necessario caricare saldo sul tuo account Frenet.",
        click_balance: "Clicca sul pulsante qui sotto per accedere a Frenet in un'altra scheda.",
        open_balance: 'Apri account Frenet',
        valid_token: 'Token non valido',
        declared_value:
          'Il valore dichiarato è utilizzato in caso di assicurazione da parte del corriere.',
        getToken:
          'Per trovare il token in Frenet, è necessario accedere alla sezione delle chiavi di accesso e copiare il valore del campo "TOKEN".',
        weight_frenet: 'Peso standard (kg)',
        height_frenet: 'Altezza standard (cm)',
        width_frenet: 'Larghezza standard (cm)',
        depth_frenet: 'Profondità standard (cm)',
        alert_title: 'Dimensioni di riferimento per il calcolo della spedizione',
        alert_warning: 'Attenzione!',
        alert_description:
          'Queste misure verranno utilizzate per calcolare la spedizione dei prodotti senza volumetria registrata.',
        alert_wrong_values: 'Valori errati possono generare:',
        alert_overpriced: 'Spedizioni sovraccaricate (allontanando i clienti).',
        alert_additional_costs: 'Costi aggiuntivi (se il corriere adegua il valore in seguito).',
        alert_recommendation: 'Raccomandiamo di registrare la volumetria reale di ogni prodotto.',
        alert_reference: 'Dimensioni di riferimento:',
        alert_small_products: 'Prodotti piccoli',
        alert_small_examples: '(es: accessori, bigiotteria, cavi)',
        alert_small_weight: 'Peso: 0,1–0,3 kg',
        alert_small_dimensions: 'Dimensioni: 10 × 10 × 5 cm',
        alert_medium_products: 'Prodotti medi',
        alert_medium_examples: '(es: vestiti, libri, piccoli dispositivi elettronici)',
        alert_medium_weight: 'Peso: 0,5–2 kg',
        alert_medium_dimensions: 'Dimensioni: 25 × 20 × 10 cm',
        alert_large_products: 'Prodotti grandi',
        alert_large_examples: '(es: elettrodomestici, scatole voluminose)',
        alert_large_weight: 'Peso: 5–20 kg o più',
        alert_large_dimensions: 'Dimensioni: 50 × 40 × 30 cm o maggiori',
      },
      chat: {
        you: 'Tu',
        now: 'Inviato ora',
        send: 'Invia',
        type_message: 'Invia un messaggio...',
        initial_message: 'Benvenuto/a nella chat IA di Ninegrid',
        error_message:
          'Non sono riuscito a trovare una risposta per il tuo messaggio, potresti essere più specifico o riprovare più tardi.',
        tip_language: 'Rispondi in italiano per favore.',
        title_config: 'Configurazioni di Intelligenza Artificiale',
        config: 'Configura Intelligenza Artificiale',
        fit: "Addestramento dell'Intelligenza Artificiale",
        fit_header: 'Qui sono elencate le domande con le rispettive risposte create',
        add_question: 'Aggiungi domanda',
        edit_question: 'Modifica domanda',
        delete_question: 'Vuoi eliminare la domanda sottostante?',
        question: 'Domanda',
        answer: 'Risposta',
        date: 'Data',
        actions: 'Azioni',
        active: 'Attivo',
        delete: 'Elimina',
        sync: 'Sincronizza IA',
        upload: 'Caricamento del file',
        about: 'Informazioni',
        chatia: 'Chat',
        about_title: 'Informazioni su Ninegrid IA',
        about_description_title: 'Descrizione',
        about_description:
          'Ninegrid IA è un assistente virtuale intelligente progettato per aiutarti con le attività di supporto.',
        about_support_title: 'Supporto',
        about_support_description:
          'Se hai domande o hai bisogno di aiuto, il nostro team di supporto è pronto ad assisterti.',
        about_support_contact_1: 'Per parlare con il supporto, contattaci via email',
        about_support_contact_2: 'o apri un ticket nel nostro portale:',
        about_features_title: 'Funzionalità',
        tips: 'Suggerimenti per creare le tue domande',
        about_tips_1: 'Usa domande chiare e obiettive per ottenere risposte migliori.',
        about_tips_2: 'Evita gergo o termini tecnici complessi.',
        about_tips_3: 'Se la risposta non è soddisfacente, prova a riformulare la domanda.',
        about_tips_4:
          'Ninegrid IA impara dalle interazioni, quindi più lo usi, migliore diventerà.',
        feature_1: 'Conversazione in linguaggio naturale',
        feature_2: 'Supporto ai comandi vocali',
        feature_3: 'Sintesi vocale per le risposte',
        feature_4: 'Interfaccia intuitiva e reattiva',
        about_manuals: 'Manuali',
        about_manuals_description:
          "Consulta i nostri manuali per saperne di più su come utilizzare l'Ambiente Ninegrid,",
        about_faq: 'Domande Frequenti',
        about_faq_description:
          'Vedi le domande più frequenti e le loro risposte per chiarire dubbi comuni,',
        about_version_title: 'Informazioni sul Sistema',
        version: 'Versione',
        last_update: 'Ultimo aggiornamento',
        rights_reserved: 'Tutti i diritti riservati',
        access_here: 'accedi qui',
        our_faq: 'vedi le domande frequenti',
        or: 'o',
        and: 'e',
      },
      sumary_access: {
        cart: 'Carrello',
        seller: 'Login Venditore',
        category: 'Categorie',
        pdv: 'Dettagli del Prodotto',
        subcategory: 'Sottocategoria',
        product: 'Elenco Prodotti',
        home: 'Schermata Iniziale',
        'search-order': 'Ordini',
        'store-info': 'Informazioni sul Negozio',
        customer: 'Registrazione cliente',
        receipt: 'Ricevuta di pagamento',
        order: 'Pagamento',
        card: 'Pagamento con Carta',
        'order-qrcode': 'Pagamento Pix Cliente',
        'success-order': "Successo dell'Acquisto",
        'filter/pdv': 'Risultato dei Filtri',
        filter: 'Selezione dei Filtri',
        'seller-qrcode': 'Link di Pagamento',
        'vendor-order ': 'Consultazione del carrello del Venditore',
        'finalize-order': "Riepilogo dell'acquisto",
      },
      optional: {
        optionals: 'Aggiuntivi',
        list: 'Elenco Aggiuntivi',
        name: 'Nome',
        used: 'Utilizzato in',
        config: 'Configura',
        link: 'Associa prodotti',
        products_optional: "Prodotti associati all'elenco",
        edit: 'Modifica elenco aggiuntivi',
        type: 'Tipo di selezione',
        max: 'Massimo',
        mandatory: 'Obbligatorio',
        order: 'Ordine',
        code: 'Codice',
        qtd: 'Qtà massima',
        price: 'Prezzo',
        include: 'Includi un aggiuntivo',
        create: 'Crea elenco aggiuntivi',
        description: 'Descrizione webapp',
        emptyProduct: 'Nessun prodotto sta utilizzando questo aggiuntivo',
      },

      coupons: {
        title: 'Coupon',
        report: 'Rapporti sui Coupon',
        titleCreate: 'Crea Coupon',
        titleUpdate: 'Modifica Coupon',
        subTitle: 'Qui sono elencati i coupon insieme alle rispettive azioni.',
        create: 'Crea Coupon',
        edit: 'Modifica Coupon',
        delete: 'Elimina Coupon',

        //variabili dell'input
        name: 'Nome del Coupon',
        name_helper: 'Massimo 15 caratteri',
        description: 'Descrizione',
        description_placeholder: 'dovrà accettare un massimo di 200 caratteri',
        seller: 'Venditore',
        catalog: 'Catalogo',
        discountValue: 'Valore dello Sconto',
        discountPercentage: 'Percentuale dello Sconto',
        type: 'Tipo',
        dateInit: 'Data di inizio',
        dateEnd: 'Data di fine',
        quantitative: 'Quantità di utilizzi',
        typeOptions: {
          all: 'Tutti i Tipi',
          classification: 'Classificazione',
          product: 'Prodotto',
          individuality: 'Individuale',
          exclusive: 'Esclusivo',
          quantitative: 'Quantitativo',
          periodical: 'Periodico',
          cupomday: 'Giorno del Coupon',
        },
        filters: 'Filtri',
        status: 'Stato',
        selectStatuses: 'Seleziona stati',
        actions: {
          filter: 'Filtra',
          export: 'Esporta',
        },
        quick: {
          today: 'Oggi',
          week: 'Questa settimana',
          month: 'Questo mese',
          lastMonth: 'Mese scorso',
          year: "Quest'anno",
        },
        stats: {
          title: 'Statistiche Generali',
          totalCoupons: 'Totale Coupon',
          activeCoupons: 'Coupon Attivi',
          totalUsages: 'Totale Utilizzi',
          totalDiscount: 'Totale Scontato',
        },
        distribution: {
          title: 'Distribuzione per Tipo',
        },
        monthlyUsage: {
          title: 'Utilizzo Mensile',
        },
        series: {
          usageCount: 'Conteggio degli utilizzi',
          numberOfUses: 'Numero di utilizzi',
          discountValue: 'Valore dello sconto',
        },
        table: {
          details: 'Dettagli Coupon',
        },
        statusLabels: {
          true: 'Attivo',
          false: 'Inattivo',
        },
        statusOptions: {
          all: 'Tutti',
          active: 'Attivo',
          inactive: 'Inattivo',
          expired: 'Scaduto',
        },
      },

      order_print: {
        title: "Controlla le informazioni dell'ordine prima di confermare la stampa",
        print_text: 'Stampa',
        information:
          'QZ Tray richiederà il permesso per stabilire la connessione. Clicca su "Allow" per procedere con la stampa.',
        order_details: "Dettagli dell'Ordine",
        client: 'Cliente',
        payment: 'Pagamento',
        created: 'Creato',
        print: 'Stampa Ordine',
        print_confirm:
          'Vuoi stampare questo ordine? Assicurati che la stampante sia collegata e configurata correttamente prima di procedere',
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle: 'Qui sono elencate le configurazioni di WhatsApp insieme alle rispettive azioni.',
        titleCreate: 'Sincronizza WhatsApp',
        titleDelete: 'Rimuovi Sincronizzazione WhatsApp',
        create: 'Sincronizza WhatsApp',
        delete: 'Elimina Sessione WhatsApp',
        active: 'Attivo',
        welcome: 'WhatsApp Web di Ninegrid',
        describe_whatsappweb:
          'Qui è possibile effettuare il collegamento di WhatsAppWEB con il cellulare del negozio!',
        config: 'Per configurare WhatsApp',
        step1: 'Apri WhatsApp sul tuo cellulare.',
        step2: 'Tocca Altre opzioni ⋮ su Android o Impostazioni ⚙️ su iPhone.',
        step3: 'Tocca Dispositivi collegati e, quindi, Collega un dispositivo.',
        step4: 'Punta il tuo cellulare su questa schermata per scansionare il QR code.',
      },
      fileManagement: {
        title: 'Gestore File',
        subtitle: 'Qui sono elencati i file insieme alle rispettive azioni.',
        create: 'Crea File',
        edit: 'Modifica File',
        delete: 'Elimina File',
        download: 'Scarica File',
        upload: 'Carica File',
        file: 'File',
        file_name: 'Nome del File',
        file_item: 'Elemento',
        file_itens: 'Elementi',
        file_type: 'Tipo di File',
        file_size: 'Dimensione del File',
        file_date: 'Data di Creazione',
        file_actions: 'Azioni',
        file_folder: 'Cartella',
        file_new_folder: 'Nuova Cartella',
        file_folder_name: 'Nome della Cartella',
        file_last_modified: 'Ultima Modifica',
        file_description: 'Descrizione del File',
        file_description_placeholder: 'Descrizione del file',
        file_description_helper: 'Massimo 200 caratteri',
        file_name_placeholder: 'Nome del file',
        file_name_helper: 'Massimo 15 caratteri',
        file_page_showing: 'Mostrando',
        file_not_found: 'Nessun file trovato',
        file_uploading: 'Caricamento del file',
        file_upload: 'Carica File',
        file_changing: 'Modifica del file',
        file_Loading: 'Caricamento dei file',
        file_update: 'Aggiorna',
        file_sync_knowledge_base: 'Sincronizza Base di Conoscenza',
        file_history_sync: 'Storico di Sincronizzazione',
        scanned: 'Scannerizzato',
        indexed: 'Indicizzato',
        modified: 'Modificato',
        completed: 'Completato',
        deleted: 'Eliminato',
        failed: 'Fallito',
        available: 'Disponibile',
        last_update: 'Ultimo aggiornamento',
        status: 'Stato',
        status_job: 'Stato del Lavoro',
        data_source: 'Fonte di Dati',
        knowledge_base: 'Base di Conoscenza',
        history_sync: 'Storico di Sincronizzazione',
        chart_scanned_doc: 'Documenti Scannerizzati',
        chart_indexed_doc: 'Documenti Indicizzati',
        chart_modified_doc: 'Documenti Modificati',
        chart_deleted_doc: 'Documenti Eliminati',
        chart_failed_doc: 'Documenti Falliti',
        chart_docs_processed: 'Documenti Elaborati',
        chart_docs_total: 'Totale Documenti',
        total_jobs_processed: 'Totale Lavori Elaborati',
        jobs_info: 'Informazioni sui Lavori',
        observation_table_jobs_phase:
          'La Tabella dei Lavori Elaborati presenta gli ultimi 5 lavori di ogni fonte di dati.',
      },
      service_requests: {
        title: 'Moduli di Servizio',
        subtitle: 'Gestisci i moduli di richiesta di servizi',
        create: 'Crea Modulo di Servizio',
        edit: 'Modifica Modulo di Servizio',
        delete: 'Elimina Modulo di Servizio',
        create_form: 'Crea Modulo',
        edit_form: 'Modifica Modulo',
        delete_form: 'Elimina Modulo',
        form_title: 'Titolo',
        form_icon: 'Icona',
        form_status: 'Stato',
        form_description: 'Descrizione',
        form_components: 'Componenti',
        form_grids: 'Griglie',
        priority_label: 'Priorità',
        priority_low: 'Bassa',
        priority_normal: 'Normale',
        priority_high: 'Alta',
        priority_critical: 'Critica',
        choose_icon: 'Scegli',
        add_component: 'Aggiungi',
        sections: 'Sezioni',
        empty_message: 'Clicca su "Aggiungi" per inserire componenti e trascina per riordinare.',
        success_created: 'Il modulo di servizio è stato creato con successo.',
        success_updated: 'Il modulo di servizio è stato aggiornato con successo.',
        success_deleted: 'Modulo di servizio eliminato con successo.',
        error_create: 'Si è verificato un errore durante la creazione del modulo di servizio.',
        error_update: "Si è verificato un errore durante l'aggiornamento del modulo di servizio.",
        error_delete: "Errore nell'eliminare il modulo di servizio.",
        error_load: 'Errore nel caricare!',
        validation_title: 'Per favore, inserisci un titolo per la sessione',
        validation_icon: "Per favore, scegli un'icona per la sessione",
        validation_components: 'Aggiungi almeno un componente prima di salvare',
        placeholder_title: 'Es.: Pulizia',
        icon_selected: 'Icona selezionata (SVG)',
        icon_none: 'Nessuna icona selezionata',
        visual_instructions:
          'Crea visivamente la sessione. Trascina per riordinare. I campi sono solo visivi (non interattivi).',
        component: 'componente',
        components_plural: 'componenti',
        grid: 'griglia',
        grids_plural: 'griglie',
        grid_services: 'Griglie di Servizi',
        grid_services_title: 'Seleziona Griglie di Servizi',
        grid_services_search: 'Cerca griglie',
        grid_services_label: 'Griglie',
        grid_services_selected: 'Griglie selezionate',
        grid_services_error: "Errore nel cercare le griglie dell'hotel",
        add_component_modal: 'Aggiungi componente',
        validation_grids_required: 'Griglie obbligatorie',
        validation_grids_text:
          'Tutti i componenti di selezione devono avere almeno una griglia di servizi selezionata.',
        actions: 'Azioni',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_essential_services: 'Servizi Essenziali',
        // Elementi UI
        drag_title: 'Trascina',
        drag_action: 'Trascina',
        remove_title: 'Rimuovi',
        remove_aria_label: 'Rimuovi blocco',
        max_quantity_title: 'Quantità massima:',
        max_prefix: 'Max:',
        description_label: 'Descrizione',
        sections_label: 'Sezioni',
        // Titoli e azioni dei modal
        select_icon_title: 'Seleziona',
        no_icons_available: 'Nessuna icona disponibile…',
        search_placeholder: 'Digita per cercare...',
        grid_services_selected_label: 'Selezionate:',
        no_grid_found: 'Nessuna griglia trovata',
        no_grid_available: 'Nessuna griglia disponibile',
        grid_status_active: 'Attivo',
        grid_status_inactive: 'Inattivo',
        grid_item_name_placeholder: 'Nome (Es.: Massaggio Rilassante)',
        grid_item_value_placeholder: 'Valore (Es.: 50,00)',
        cancel_button: 'Annulla',
        save_button: 'Salva',
        confirm_button: 'Conferma',
        // Modal Quantità
        max_quantity_modal_title: 'Definisci Quantità Massima',
        max_quantity_label: 'Quantità massima',
        max_quantity_placeholder: 'Inserisci la quantità massima',
        max_quantity_helper:
          'Definisce il numero massimo di elementi che possono essere selezionati in questo campo.',
        // Breadcrumb
        breadcrumb_create: 'Crea',
        breadcrumb_edit: 'Modifica',
        // Componenti del modulo
        sample_service_1: 'Servizio 1',
        sample_service_2: 'Servizio 2',
        sample_hygiene: 'Igiene',
        sample_drinks: 'Bevande',
        room_number_label: 'Numero della camera',
        select_placeholder: 'Seleziona...',
        date_label: 'Data',
        hour_label: 'Ora',
        quantity_label: 'Quantità',
        between_placeholder: 'Tra',
        and_placeholder: 'e',
        select_list_label: 'Selezione (elenco)',
        select_item_placeholder: 'Seleziona un elemento',
        select_checkbox_label: 'Selezione (checkbox)',
        // Visibility
        visible_to_label: 'Visibile a',
        visible_to_employees: 'Dipendenti',
        visible_to_customers: 'Clienti',
        visible_to_both: 'Entrambi',
        select_category_placeholder: 'Seleziona una categoria',
        select_quantity_label: 'Selezione (quantità)',
        qty_label: 'Qtà.',
        // Titoli Catalogo
        catalog_room_number: 'Numero della camera',
        catalog_date: 'Data',
        catalog_hour: 'Ora',
        catalog_date_hour: 'Data + Ora',
        catalog_select_list: 'Selezione (elenco)',
        catalog_select_list_quantity: 'Selezione (Elenco) + Quantità',
        catalog_select_checkbox: 'Selezione (checkbox)',
        catalog_select_count: 'Selezione (quantità)',
        catalog_quantity: 'Quantità',
      },
      base_modal: {
        attention_title: 'Attenzione!',
        unsaved_changes_text: 'Le modifiche apportate andranno perse, sei sicuro di voler uscire?',
        confirm_button: 'Sì',
        cancel_button: 'No',
      },
      summarize_ia: {
        title: 'Riepilogo Utilizzo IA',
        subtitle: "Qui sono elencate le informazioni di riepilogo dell'IA.",
        create: 'Crea Riepilogo IA',
        edit: 'Modifica Riepilogo IA',
        delete: 'Elimina Riepilogo IA',
        summarize: 'Riepiloga',
      },
      hospitality: {
        add_room: 'Aggiungi Camera',
        create_multiples: 'Crea Multipli',
        add_activity: 'Aggiungi Attività',
        add_experience: 'Aggiungi Esperienza',
        experiences: 'Esperienze ',
        experience_type: 'Tipo di Esperienza',
        experience_duration: 'Durata',
        experience_price: 'Prezzo',
        experience_rating: 'Valutazione',
        experience_includes: 'Include',
        create_experience: 'Crea Esperienza',
        edit_experience: 'Modifica Esperienza',
        experience_created: 'Esperienza creata con successo!',
        experience_updated: 'Esperienza aggiornata con successo!',
        experience_deleted: 'Esperienza eliminata con successo!',
      },
      hospitality_content: {
        page_title: 'Pulsanti',
        page_subtitle: 'Qui sono elencati i pulsanti per le sezioni.',
        add_button: 'Aggiungi Pulsante',
        filters: {
          sections: 'Sezioni',
        },
        table: {
          headers: {
            title: 'Titolo',
            order: 'Ordine',
            formTitle: 'Titolo del Modulo',
            type: 'Tipo',
            visibility: 'Visibilità',
            actions: 'Azioni',
          },
        },
        tabs: {
          buttons: 'Pulsanti',
          native_buttons: 'Pulsanti Nativi',
        },
        actions: {
          edit: 'Modifica pulsante',
          delete: 'Elimina pulsante',
          delete_confirm: 'Sei sicuro di voler eliminare questo pulsante?',
        },
        type_labels: {
          service_form: 'Moduli di Servizio',
          feedback: 'La Tua Opinione',
          service: 'Servizi',
          information: 'Informazioni',
          activities_leisure: 'Attività e Tempo Libero',
          bars_restaurants: 'Bar e Ristoranti',
          schedule: 'Prenotazione',
          experience: 'Esperienza',
          booking: 'Programmazione',
          check_in: 'Check-in',
          check_out: 'Check-out',
          tours: 'Tour',
          page_dynamic: 'Pagina Dinamica',
        },
        no_category: 'Nessuna categoria',
        messages: {
          filter_error_title: 'Errore',
          filter_error_text: 'Errore durante il filtro delle sezioni',
          load_error_title: 'Errore di caricamento',
          load_error_text: 'Impossibile caricare le sezioni!',
          section_not_found_title: 'Errore',
          section_not_found_text: 'Sezione non trovata!',
          deleted_title: 'Sezione eliminata',
          deleted_text: 'Eliminazione eseguita con successo!',
          delete_error: "Errore durante l'eliminazione della sezione!",
          visibility_updated_title: 'Visibilità Aggiornata',
          visibility_updated_text: 'La visibilità del pulsante è stata aggiornata con successo!',
          visibility_error_title: 'Errore di Aggiornamento',
          visibility_error_text: 'Errore durante l’aggiornamento della visibilità del pulsante!',
          form: 'Modulo',
          page: 'Pagina',
        },
        create_modal: {
          modal_title: 'Aggiungi Contenuto',
          alert_title: 'Selezione di Sezione e Contenuto',
          alert_subtitle: 'Seleziona la sezione e il contenuto corrispondenti.',
          label_section: 'Sezione',
          label_content: 'Contenuto',
          placeholder_select: 'Seleziona',
          placeholder_select_section: 'Seleziona la sezione',
          placeholder_select_content: 'Seleziona il contenuto',
          order_label: 'Ordine',
          selection_summary: 'Riepilogo della selezione:',
          badge_section: 'Sezione',
          badge_content: 'Contenuto',
          select_form_label: 'Seleziona il modulo (roomService)',
          tips_title: 'Suggerimenti',
          tips: {
            item1: 'La sezione può avere più contenuti',
            item2: 'Il contenuto può appartenere a più sezioni',
            item3: "L'ordine definisce la posizione nell'elenco",
          },
          buttons: {
            cancel: 'Annulla',
            create: 'Crea',
          },
          swal: {
            missing_field_title: 'Campo mancante',
            missing_section: 'Seleziona una sezione per continuare',
            missing_content: 'Seleziona un contenuto per continuare',
            invalid_field_title: 'Campo non valido',
            invalid_order: "L'ordine deve essere un numero positivo o zero",
            created_title: 'Contenuto registrato',
            created_text: 'Registrazione completata con successo!',
            create_error: 'Errore durante la registrazione del contenuto!',
          },
        },
        edit_modal: {
          modal_title: 'Modifica Contenuto',
          alert_title: 'Modifica Contenuto',
          alert_subtitle:
            "Modifica la sezione e l'ordine se necessario. Il contenuto attuale non può essere modificato.",
          label_section: 'Sezione',
          label_content: 'Contenuto',
          placeholder_select: 'Seleziona',
          placeholder_select_section: 'Seleziona la sezione',
          placeholder_select_content: 'Seleziona il contenuto',
          order_label: 'Ordine',
          selection_summary: 'Riepilogo della selezione:',
          badge_section: 'Sezione',
          badge_content: 'Contenuto',
          tips_title: 'Suggerimenti',
          tips: {
            item1: 'Puoi modificare solo la sezione',
            item2: "L'ordine definisce la posizione nell'elenco",
          },
          buttons: {
            cancel: 'Annulla',
            save: 'Salva',
          },
          swal: {
            missing_field_title: 'Campo mancante',
            missing_section: 'Seleziona una sezione per continuare',
            missing_content: 'Seleziona un contenuto per continuare',
            invalid_field_title: 'Campo non valido',
            invalid_order: "L'ordine deve essere un numero positivo o zero",
            updated_title: 'Contenuto aggiornato',
            updated_text: 'Aggiornamento completato con successo!',
            update_error: "Errore durante l'aggiornamento del contenuto!",
          },
        },
        category: {
          page_title: 'Sezioni',
          page_subtitle:
            'Qui sono elencate le sezioni di contenuto insieme alle rispettive azioni.',
          add_button: 'Aggiungi',
          breadcrumbs: {
            dashboard: 'Dashboard',
            categories: 'Categorie',
          },
          table: {
            headers: {
              section: 'Sezione',
              order: 'Ordine',
              status: 'Stato',
              actions: 'Azioni',
            },
          },
          options: {
            edit_category: 'Modifica categoria',
            delete_section: 'Elimina sezione',
            delete_confirm: 'Elimina sezione',
          },
          swal: {
            deleted_title: 'Sezione eliminata',
            deleted_text: 'Eliminazione eseguita con successo!',
            delete_error: "Errore durante l'eliminazione della sezione!",
          },
          create: {
            missing_fields_title: 'Campi mancanti',
            missing_fields_text: 'Verifica di aver compilato tutti i campi correttamente!',
            created_title: 'Categoria registrata',
            created_text: 'Registrazione completata con successo!',
            create_error: 'Errore durante la registrazione della categoria!',
          },
          update: {
            missing_fields_title: 'Campi mancanti',
            missing_fields_text: 'Verifica di aver compilato tutti i campi correttamente!',
            updated_title: 'Categoria aggiornata',
            updated_text: 'Modifica completata con successo!',
            update_error: "Errore durante l'aggiornamento della categoria!",
          },
          type: {
            default: 'Standard',
            banner: 'Bannière en Vedette',
          },
        },
      },
      clean_safe: {
        title: 'Clean & Safe',
        subtitle: 'Gestisci misure di sicurezza, protocolli di pulizia e certificazioni',
        security_measures: 'Misure di Sicurezza',
        cleaning_protocols: 'Protocolli di Pulizia',
        certifications: 'Certificazioni',
        add_security_measure: 'Aggiungi Misura',
        add_cleaning_protocol: 'Aggiungi Protocollo',
        add_certification: 'Aggiungi Certificazione',
        add_new_security_measure: 'Aggiungi Nuova Misura',
        add_new_cleaning_protocol: 'Aggiungi Nuovo Protocollo',
        add_new_certification: 'Aggiungi Nuova Certificazione',
        security_measure: 'Misura di Sicurezza',
        cleaning_protocol: 'Protocollo di Pulizia',
        certification: 'Certificazione',
        icon: 'Icona',
        choose_icon: 'Scegli Icona',
        title_field: 'Titolo',
        description: 'Descrizione',
        status: 'Stato',
        active: 'Attivo',
        inactive: 'Inattivo',
        remove: 'Rimuovi',
        save: 'Salva',
        required_title: 'Il titolo è obbligatorio',
        required_icon: "L'icona è obbligatoria",
        required_fields: 'Campi obbligatori',
        required_fields_message: 'Per favore, compila tutti i campi obbligatori.',
        confirmation: 'Conferma',
        delete_security_measure_confirm:
          'Sei sicuro di voler eliminare questa misura di sicurezza?',
        delete_cleaning_protocol_confirm:
          'Sei sicuro di voler eliminare questo protocollo di pulizia?',
        delete_certification_confirm: 'Sei sicuro di voler eliminare questa certificazione?',
        yes: 'Sì',
        no: 'No',
        error: 'Errore',
        error_delete: "Errore nell'eliminare l'elemento.",
        success: 'Successo',
        success_save: 'Dati di igiene e sicurezza salvati con successo!',
        error_save: 'Si è verificato un errore durante il salvataggio dei dati.',
        empty_security_measures: 'Nessuna misura di sicurezza ancora aggiunta.',
        empty_cleaning_protocols: 'Nessun protocollo di pulizia ancora aggiunto.',
        empty_certifications: 'Nessuna certificazione ancora aggiunta.',
        empty_start_message: 'Clicca su "Aggiungi" per iniziare.',
        placeholder_security_title: 'Inserisci il titolo della misura di sicurezza',
        placeholder_protocol_title: 'Inserisci il titolo del protocollo',
        placeholder_certification_title: 'Inserisci il titolo della certificazione',
        placeholder_security_description: 'Inserisci una breve descrizione (massimo 100 caratteri)',
        placeholder_protocol_description:
          'Inserisci la descrizione dettagliata del protocollo di pulizia',
      },
      orders_room_service: {
        title: 'Ordini Camera',
        subtitle: "Gestione delle richieste di servizi dell'hotel",

        // Filtri
        status: 'Stato',
        start_date: 'Data Iniziale',
        end_date: 'Data Finale',
        reservation_id: 'Codice della Prenotazione',
        post_id: 'ID del Post',
        service_type: 'Tipo di Servizio',
        search: 'Cerca',
        clear_filters: 'Pulisci Filtri',

        // Stato
        status_pending: 'In sospeso',
        status_confirmed: 'Confermato',
        status_in_progress: 'In Corso',
        status_cancelled: 'Annullato',
        status_concluded: 'Completato',
        status_completed: 'Completato',

        // Opzioni di filtro
        all_status: 'Tutti gli stati',
        all_types: 'Tutti i tipi',
        service_forms: 'Moduli di Servizio',
        services: 'Servizi',

        // Intestazioni della tabella
        service: 'Servizio',
        room: 'Camera',
        price: 'Prezzo',
        people_qty: 'Numero di Persone',
        reservation: 'Prenotazione',
        date: 'Data',
        time: 'Orario',
        priority: 'Priorità',
        created_at: 'Creato il',
        actions: 'Azioni',

        // Azioni Tooltip
        view_details: 'Vedi Dettagli',
        change_status: 'Cambia Stato',

        // Modale Dettagli
        order_details: "Dettagli dell'Ordine",
        close: 'Chiudi',
        loading_details: "Caricamento dettagli dell'ordine...",
        loading: 'Caricamento...',

        // Informazioni sull'ordine
        order: 'Ordine',
        room_service: 'Servizio in Camera',
        location: 'Località',
        room_number: 'Numero della Camera',
        scheduled_date: 'Data Programmata',
        no_time: 'Senza orario',
        reservation_id_label: 'Codice della Prenotazione',

        // Informazioni sul cliente
        customer_info: 'Informazioni sul Cliente',
        full_name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Telefono',

        // Dettagli della richiesta
        request_summary: 'Riepilogo della Richiesta',
        service_details: 'Dettagli del Servizio',
        request_details: 'Dettagli della Richiesta',
        no_items_selected: 'Nessun elemento selezionato',
        not_informed: 'Non specificato',
        units: 'unità',

        // Informazioni tecniche
        technical_info: 'Informazioni Tecniche',
        post: 'Post',
        booking_type: 'Tipo di Prenotazione',
        hotel_info: 'Informazioni Hotel',
        hotel_name: 'Nome Hotel',
        subdomain: 'Sottodominio',
        type: 'Tipo',
        service_form: 'Modulo di Servizio',
        last_update: 'Ultimo Aggiornamento',
        additional_notes: 'Osservazioni Aggiuntive',

        // Modale di cambio stato
        change_status_title: 'Cambia Stato',
        current_status: 'Stato Attuale',
        new_status: 'Nuovo Stato',
        select_status: 'Seleziona uno stato',

        // Segnaposto
        select_status_placeholder: 'Seleziona lo stato',
        select_service_type_placeholder: 'Seleziona il tipo di servizio',
        start_date_placeholder: 'Data iniziale',
        end_date_placeholder: 'Data finale',
        reservation_id_placeholder: "Inserisci l'ID della prenotazione",
        post_id_placeholder: "Inserisci l'ID del post",
        new_status_placeholder: 'Seleziona il nuovo stato',

        // Messaggi di errore e successo
        error: 'Errore',
        success: 'Successo',
        warning: 'Attenzione',
        error_loading_orders: 'Errore nel caricare gli ordini!',
        error_loading_details: "Errore nel caricare i dettagli dell'ordine!",
        error_changing_status: "Errore nel cambiare lo stato dell'ordine!",
        success_status_changed: 'Stato cambiato con successo!',
        select_status_warning: 'Per favore, seleziona uno stato.',

        // Recensione del cliente
        customer_review: 'Recensione del Cliente',
        rating: 'Valutazione',
        review_comment: 'Commento',
      },
      s3Analytics: {
        title: 'Analytics S3',
        startDate: 'Data Iniziale',
        endDate: 'Data Finale',
        pluginspaceId: 'ID del Pluginspace',
        pluginspaceIdPlaceholder: "Inserisci l'ID del pluginspace",
        method: 'Metodo',
        methodPlaceholder: 'Inserisci il metodo (GET, POST, ecc.)',
        loadData: 'Carica Dati',
        generateAIAnalysis: 'Genera Analisi IA',
        chatWithAI: 'Parla con IA',
        showRanking: 'Mostra Classifica',
        analyzeWithAI: 'Analizza con IA',
        close: 'Chiudi',
        totalRequests: 'Totale Richieste',
        totalCost: 'Costo Totale',
        averageCostPerRequest: 'Costo Medio per Richiesta',
        consumptionByPluginspace: 'Consumo per Pluginspace',
        consumptionByMethod: 'Consumo per Metodo',
        consumptionByDate: 'Consumo per Data',
        costAnalysis: 'Analisi dei Costi',
        aiAnalysis: "Analisi dell'IA",
        chatMessage: 'Inserisci la tua domanda sui dati...',
        speakAnalysis: 'Ascolta Analisi',
        filterData: 'Filtra Dati',
        noDataFound: 'Nessun dato trovato per i filtri selezionati',
        errorLoadingData: 'Errore nel caricare i dati',
        errorGeneratingAnalysis: "Errore nel generare l'analisi dell'IA",
        analysisGenerated: 'Analisi generata con successo!',
        dataLoaded: 'Dati caricati con successo!',
        rankingData: 'Dati di Classifica',
        aiChatResponse: "Risposta dell'IA",
        s3Analytics: 'Analytics S3',
        filters: 'Filtri',
        totalConsumption: 'Consumo Totale',
        totalRecords: 'Totale Record',
        error: 'Errore',
        fetchError: 'Errore nel recuperare i dati S3',
        aiAnalysisError: "Errore nel generare l'analisi dell'IA",
        aiChatError: 'Errore nel parlare con IA',
        askQuestion: 'Inserisci la tua domanda sui dati...',
        ask: 'Chiedi',
        cancel: 'Annulla',
        ok: 'OK',
        aiResponse: "Risposta dell'IA",
        aiAnalysisTitle: "Analisi dell'IA",
        account: 'Account',
        pluginspace: 'Negozio',
        uniquePluginspaces: 'Negozi Unici',
        methodDistribution: 'Distribuzione per Metodo',
        timeAnalysis: 'Analisi Temporale',
        dataTable: 'Tabella Dati',
        showingFirst10: 'Mostrando i primi 10',
        of: 'di',
        records: 'record',
        consumption: 'Consumo',
        cost: 'Costo',
        date: 'Data',
        allMethods: 'Tutti i Metodi',
        exportData: 'Esporta Dati',
      },
      hospitality_store: {
        establishment: 'Stabilimento',
        select_establishment: 'Seleziona...',
        link: 'Link',
        status: 'Stato',
        payment_integrated: 'Pagamento Integrato',
        order: 'Ordine',
        store_image: 'Immagine del Negozio',
        store_image_hint: "Seleziona un'immagine rappresentativa del negozio",
        description: 'Descrizione',
        cnpj: 'Codice Fiscale',
        code: 'Codice',
        store_id_placeholder: 'ID del negozio',
        type: 'Tipo',
        store_type_placeholder: 'Tipo di stabilimento',
        no_store_found: 'Nessuno stabilimento trovato.',
        edit_store: 'Modifica Stabilimento',
        edit_store_subtitle: 'Modifica i dati dello stabilimento.',
      },
      stores_pages: {
        title: 'Stabilimenti',
        subtitle: "Qui sono elencati gli stabilimenti dell'hotel insieme alle rispettive azioni.",
        create: 'Crea Stabilimento',
        no_results: 'Nessuno stabilimento trovato.',
        table: {
          code: 'Codice',
          image: 'Immagine',
          name: 'Negozio',
          cnpj: 'Codice Fiscale',
          vinculation: 'Vinculazione',
          vinculation_default: 'Predefinito',
          vinculation_dynamic: 'Dinamico',
          type: 'Tipo',
          order: 'Ordine',
          status: 'Stato',
          status_active: 'Attivo',
          status_inactive: 'Inattivo',
          payment_integrated: 'Pagamento Integrato',
          actions: 'Azioni',
        },
        actions: {
          edit: 'Modifica Stabilimento',
          delete_confirm: 'Sei sicuro di voler eliminare?',
          delete: 'Elimina Stabilimento',
        },
        delete_success: 'Stabilimento eliminato con successo.',
        delete_error: "Errore nell'eliminare lo stabilimento. Per favore, riprova.",
        success: 'Successo!',
        error: 'Errore!',
      },
      stores_pages_create: {
        title: 'Crea Stabilimento',
        subtitle: "Crea un nuovo stabilimento per l'hotel.",
        form: {
          establishment: 'Stabilimento',
          select_placeholder: 'Seleziona...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Stato',
          status_options: {active: 'Attivo', inactive: 'Inattivo'},
          payment_integrated: 'Pagamento Integrato',
          payment_options: {active: 'Attivo', inactive: 'Inattivo'},
          order: 'Ordine',
          image_label: 'Immagine dello Stabilimento',
          image_smalltext: "Seleziona un'immagine rappresentativa dello stabilimento",
          description: 'Descrizione',
          info_title: 'Informazioni dello Stabilimento',
          cnpj: 'Codice Fiscale',
          code: 'Codice',
          type: 'Tipo',
          vinculation_label: 'Tipo di Vinculazione',
          vinculation_options: {default: 'Predefinito', dynamic: 'Dinamico'},
          empty_message: 'Nessuno stabilimento trovato.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID del negozio',
        },
        console_messages: {
          image_upload_error: 'Errore upload immagine',
        },
        messages: {
          warning_title: 'Attenzione',
          select_store_warning: 'Per favore, seleziona uno stabilimento valido prima di salvare.',
          error_saving:
            'Si è verificato un errore durante il salvataggio dello stabilimento. Per favore, riprova.',
          success_saved: 'Stabilimento salvato con successo.',
        },
      },
      feedback_reviews: {
        title: 'Recensioni di Ricerca e Soddisfazione',
        subtitle: 'Visualizza e gestisci tutte le valutazioni e le risposte dai moduli di feedback',
        breadcrumb_feedback: 'Feedback di Soddisfazione',
        error: 'Errore',
        success: 'Successo',
        loading: 'Caricamento...',
        loading_details: 'Caricamento dettagli recensione...',
        close: 'Chiudi',
        error_loading_reviews: 'Errore durante il caricamento delle recensioni',
        error_loading_details: 'Errore durante il caricamento dei dettagli della recensione',
        error_changing_status: 'Errore durante la modifica dello stato della recensione',
        success_status_changed: 'Stato modificato con successo',
        confirm_status_change: 'Conferma modifica stato',
        confirm_status_change_text: 'Sei sicuro di voler cambiare lo stato di questa recensione?',

        // Stato
        status_pending: 'In sospeso',
        status_approved: 'Approvato',
        status_rejected: 'Rifiutato',

        anonymous_active: 'Attivo',
        anonymous_inactive: 'Inattivo',

        // Filtri
        filters: {
          feedback_form: 'Modulo',
          status: 'Stato',
          anonymous: 'Anonimo',
          select_anonymous_placeholder: 'Tutti',
          rating: 'Valutazione',
          reservation_id: 'ID Prenotazione',
          start_date: 'Data Inizio',
          end_date: 'Data Fine',
          date: 'Data',
          all_forms: 'Tutti i Moduli',
          all_status: 'Tutti gli Stati',
          all_ratings: 'Tutte le Valutazioni',
          select_form_placeholder: 'Seleziona un modulo',
          select_status_placeholder: 'Seleziona uno stato',
          select_rating_placeholder: 'Seleziona una valutazione',
          reservation_id_placeholder: "Inserisci l'ID della prenotazione",
          start_date_placeholder: 'Seleziona la data di inizio',
          end_date_placeholder: 'Seleziona la data di fine',
          filter_button: 'Filtra',
          clear_filters: 'Cancella Filtri',
        },

        // Tabella
        table: {
          feedback_form: 'Modulo',
          customer: 'Cliente',
          room: 'Stanza',
          reservation: 'Prenotazione',
          rating: 'Valutazione',
          status: 'Stato',
          date: 'Data',
          time: 'Ora',
          actions: 'Azioni',
        },

        // Azioni
        actions: {
          view_details: 'Visualizza Dettagli',
          approve: 'Approva',
          reject: 'Rifiuta',
        },

        // Dettagli della Recensione
        review_details: 'Dettagli Recensione',
        room: 'Stanza',
        reservation: 'Prenotazione',
        feedback_form: 'Modulo',
        responses: 'Risposte',
        technical_info: 'Informazioni Tecniche',
        created_at: 'Creato il',
        updated_at: 'Aggiornato il',
        review_id: 'ID Recensione',
        plugin_space_id: 'ID Spazio Plugin',
        anonymous_response: 'Risposta Anonima',
        no_reservation_linked: 'Questa risposta non è collegata a una prenotazione specifica',
        no_detailed_responses: 'Nessuna risposta dettagliata disponibile per questa recensione',
        anonymous_label: 'Anonimo',
        email_anonymous: 'Email non disponibile (risposta anonima)',
        email_not_informed: 'Email non fornita',
        response_title: 'Titolo',
        no_rating_provided: 'Nessuna valutazione fornita',
        no_items_selected: 'Nessun elemento selezionato',
        no_option_selected: 'Nessuna opzione selezionata',
        no_answer_provided: 'Nessuna risposta fornita',
        form_label: 'Modulo:',
        client_not_identified: 'Cliente non identificato',
        types: {
          title: 'Titolo',
          text: 'Testo',
          textarea: 'Paragrafo',
          stars: 'Valutazione (stelle)',
          checkbox: 'Selezione (checkbox)',
          radio: 'Selezione (radio)',
          select: 'Selezione (lista)',
          number: 'Numero',
          date: 'Data',
          time: 'Ora',
          image: 'Immagine',
          link: 'Link',
        },
      },
      stores_pages_edit: {
        title: 'Modifica Stabilimento',
        subtitle: 'Modifica i dati dello stabilimento.',
        form: {
          establishment: 'Stabilimento',
          select_placeholder: 'Seleziona...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Stato',
          status_options: {active: 'Attivo', inactive: 'Inattivo'},
          payment_integrated: 'Pagamento Integrato',
          payment_options: {active: 'Attivo', inactive: 'Inattivo'},
          order: 'Ordine',
          image_label: 'Immagine dello Stabilimento',
          image_smalltext: "Seleziona un'immagine rappresentativa dello stabilimento",
          description: 'Descrizione',
          info_title: 'Informazioni dello Stabilimento',
          cnpj: 'Codice Fiscale',
          code: 'Codice',
          type: 'Tipo',
          vinculation_label: 'Tipo di Vinculazione',
          vinculation_options: {default: 'Predefinito', dynamic: 'Dinamico'},
          empty_message: 'Nessuno stabilimento trovato.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID del negozio',
        },
        console_messages: {
          image_upload_error: 'Errore upload immagine',
          image_remove_error: "Errore nel rimuovere l'immagine al salvataggio",
        },
        messages: {
          success_updated: 'Stabilimento aggiornato con successo.',
          error_updating:
            "Si è verificato un errore durante l'aggiornamento dello stabilimento. Per favore, riprova.",
          payment_change_warning_title: 'Attenzione',
          payment_change_warning_text:
            'Questa modifica può cambiare il valore delle prenotazioni in corso al momento del check-out.',
          payment_confirm: 'Sì, continua',
          cancel: 'Annulla',
        },
      },
      hospitality_section: {
        index: {
          page_title: 'Pagine di Pubblicazione',
          page_subtitle:
            'Qui sono elencate le pagine di pubblicazione di contenuto con le loro rispettive azioni.',
          add_button: 'Aggiungi Pagina di Pubblicazione',
          filters: {
            sections: 'Pagina di Pubblicazione',
          },
          table: {
            headers: {
              title: 'Titolo',
              order: 'Ordine',
              formTitle: 'Titolo del Modulo',
              type: 'Tipo',
              actions: 'Azioni',
            },
          },
          actions: {
            edit: 'Modifica Pagine di Pubblicazione',
            delete: 'Elimina Pagine di Pubblicazione',
          },
        },
        create: {
          page_title: 'Crea Pagine di Pubblicazione',
          page_subtitle: "Crea una nuova pagina di pubblicazione di contenuto per l'hotel.",
          add_button: 'Aggiungi Pagine di Pubblicazione',
          filters: {
            sections: 'Sezioni',
          },
        },
        edit: {
          page_title: 'Modifica Pagine di Pubblicazione',
          page_subtitle: 'Modifica i dati della pagina di pubblicazione di contenuto.',
        },
        // Traduzioni dinamiche per sezioni
        types: {
          category: 'Categoria',
          content: 'Contenuto',
          simple: 'Semplice',
          form: 'Modulo',
          page: 'Ristorante e negozio',
        },
        status: {
          active: 'Attivo',
          inactive: 'Inattivo',
        },
        actions: {
          create: 'Crea',
          edit: 'Modifica',
          delete: 'Elimina',
          save: 'Salva',
          cancel: 'Annulla',
          update: 'Aggiorna',
          remove_icon: 'Rimuovi Icona',
          select_icon: 'Seleziona Icona',
        },
        fields: {
          title: 'Titolo del Pulsante',
          type: 'Tipo di Pagina di Pubblicazione',
          category: 'Categoria',
          order: 'Ordine',
          status: 'Stato',
          icon: 'Icona',
          icon_selected: 'Icona Selezionata',
          icon_not_selected: 'Nessuna Icona Selezionata',
          icon_description: "Seleziona un icona dall'elenco laterale per la sezione",
          icon_change_description:
            "Seleziona un icona diversa dall'elenco laterale o rimuovi quella corrente",
        },
        placeholders: {
          title: 'Inserisci il titolo del pulsante',
          type: 'Seleziona il tipo',
          category: 'Seleziona una categoria',
          order: '0',
          search_icon: 'Cerca icona...',
          all_categories: 'Tutte le categorie',
        },
        warnings: {
          stores:
            'Nessun negozio di tipo Dinamico è stato trovato.\nPer continuare, vai su Impostazioni → Negozi e Strutture e configura un negozio di tipo Dinamico.',
        },
        messages: {
          validation: {
            title_required: 'Il titolo è obbligatorio!',
            category_required: 'Seleziona una categoria!',
            icon_required: 'Seleziona un icona!',
          },
          success: {
            created: 'Pagina di Pubblicazione creata con successo!',
            updated: 'Pagina di Pubblicazione aggiornata con successo!',
            deleted: 'Pagina di Pubblicazione eliminata con successo!',
          },
          error: {
            create: 'Errore nella creazione della Pagina di Pubblicazione!',
            update: "Errore nell'aggiornamento della Pagina di Pubblicazione!",
            delete: "Errore nell'eliminazione della Pagina di Pubblicazione!",
            load: 'Errore nel caricamento dei dati della Pagina di Pubblicazione!',
          },
          confirm: {
            delete_title: 'Sei sicuro?',
            delete_text: 'Questa azione non può essere annullata!',
            delete_confirm: 'Sì, elimina',
            delete_cancel: 'Annulla',
          },
          delete: {
            deleted_title: 'Pagine di Pubblicazione eliminate',
            deleted_text: 'Eliminazione effettuata con successo!',
            error_title: "Errore durante l'eliminazione delle Pagine di Pubblicazione!",
            error_text:
              "Si è verificato un errore durante l'eliminazione delle Pagine di Pubblicazione. Per favore, riprova.",
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: 'Categorie di Pubblicazione',
          page_subtitle:
            'Qui sono elencate le categorie di pubblicazione con le loro rispettive azioni.',
          add_button: 'Aggiungi Categoria di Pubblicazione',
          filter_all: 'Tutte',
          table: {
            headers: {
              title: 'Titolo',
              image: 'Immagine',
              summary: 'Riepilogo',
              status: 'Stato',
              classification: 'Classificazione',
              code: 'Codice',
              actions: 'Azioni',
            },
            actions: {
              edit: 'Modifica Categoria di Pubblicazione',
              delete: 'Elimina Categoria di Pubblicazione',
            },
          },
        },
        create: {
          page_title: 'Crea Categoria di Pubblicazione',
          page_subtitle: "Crea una nuova categoria di pubblicazione per l'hotel.",
          add_button: 'Aggiungi Categoria di Pubblicazione',
          success: {
            created_title: 'Categoria di Pubblicazione creata',
            created_text: 'Registrazione completata con successo!',
          },
          error: {
            created_title: 'Errore nella creazione della Categoria di Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la creazione della categoria. Per favore, riprova.',
          },
        },
        edit: {
          page_title: 'Modifica Categoria di Pubblicazione',
          page_subtitle: 'Modifica i dati della categoria di pubblicazione.',
          error: {
            created_title: 'Errore nella modifica della Categoria di Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la modifica della categoria. Per favore, riprova.',
          },
          success: {
            created_title: 'Categoria di Pubblicazione modificata',
            created_text: 'Registrazione aggiornata con successo!',
          },
        },
      },
      hospitality_post: {
        posts: 'Pubblicazioni',
        index: {
          page_title: 'Pubblicazioni',
          page_subtitle:
            "Qui sono elencate le pubblicazioni dell'hotel insieme alle loro rispettive azioni.",
          add_button: 'Aggiungi Pubblicazione',
          filter_all: 'Tutti',
          filter: 'Categorie',
          table: {
            headers: {
              title: 'Titolo',
              image: 'Immagine',
              summary: 'Riassunto',
              order: 'Ordine',
              status: 'Stato',
              classification: 'Classificazione',
              actions: 'Azioni',
            },
            actions: {
              edit: 'Modifica Pubblicazione',
              delete: 'Elimina Pubblicazione',
            },
          },
        },
        create: {
          page_title: 'Crea Pubblicazione',
          page_subtitle: "Crea una nuova pubblicazione per l'hotel.",
          success: {
            created_title: 'Pubblicazione creata',
            created_text: 'Registrazione completata con successo!',
          },
          error: {
            created_title: 'Errore nella creazione della Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la creazione della pubblicazione. Per favore, riprova.',
          },
        },
        edit: {
          page_title: 'Modifica Pubblicazione',
          page_subtitle: 'Modifica i dati della pubblicazione.',
          success: {
            created_title: 'Pubblicazione modificata',
            created_text: 'Registrazione completata con successo!',
          },
          error: {
            created_title: 'Errore nella modifica della Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la modifica della pubblicazione. Per favore, riprova.',
          },
        },
        form_validate: {
          title_required: 'Il titolo è obbligatorio!',
          summary_required: 'Il riassunto è obbligatorio!',
          classification_required: 'La classificazione è obbligatoria!',
          content_required: 'Il contenuto è obbligatorio!',
          fields_missing: 'Verifica di aver compilato tutti i campi!',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'Semplice',
          section: 'Sezione',
          form: 'Modulo',
          category: 'Categoria',
        },
        index: {
          page_title: 'Pagine di Pubblicazioni',
          page_subtitle:
            'Qui sono elencate le pagine di pubblicazione dei contenuti insieme alle loro rispettive azioni.',
          add_button: 'Aggiungi Pagina di Pubblicazione',
          edit_button: 'Modifica Pagina di Pubblicazione',
          delete_button: 'Elimina Pagina di Pubblicazione',
        },
        create: {
          page_title: 'Crea Pagina di Pubblicazione',
          page_subtitle: "Crea una nuova pagina di pubblicazione dei contenuti per l'hotel.",
          form: {
            title: 'Titolo della Pagina di Pubblicazione',
            type: 'Tipo di Pagina di Pubblicazione',
            status: 'Stato',
          },
          icon: {
            icon: 'Icona SVG',
            lib: 'Libreria di Icone SVG',
            search: 'Cerca icona...',
            category: 'Categoria Icona',
            description: "Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            selected: 'Icona Selezionata',
            no_selected: 'Nessuna Icona Selezionata',
            selected_description:
              "Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            no_selected_description:
              "Nessuna icona selezionata. Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            change_description:
              "Seleziona un'icona diversa dall'elenco a lato o rimuovi quella attuale",
          },
          success: {
            created_title: 'Pagina di Pubblicazione creata',
            created_text: 'Registrazione completata con successo!',
          },
          error: {
            created_title: 'Errore nella creazione della Pagina di Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la creazione della pagina. Per favore, riprova.',
          },
        },
        edit: {
          page_title: 'Modifica Pagina di Pubblicazione',
          page_subtitle: 'Modifica i dati della pagina di pubblicazione dei contenuti.',
          form: {
            title: 'Titolo della Pagina di Pubblicazione',
            type: 'Tipo di Pagina di Pubblicazione',
            status: 'Stato',
          },
          icon: {
            icon: 'Icona SVG',
            lib: 'Libreria di Icone SVG',
            search: 'Cerca icona...',
            category: 'Categoria Icona',
            description: "Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            selected: 'Icona Selezionata',
            no_selected: 'Nessuna Icona Selezionata',
            selected_description:
              "Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            no_selected_description:
              "Nessuna icona selezionata. Seleziona un'icona dall'elenco a lato per la pagina di pubblicazione",
            change_description:
              "Seleziona un'icona diversa dall'elenco a lato o rimuovi quella attuale",
          },
          success: {
            created_title: 'Pagina di Pubblicazione modificata',
            created_text: 'Modifica completata con successo!',
          },
          error: {
            created_title: 'Errore nella modifica della Pagina di Pubblicazione!',
            created_text:
              'Si è verificato un errore durante la modifica della pagina. Per favore, riprova.',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'Prenotazioni di Servizi',
        page_subtitle: 'Gestisci prenotazioni di servizi',
        breadcrumb_services: 'Servizi di Prenotazione',
        breadcrumb_booking: 'Servizi di Prenotazione',
        create_button: 'Crea Prenotazione di Servizio',

        // Table headers
        table_image: 'Immagine',
        table_title: 'Titolo',
        table_order: 'Ordine',
        table_status: 'Stato',
        table_actions: 'Azioni',

        // Table actions
        action_edit: 'Modifica',
        action_delete: 'Elimina',

        // Status
        status_active: 'Attivo',
        status_inactive: 'Inattivo',

        // Messages
        delete_success: 'Prenotazione eliminata',
        delete_error: "Errore nell'eliminazione della prenotazione",
        delete_confirm: "Confermare l'eliminazione?",

        // Create page
        create_title: 'Crea Prenotazione di Servizio',
        create_subtitle: 'Compila le informazioni per creare una nuova prenotazione di servizio',

        // Edit page
        edit_title: 'Modifica Prenotazione Hotel',
        edit_subtitle: 'Modifica informazioni della prenotazione',

        // Form fields
        field_title_label: 'Titolo',
        field_title_placeholder: 'Es.: Prenotazione Spa',
        field_status_label: 'Stato',
        field_description_label: 'Descrizione',
        field_image_label: 'Immagine',
        field_icon_label: 'Icona',

        // Icon picker
        icon_choose: 'Scegli Icona',
        icon_choose_modal: 'Scegli Icona',

        // Day configuration
        day_config_title: 'Configurazione Giorni',
        day_configure: 'Configura',
        day_periods_title: 'Periodi di Tempo',
        day_period_add: 'Aggiungi Periodo',
        day_period_max: 'Massimo 3 periodi',
        day_period_none: 'Nessun periodo configurato. Aggiungi almeno un periodo.',
        day_period_overlap: 'I periodi non possono sovrapporsi. Regola gli orari configurati.',
        day_period_label: 'Periodo',
        day_period_remove: 'Rimuovi',
        day_interval_label: 'Intervallo (min)',
        day_start_time_label: 'Orario Inizio',
        day_end_time_label: 'Orario Fine',

        // Day names
        day_sunday: 'Domenica',
        day_monday: 'Lunedì',
        day_tuesday: 'Martedì',
        day_wednesday: 'Mercoledì',
        day_thursday: 'Giovedì',
        day_friday: 'Venerdì',
        day_saturday: 'Sabato',

        // Grid selection
        grid_title: 'Griglie Collegate',
        grid_select: 'Seleziona Griglie',
        grid_selected: 'griglia(e) selezionata(e)',
        grid_capacity: 'Capacità',
        grid_multiple: 'Multiplo',
        grid_multiple_yes: 'Sì',
        grid_multiple_no: 'No',
        grid_status_active: 'Attivo',
        grid_status_inactive: 'Inattivo',

        // Action buttons
        button_back: 'Indietro',
        button_save: 'Salva',
        button_update: 'Aggiorna',
        button_create: 'Crea',
        button_cancel: 'Annulla',
        button_confirm: 'Conferma',

        // Validation messages
        validation_title_required: 'Campo obbligatorio',
        validation_title_text: 'Il titolo è obbligatorio.',
        validation_icon_required: 'Campo obbligatorio',
        validation_icon_text: "Seleziona un'icona.",
        validation_day_required: 'Configurazione richiesta',
        validation_day_text: 'Configura almeno un giorno della settimana.',

        // Success messages
        success_created: 'Prenotazione creata',
        success_created_text: 'La prenotazione è stata creata con successo!',
        success_updated: 'Prenotazione aggiornata',
        success_updated_text: 'La prenotazione è stata aggiornata con successo!',

        // Error messages
        error_create: 'Errore nella creazione',
        error_create_text: 'Si è verificato un errore durante la creazione della prenotazione.',
        error_update: "Errore nell'aggiornamento",
        error_update_text: "Si è verificato un errore durante l'aggiornamento della prenotazione.",
        error_save: 'Errore',
        error_save_text: 'Si è verificato un errore durante il salvataggio della prenotazione.',
        error_load: 'Errore',
        error_load_text: 'Errore nel caricamento dei dati della prenotazione.',

        // Breadcrumbs
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hospitality: 'Ospitalità',
        breadcrumb_hotel_reservations: 'Prenotazioni Hotel',
        breadcrumb_create: 'Crea',
        breadcrumb_edit: 'Modifica',
      },
      users: {
        houserkeeping: 'Addetto alle pulizie',
        maintenancetechnician: 'Tecnico di manutenzione',
        receptionist: 'Addetto alla reception',
        manager: 'Direttore',
        administrator: 'Amministratore',
        waiter: 'Cameriere',
        kitchenchief: 'Capo cuoco',
        warehouse: 'Responsabile del magazzino',
        concierge: 'Concierge',
        messenger: 'Messaggero',
        receptionsupervisor: 'Supervisore della Reception',
        telephonist: 'Centralinista',
        cook: 'Cuoco',
        barman: 'Barista',
        roomserviceattendant: 'Addetto al Servizio in Camera',
        steward: 'Steward',
        sommelier: 'Sommelier',
        plumber: 'Idraulico',
        airconditiontechnician: 'Tecnico di Climatizzazione',
        maintenancesupervisor: 'Supervisore della Manutenzione',
        reservationagent: 'Agente di Prenotazione',
        reservationcoordinator: 'Coordinatore delle Prenotazioni',
        salesexecutive: 'Responsabile Vendite',
        revenuemanager: 'Revenue Manager',
        commercialmanager: 'Direttore Commerciale',
        administrativeassistant: 'Assistente Amministrativo',
        financeaccountspayable: 'Finanza - Contabilità Fornitori',
        accountant: 'Contabile',
        humanresources: 'Risorse Umane',
        purchasingwarehouse: 'Acquisti e Magazzino',
        recreator: 'Animatore',
        activityinstructor: 'Istruttore di Attività',
        experiencecoordinator: 'Coordinatore delle Esperienze',
        tourguide: 'Guida Turistica',
        childmonitor: 'Educatore per Bambini',
        securityguard: 'Guardia di Sicurezza',
        doorman: 'Portiere',
        accesscontroller: 'Controllore Accessi',
        securitysupervisor: 'Supervisore della Sicurezza',
        generalmanager: 'Direttore Generale',
        assistantmanager: 'Vice Direttore',
        operationalmanager: 'Direttore Operativo',
        departmentsupervisorscoordinators: 'Supervisori e Coordinatori di Dipartimento',
        floormanager: 'Responsabile dei Piani',
        governancesupervisor: 'Supervisore delle Pulizie',
        generalservicesassistant: 'Assistente ai Servizi Generali',
        laundryattendant: 'Addetto alla Lavanderia',
        laundrymanager: 'Responsabile della Biancheria',
        machinist: 'Operatore di Macchine',
        ironer: 'Stiratore',
        electrician: 'Elettricista',
        carpenter: 'Falegname',
      },
    },
  },
}

export {messages}
// hospitality_experiences block moved inside translations below
